import { sanitizeHtml } from '../../utils/safeHtml';
import { paramsDaBusca, candidatosDaResposta, MIN_CARACTERES } from '../../utils/buscaDeChamados';
import { linkDoChamado } from '../../utils/linkDoChamado';
import { copiarTexto } from '../../utils/copiarTexto';
import React, { useCallback, useContext, useEffect, useMemo, useState, useRef } from 'react';
import { Box, Typography, IconButton, Tooltip, TextField, Button, Select, MenuItem, Divider, Skeleton, Switch, Tabs, Tab, Avatar, Dialog, DialogTitle, DialogContent, DialogActions, Rating, Autocomplete, Chip, ListSubheader, Popover, Collapse, RadioGroup, FormControlLabel, Radio, Checkbox, CircularProgress, alpha } from '@mui/material';
import { CloseSharp, AttachFile, InsertDriveFile, Image, Audiotrack, Add, ExpandMore, ExpandLess } from '@material-ui/icons';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import CheckOutlined from '@mui/icons-material/CheckOutlined';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { useParams, Prompt, useLocation } from 'react-router-dom';
import http from '../../services/http';
import { connect } from 'react-redux';
import { ThemeContext } from '../ThemeContext/ThemeContext';
import { editTicket, createTicket, setViewedTickets, fetchTickets } from '../../redux/ticket/ticket.actions';
import { getUsers } from '../../redux/user/user.actions';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
// Registra o blot de imagem que preserva style/width (item 4b) — precisa vir
// antes de qualquer editor ser montado.
import '../../utils/quillImageAttributes';
import QuillImageResizer from '../QuillImageResizer';
import { toast } from 'react-toastify';
import { quillAdjustTextWithGpt } from '../../utils/aiTextTools';
import { isReminderMacro, isQuillEmpty } from '../../utils/reminderMacro';
import MacroKeywordSuggest from '../MacroKeywordSuggest';
import {
    loadTicketCommentHtmlForQuillEditor,
    normalizeInlineImageParagraphs,
} from '../../utils/ticketCommentImages';
import TicketCommentHtml from '../TicketCommentHtml';
import { ticketCommentToHtml } from '../../utils/plainTextToHtml';
import { nomeInicialDoContato, telefoneInicialDoContato } from '../../utils/contatoDoChamado';
import { nomeDoDepartamento } from '../../utils/departamentoDoChamado';
import { linhaDoProduto } from '../../utils/linhaDoProduto';
import FaseDoRelacionamento, { useFasesDoRelacionamento } from '../FaseDoRelacionamento';
import ObservacaoDoCliente from '../ObservacaoDoCliente';
import { comAssinatura } from '../../utils/assinaturaNaAcao';
import ChatTranscript from '../ChatTranscript';
import VoiceTranscribeButton from '../VoiceTranscribeButton';
import { notifyNewTicketAssigned, notifyTicketUpdated } from '../../redux/notification/notification.actions';
import ClientSearch from '../ClientSearch';
import PresencaNoChamado from '../PresencaNoChamado';
import ChatTranscription from '../ChatTranscription';
import FilePreview from '../FilePreview';
import TicketAgendaPanel from '../TicketAgendaPanel';
import TicketAttendanceTimer from '../TicketAttendanceTimer';
import { flattenAttendanceForTimeline, formatAttendanceDuration } from '../../utils/formatAttendanceDuration';
import {
    applyMacroToTicketDraft,
    extractMacroMessageEffects,
} from '../../utils/applyMacroActionsToTicketData';
import discoveryIconWhite from '../../assets/icons/discovery_icon_white.png';
import discoveryIconBlack from '../../assets/icons/discovery_icon_black.png';
import StatusJustificationPicker from '../StatusJustificationPicker';
import ServicePicker from '../ServicePicker';
import { precisaPerguntarSeAssume } from '../../utils/assumirTicket';
import { dadosDoTicketCriado } from '../../utils/ticketCriado';
import { usePoliticaDeAnexos } from '../../services/politicaDeAnexos';
import { validarAnexo, aceitosNoSeletor } from '../../utils/validacaoDoAnexo';
import { impedimentoParaFinalizar, impedimentoAoFinalizar, REGRA_PADRAO } from '../../utils/classificacaoDoChamado';
import { idsFinalizados } from '../../utils/statusDoChamado';
import { faltaJustificativa, avisoDeJustificativa } from '../../utils/exigeJustificativa';

const SanitizeHTML = TicketCommentHtml;

function formatPortugueseList(items) {
    if (!items?.length) return '';
    if (items.length === 1) return items[0];
    if (items.length === 2) return `${items[0]} e ${items[1]}`;
    return `${items.slice(0, -1).join(', ')} e ${items[items.length - 1]}`;
}

// Valida apenas os campos de status do ticket: status obrigatorio e, quando o
// status exige justificativa (requires_justification), substatus obrigatorio.
function getTicketStatusValidation(data, ticketStatuses) {
    const missing = [];
    const statusId = data?.status_id;
    if (statusId == null || statusId === '') {
        missing.push('status');
    } else if (faltaJustificativa(ticketStatuses, statusId, data?.substatus_id)) {
        // A regra mora em `utils/exigeJustificativa` porque o PICKER também
        // precisa dela -- é ele que pede a justificativa na hora da escolha.
        // Duas cópias trariam de volta o defeito original: a tela barrando
        // algo que o campo não chegou a pedir.
        missing.push('justificativa');
    }
    return { missing, isInvalid: missing.length > 0 };
}

function buildRequiredFieldsMessage(missing) {
    const list = formatPortugueseList(missing);
    return missing.length === 1
        ? `Não é possível salvar. Preencha o campo ${list}.`
        : `Não é possível salvar. Preencha os campos obrigatórios: ${list}.`;
}

// Estado inicial de um ticket novo/em branco. Usado tanto ao entrar em
// /ticket/new quanto ao abrir OUTRO ticket novo por cima de um já iniciado,
// garantindo que cada novo ticket comece zerado (sem herdar o anterior).
function buildBlankTicketData(currentUserId) {
    return {
        title: '',
        status: 1,
        priority: 0,
        assigned_to: currentUserId ?? '',
        created_by: currentUserId || '',
        fields: [],
        is_internal: false,
        client: '',
        category: '',
        service_id: null,
        // O DEPARTAMENTO responsável pelo chamado (ponto 7 da Gisele):
        // classificação, para filtrar. Não é o responsável -- esse continua
        // sendo `assigned_to`, que é uma PESSOA.
        service_group_id: null,
        contact: '',
        channel: '',
        whatsapp_protocol: '',
        cc_users: [],
        cc_emails: [],
        solution_due_at: null,
    };
}

// Playbooks disponíveis no ticket (item 6). Hoje é um link externo (Lovable);
// no futuro virão da plataforma (criar/ativar/desativar). Só os `active` aparecem
// no dropdown "Playbook" ao lado de "Reutilizar anexos".
const PLAYBOOKS = [
    {
        id: 'atendimento',
        title: 'Playbook de Atendimento',
        url: 'https://easy-route-ops.lovable.app/playbook',
        active: true,
    },
];

// Status do cliente (item 4): a company guarda em `active` os estados S/N/C/T.
// Mapeia para rótulo + cor. Retorna null quando não informado (não mostra chip).
const getClientStatusInfo = (active, theme) => {
    switch (String(active || '').toUpperCase()) {
        case 'S': return { label: 'Ativo', color: theme.palette.success.main };
        case 'N': return { label: 'Inativo', color: theme.palette.text.secondary };
        case 'C': return { label: 'Cancelado', color: theme.palette.error.main };
        case 'T': return { label: 'Bloqueado', color: theme.palette.warning.main };
        default: return null;
    }
};

/**
 * O NUMERO do chamado, destacado do assunto.
 *
 * Ate 29/10/2026 cabecalho era uma string so -- `#6756 - Chat - Lead de
 * teste - 19/10/2026 22:08`. O numero e o que se dita no telefone, se cola no
 * WhatsApp e se procura na busca, e estava grudado num assunto que, em chamado
 * vindo do chat, ja comeca com data e hora: para copiar so o numero era
 * preciso selecionar letra a letra ate o hifen.
 *
 * Separado, ele tambem para de competir com o assunto pela reticencia: o que
 * corta quando falta largura passa a ser o assunto, e o numero fica inteiro.
 */
const ProtocoloDoChamado = ({ numero }) => (
    <Box
        component="span"
        data-testid="protocolo-do-chamado"
        sx={{
            flexShrink: 0,
            px: 0.875,
            py: 0.25,
            borderRadius: '8px',
            fontSize: '0.8rem',
            fontWeight: 700,
            letterSpacing: '0.01em',
            lineHeight: 1.6,
            color: 'primary.main',
            bgcolor: (t) => alpha(t.palette.primary.main, t.palette.mode === 'dark' ? 0.2 : 0.1),
            border: '1px solid',
            borderColor: (t) => alpha(t.palette.primary.main, t.palette.mode === 'dark' ? 0.4 : 0.25),
        }}
    >
        {`#${numero}`}
    </Box>
);

const TicketDetails = ({ ...props }) => {
    const { theme } = useContext(ThemeContext);

    /*
     * O limite de anexo e os tipos aceitos, vindos da api.
     *
     * Antes o "25MB" estava escrito a mao em QUATRO lugares deste arquivo
     * (duas mensagens de erro e dois tooltips), e os tipos em mais dois
     * (`accept=`). Com o limite configuravel por empresa, todos passariam a
     * mentir. O numero que a api devolve ja e o EFETIVO -- o menor entre o
     * configurado e o que o servidor web aceita.
     */
    const politicaDeAnexos = usePoliticaDeAnexos();

    /**
     * Separa os arquivos que podem ser enviados, avisando sobre cada recusa.
     *
     * Confere ANTES de enviar, que e o que nao acontecia: o arquivo subia
     * inteiro, o servidor recusava, e vinha uma frase so --
     * "Verifique os anexos (tamanho max. 25MB, tipos permitidos)" -- que nao
     * distinguia "grande demais" de "tipo recusado". Sao problemas
     * diferentes com solucoes diferentes.
     *
     * Aceita os validos em vez de recusar a selecao inteira: quem escolheu
     * cinco arquivos e errou em um nao deveria perder os outros quatro.
     */
    /**
     * A frase de recusa vinda do SERVIDOR (o front ja conferiu antes; esta
     * cobre o que so o servidor sabe).
     *
     * Era `"...tamanho max. 25MB, tipos permitidos"` escrita a mao em dois
     * lugares. O numero agora vem da politica, e some quando ela ainda nao
     * carregou -- melhor nao dizer numero nenhum do que dizer o errado.
     */
    const mensagemDeAnexoRecusado = () => (
        politicaDeAnexos
            ? `Verifique os anexos (tamanho máx. ${politicaDeAnexos.limiteMb} MB, tipos permitidos).`
            : 'Verifique os anexos (tamanho ou tipo não permitido).'
    );

    /** O tooltip do clipe, pelo mesmo motivo. */
    const tituloDoBotaoDeAnexo = () => (
        politicaDeAnexos
            ? `Anexar arquivo (máx. ${politicaDeAnexos.limiteMb} MB)`
            : 'Anexar arquivo'
    );

    const conferirAnexos = (arquivos) => {
        const aceitos = [];

        arquivos.forEach((arquivo) => {
            const { ok, motivo } = validarAnexo(arquivo, politicaDeAnexos);

            if (ok) {
                aceitos.push(arquivo);
            } else {
                toast.error(`${arquivo.name}: ${motivo}`);
            }
        });

        return aceitos;
    };
    const { id } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const isNewTicket = id === 'new';

    // Verificação de permissões (agora sempre array)
    const canViewInternalTickets = props.permissions?.includes('#view-internal-tickets') || false;
    const canViewInternalComments = props.permissions?.includes('#view-internal-comments') || false;
    const canViewFinancialInfo = props.permissions?.includes('#view-financial-info') || false;
    const canMergeTickets = Boolean(
        props.currentUser?.is_super_admin ||
        (Array.isArray(props.permissions) && props.permissions.includes('#mesclar-tickets'))
    );
    // Exclusão de ticket: permissão configurável (página de permissões).
    const canDeleteTicket = Boolean(
        Array.isArray(props.permissions) && props.permissions.includes('#excluir-tickets')
    );
    const formatCompanyPhone = (company) => {
        if (!company) return '';
        const area = company.area_code ? String(company.area_code).trim() : '';
        const phone = company.phone ? String(company.phone).trim() : '';
        if (!phone) return '';
        return area ? `(${area}) ${phone}` : phone;
    };

    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState('');
    // Envio de e-mail direto do ticket.
    const [emailDialogOpen, setEmailDialogOpen] = useState(false);
    const [emailForm, setEmailForm] = useState({ to: '', cc: '', subject: '', body: '' });
    const [sendingEmail, setSendingEmail] = useState(false);
    const [commentIsInternal, setCommentIsInternal] = useState(false);
    /*
     * Assinar a ação (3º bloco da Gisele). Decisão do dono do produto em
     * 14/10: AUTOMÁTICA, com opção de desligar -- então o padrão é marcado.
     *
     * O estado é por caixa de ação, e não por sessão: desmarcar vale para
     * aquela ação. Lembrar a escolha entre ações faria o operador descobrir
     * que não assinou dez ações depois.
     */
    const [incluirAssinatura, setIncluirAssinatura] = useState(true);
    const [commentAttachments, setCommentAttachments] = useState([]);
    // Reutilização de anexos já salvos em outras ações do ticket.
    const [reuseAttachModalOpen, setReuseAttachModalOpen] = useState(false);
    const [reuseSelectedPaths, setReuseSelectedPaths] = useState(() => new Set());
    const [editCommentAttachments, setEditCommentAttachments] = useState([]);
    // Caminhos (path) de anexos já salvos que o usuário marcou para remover ao editar a ação.
    const [editRemovedAttachmentPaths, setEditRemovedAttachmentPaths] = useState([]);
    const [gptAdjustingNewComment, setGptAdjustingNewComment] = useState(false);
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [editCommentDraft, setEditCommentDraft] = useState('');
    const [savingCommentEdit, setSavingCommentEdit] = useState(false);
    const [gptAdjustingComment, setGptAdjustingComment] = useState(false);

    const OrbyInlineIcon = ({ loading: isLoading }) => {
        if (isLoading) {
            return (
                <CircularProgress
                    size={18}
                    thickness={6}
                    sx={{
                        color: 'primary.main',
                        '@keyframes orbyPulse': {
                            '0%': { opacity: 0.45 },
                            '50%': { opacity: 1 },
                            '100%': { opacity: 0.45 },
                        },
                        animation: 'orbyPulse 1s ease-in-out infinite',
                    }}
                />
            );
        }
        return (
            <Box
                component="img"
                src={theme.palette.mode === 'dark' ? discoveryIconWhite : discoveryIconBlack}
                alt="Orby"
                sx={{ width: 18, height: 18, objectFit: 'contain' }}
            />
        );
    };

    const OrbyTypingOverlay = ({ show }) => {
        if (!show) return null;
        return (
            <Box
                sx={{
                    position: 'absolute',
                    right: 12,
                    bottom: 10,
                    zIndex: 6,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.75,
                    px: 1,
                    py: 0.5,
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                    pointerEvents: 'none',
                }}
            >
                <Box
                    component="img"
                    src={theme.palette.mode === 'dark' ? discoveryIconWhite : discoveryIconBlack}
                    alt=""
                    sx={{ width: 14, height: 14, objectFit: 'contain', opacity: 0.9 }}
                />
                <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1 }}>
                    digitando
                </Typography>
                <Box
                    sx={{
                        width: 6,
                        height: 16,
                        borderRadius: 1,
                        bgcolor: 'primary.main',
                        '@keyframes orbyCaretBlink': {
                            '0%': { opacity: 0.2 },
                            '50%': { opacity: 1 },
                            '100%': { opacity: 0.2 },
                        },
                        animation: 'orbyCaretBlink 900ms ease-in-out infinite',
                    }}
                />
            </Box>
        );
    };
    const fileInputRef = useRef(null);
    const newCommentQuillRef = useRef(null);
    const editCommentQuillRef = useRef(null);
    const editFileInputRef = useRef(null);

    // Insere o texto transcrito por voz no final do editor de ação.
    const insertTranscriptIntoComment = useCallback((text) => {
        if (!text) return;
        const editor = newCommentQuillRef.current?.getEditor?.();
        if (editor) {
            const len = editor.getLength(); // inclui o \n final
            const prefix = len > 1 ? ' ' : '';
            editor.insertText(Math.max(0, len - 1), prefix + text, 'user');
            editor.setSelection(len - 1 + prefix.length + text.length, 0);
        } else {
            setNewComment((prev) => (prev ? `${prev} ${text}` : text));
        }
    }, []);

    // Insere no editor de ação a resposta do Orby (botão "Inserir"). Confirma com um ack
    // para o Orby saber que havia um ticket aberto (senão ele copia como fallback).
    useEffect(() => {
        const handler = (e) => {
            const text = e?.detail?.text || '';
            if (!text) return;
            insertTranscriptIntoComment(text);
            window.dispatchEvent(new CustomEvent('orbyInsertTextAck'));
        };
        window.addEventListener('orbyInsertText', handler);
        return () => window.removeEventListener('orbyInsertText', handler);
    }, [insertTranscriptIntoComment]);
    const [previewFile, setPreviewFile] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [showAuditHistory, setShowAuditHistory] = useState(false);
    const [auditHistory, setAuditHistory] = useState([]);
    const [showTypeChangeModal, setShowTypeChangeModal] = useState(false);
    const [pendingTypeChange, setPendingTypeChange] = useState(null);
    // Modal de sucesso pós-criação (item 17). null = fechado; objeto = dados do ticket criado.
    const [createdTicketInfo, setCreatedTicketInfo] = useState(null);
    // Fechamento de chamado de OUTRO agente, esperando a pessoa decidir de
    // quem ele fica. `null` = sem pergunta aberta. Guarda a mudança pendente
    // nos dois formatos possíveis, porque são dois controles diferentes que
    // fecham o chamado -- ver `utils/assumirTicket`.
    const [assumirPendente, setAssumirPendente] = useState(null);
    const [pendingComments, setPendingComments] = useState([]);
    const [selectedClients, setSelectedClients] = useState([]);
    // As fases que o seletor do cartao oferece. Buscadas uma vez por sessao
    // (cache no proprio hook): o cartao repete o controle por cliente
    // vinculado, e sem o cache seriam N requisicoes para a mesma lista.
    const fasesDoRelacionamento = useFasesDoRelacionamento();
    const [contactOptions, setContactOptions] = useState([]);
    const [expandedClientIds, setExpandedClientIds] = useState({});
    // Grupos de clientes disponíveis. O grupo aplicado é derivado de
    // ticketData.client_group_id (por ticket), evitando vazamento entre tickets.
    const [clientGroups, setClientGroups] = useState([]);
    const [applyingGroup, setApplyingGroup] = useState(false);
    // Minimiza a lista de cards de clientes (mostra so o primeiro) quando ha varios.
    const [clientsCollapsed, setClientsCollapsed] = useState(false);
    // Telefones manuais da empresa (cadastro adicional pelo operador).
    const [phonesDialog, setPhonesDialog] = useState({ open: false, companyId: null });
    const [phonesDraft, setPhonesDraft] = useState([]);
    const [savingPhones, setSavingPhones] = useState(false);
    const [manualPhonesOverride, setManualPhonesOverride] = useState({});

    // Dropdown de playbooks (item 6) ao lado de "Reutilizar anexos".
    const [playbookAnchor, setPlaybookAnchor] = useState(null);

    // Cadastro rapido de contato (Client) atrelado a um registro do ticket.
    const [contactDialog, setContactDialog] = useState({ open: false });
    const [contactDraft, setContactDraft] = useState({ name: '', whatsapp: '', companyId: null });
    const [savingContact, setSavingContact] = useState(false);
    const [leftPanelWidth, setLeftPanelWidth] = useState(28); // largura % do painel de campos (lado esquerdo)
    const leftPanelMinWidth = 22;
    const leftPanelMaxWidth = 48;
    const [ticketData, setTicketData] = useState({
        title: '',
        status: 1,
        status_id: null,
        substatus_id: null,
        priority: 0,
        assigned_to: props.currentUser?.id ?? '',
        created_by: props.currentUser?.id || '',
        fields: [],
        is_internal: false,
        client: '',
        category: '',
        service_id: null,
        // O DEPARTAMENTO responsável pelo chamado (ponto 7 da Gisele):
        // classificação, para filtrar. Não é o responsável -- esse continua
        // sendo `assigned_to`, que é uma PESSOA.
        service_group_id: null,
        contact: '',
        channel: '',
        whatsapp_protocol: '',
        cc_users: [],
        cc_emails: [],
        solution_due_at: null
    });
    const [persistedStatus, setPersistedStatus] = useState(null);
    const [ticketStatuses, setTicketStatuses] = useState([]);
    // Começa no padrão para a tela já avisar certo antes de a requisição voltar.
    const [regraDeConclusao, setRegraDeConclusao] = useState(REGRA_PADRAO);
    const [services, setServices] = useState([]);
    // Os departamentos (grupos de atendimento) ATIVOS. Entraram para o campo
    // "Departamento responsável" e agora também servem à escolha pelo título
    // da seção, na lista de responsáveis.
    const [departamentos, setDepartamentos] = useState([]);
    // `id -> descrição`, da lista COMPLETA: é o que resolve o nome do
    // departamento gravado no chamado, inclusive de um já desativado.
    const [mapaDeDepartamentos, setMapaDeDepartamentos] = useState({});
    // Ver o `open` do Autocomplete de responsável.
    const [assigneeOpen, setAssigneeOpen] = useState(false);
    const [ticketCategories, setTicketCategories] = useState([]);
    const [macros, setMacros] = useState([]);
    const [messageMacroSelect, setMessageMacroSelect] = useState('');
    const [macroSelectFilter, setMacroSelectFilter] = useState('');
    const [mergeModalOpen, setMergeModalOpen] = useState(false);
    const [mergeCandidates, setMergeCandidates] = useState([]);
    // O temporizador da busca de chamados dos seletores de mesclar e de
    // relacionado -- um só, porque os dois modais não abrem juntos.
    const buscaDeChamadosRef = useRef(null);
    const [mergeTargetTicket, setMergeTargetTicket] = useState(null);
    const [mergePrimaryChoice, setMergePrimaryChoice] = useState('current');
    const [rememberMergeChoice, setRememberMergeChoice] = useState(false);
    const [mergeLoadingOptions, setMergeLoadingOptions] = useState(false);
    const [mergeSaving, setMergeSaving] = useState(false);
    const [ticketOptionsAnchorEl, setTicketOptionsAnchorEl] = useState(null);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deletingTicket, setDeletingTicket] = useState(false);
    const [relatedModalOpen, setRelatedModalOpen] = useState(false);
    const [creatingRelatedTicket, setCreatingRelatedTicket] = useState(false);
    const [relatedCopyMode, setRelatedCopyMode] = useState('all');
    const [relatedMode, setRelatedMode] = useState('create_new');
    const [relatedTargetTicket, setRelatedTargetTicket] = useState(null);
    const [relatedLinkDirection, setRelatedLinkDirection] = useState('current_as_child');
    const [relatedTicketOptions, setRelatedTicketOptions] = useState([]);
    const [relatedOptionsLoading, setRelatedOptionsLoading] = useState(false);
    const [relatedRegistroFilter, setRelatedRegistroFilter] = useState('');
    const [relationshipsLoading, setRelationshipsLoading] = useState(false);
    const [relationshipsData, setRelationshipsData] = useState({ parent: null, children: [] });
    const [relationshipsExpanded, setRelationshipsExpanded] = useState(true);
    const [isEditingSubject, setIsEditingSubject] = useState(false);
    const [subjectDraft, setSubjectDraft] = useState('');
    const [savingSubject, setSavingSubject] = useState(false);
    const [draftId, setDraftId] = useState(null);
    const [attendanceRefreshKey, setAttendanceRefreshKey] = useState(0);
    const [attendanceTimelineItems, setAttendanceTimelineItems] = useState([]);
    const { users, viewedTickets } = props;
    const history = props.history;
    const setViewedTickets = props.setViewedTickets;

    // Pode editar ticket e adicionar comentários: super admin, permissão #gerenciar-tickets ou ser o responsável/criador do ticket (após ticketData estar declarado)
    /**
     * O responsável do chamado quando ele NÃO está na lista de operadores.
     *
     * `GET /users` devolve só quem está ativo -- é o que faz um operador
     * desativado sumir dos seletores, que é o comportamento desejado. Mas o
     * Autocomplete procurava o responsável DENTRO dessa lista, então um
     * chamado atribuído a alguém desativado aparecia SEM responsável, como se
     * estivesse livre.
     *
     * Isso ficou grave com a importação do Movidesk: os agentes que já saíram
     * da empresa entram como usuários inativos, e são eles os responsáveis por
     * boa parte dos 262 mil chamados importados. Sem isto, o histórico inteiro
     * pareceria não ter dono.
     *
     * A API do ticket já manda o objeto completo (`{id, name, ...}`); só
     * precisamos guardá-lo antes de reduzir a coluna ao id.
     */
    const [responsavelForaDaLista, setResponsavelForaDaLista] = useState(null);

    /*
     * O AVISO DE OUTRO OPERADOR NO MESMO CHAMADO (Gisele, 23/10/2026).
     *
     * `ultimaAlteracaoEm` e o instante da minha ultima mudanca -- e o que
     * diz ao batimento se eu estou EDITANDO ou so lendo. As duas coisas
     * tem consequencias diferentes: ler junto nao e problema.
     *
     * `recarregarEm` e uma chave: muda-la faz o efeito que le o chamado
     * rodar de novo. E o que o botao "Atualizar Ticket" aciona -- sem ela,
     * recarregar exigiria duplicar aqui o efeito inteiro de leitura, que
     * trata permissao, chamado mesclado e rascunho.
     */
    const [ultimaAlteracaoEm, setUltimaAlteracaoEm] = useState(null);
    const [recarregarEm, setRecarregarEm] = useState(0);

    /**
     * Marca que EU estou mexendo no chamado agora.
     *
     * Fica numa funcao porque sao TRES caminhos: a mudanca de campo
     * (`handleInputChange`), o editor da acao nova e o editor da acao que
     * esta sendo corrigida. Os dois editores ligam direto no `setState`
     * deles, sem passar pelo caminho dos campos -- e foi exatamente por
     * isso que o aviso ficava azul com a outra pessoa digitando: o campo em
     * que todo mundo digita era o unico que nao contava.
     */
    const marcarQueEstouEditando = useCallback(() => setUltimaAlteracaoEm(Date.now()), []);

    const guardarResponsavelForaDaLista = (responsavel) => {
        if (responsavel && typeof responsavel === 'object' && responsavel.id) {
            setResponsavelForaDaLista(responsavel);
        }
    };

    /**
     * Os operadores oferecidos no seletor, mais o responsável atual do chamado
     * caso ele não esteja entre eles. Quem está inativo continua fora da lista
     * de escolha -- só não some da tela quando já é o responsável.
     */
    const operadoresParaOSeletor = (() => {
        const lista = users || [];
        const atual = responsavelForaDaLista;

        if (!atual || lista.some((u) => Number(u.id) === Number(atual.id))) {
            return lista;
        }

        return [...lista, atual];
    })();

    const assignedToId = ticketData?.assigned_to?.id ?? ticketData?.assigned_to;

    /*
     * QUEM PEDIU, quando quem pediu e um colaborador (Gisele, 23/10/2026).
     *
     * A coluna `requester` existe em `tickets` desde a migration original e a
     * api sempre a validou na criacao -- mas nenhuma tela mandava o campo, e
     * por isso ele nunca saiu do banco.
     *
     * A tela aceita tanto o ID quanto o objeto: a leitura individual devolve
     * `solicitante` (nome e foto) e o salvamento manda so o id.
     */
    const solicitanteId = ticketData?.requester?.id ?? ticketData?.requester ?? null;
    const solicitanteEscolhido = useMemo(() => {
        if (!solicitanteId) return null;

        return (users || []).find((u) => Number(u.id) === Number(solicitanteId))
            // O colaborador pode ter sido desativado depois de abrir o chamado.
            // Some do seletor, mas nao do chamado que ele pediu -- a mesma
            // regra do responsavel.
            || ticketData?.solicitante
            || null;
    }, [solicitanteId, users, ticketData?.solicitante]);
    const createdById = ticketData?.created_by?.id ?? ticketData?.created_by;
    const isResponsibleOrCreator = props.currentUser?.id != null && (
        Number(assignedToId) === Number(props.currentUser.id) ||
        (!assignedToId && Number(createdById) === Number(props.currentUser.id))
    );
    const canEditTicket = isNewTicket || props.currentUser?.is_super_admin ||
        (Array.isArray(props.permissions) && props.permissions.includes('#gerenciar-tickets')) ||
        isResponsibleOrCreator;

    const canEditAllTicketActions =
        Boolean(props.currentUser?.is_super_admin) ||
        (Array.isArray(props.permissions) && props.permissions.includes('#editar-todas-acoes-ticket'));

    const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());

    const getTicketStakeholderIds = useCallback((data) => {
        const ids = new Set();
        const assignId = data?.assigned_to?.id ?? data?.assigned_to;
        const creatorId = data?.created_by?.id ?? data?.created_by;
        if (assignId != null && assignId !== '') ids.add(Number(assignId));
        if (creatorId != null && creatorId !== '') ids.add(Number(creatorId));
        (data?.cc_users || []).forEach((uid) => {
            if (uid != null && uid !== '') ids.add(Number(uid));
        });
        const currentId = props.currentUser?.id;
        if (currentId != null) ids.delete(Number(currentId));
        return Array.from(ids).filter((id) => !Number.isNaN(id) && id > 0);
    }, [props.currentUser?.id]);

    const notifyTicketStakeholders = useCallback((data, changes = {}) => {
        if (!data?.id) return;
        const ids = getTicketStakeholderIds(data);
        if (!ids.length) return;
        props.notifyTicketUpdated(data.id, data.title, props.currentUser?.id, changes, ids);
    }, [getTicketStakeholderIds, props]);

    // Normaliza para objetos { name, phone, note } (compat com strings antigas
    // e com registros salvos antes do campo de observação existir).
    const normalizePhone = (p) => {
        if (p && typeof p === 'object') {
            return {
                name: String(p.name || '').trim(),
                phone: String(p.phone || '').trim(),
                note: String(p.note || '').trim(),
            };
        }
        return { name: '', phone: String(p || '').trim(), note: '' };
    };

    const getManualPhones = (company) => {
        if (!company) return [];
        const raw = Object.prototype.hasOwnProperty.call(manualPhonesOverride, company.id)
            ? (manualPhonesOverride[company.id] || [])
            : (Array.isArray(company.manual_phones) ? company.manual_phones : []);
        return raw.map(normalizePhone).filter((p) => p.phone);
    };

    // Clique na imagem de uma acao: abre no mesmo visualizador ja usado pelos
    // anexos. As imagens da timeline sao reescritas para blob: URL, formato que o
    // FilePreview nao reconhece como imagem — por isso busca o Blob de volta, que
    // carrega o MIME real e ainda permite o download.
    const handleCommentImageClick = async (src) => {
        try {
            const blob = await fetch(src).then((r) => r.blob());
            setPreviewFile(blob);
        } catch (_) {
            setPreviewFile(src);
        }
        setPreviewOpen(true);
    };

    const emptyPhone = () => ({ name: '', phone: '', note: '' });

    const updatePhoneDraft = (idx, patch) => {
        const base = phonesDraft.length ? phonesDraft : [emptyPhone()];
        const next = [...base];
        next[idx] = { ...next[idx], ...patch };
        setPhonesDraft(next);
    };

    const openPhonesDialog = (company) => {
        if (!company?.id) {
            toast.info('Empresa sem cadastro; não é possível adicionar telefones.');
            return;
        }
        const current = getManualPhones(company);
        setPhonesDraft(current.length ? current.map((p) => ({ ...p })) : [emptyPhone()]);
        setPhonesDialog({ open: true, companyId: company.id });
    };

    const savePhones = async () => {
        const companyId = phonesDialog.companyId;
        if (!companyId) return;
        const cleaned = (phonesDraft || [])
            .map((p) => ({
                name: String(p.name || '').trim(),
                phone: String(p.phone || '').trim(),
                note: String(p.note || '').trim(),
            }))
            .filter((p) => p.phone);
        try {
            setSavingPhones(true);
            const res = await http.put(`/companies/${companyId}/phones`, { manual_phones: cleaned });
            const saved = Array.isArray(res.data?.manual_phones) ? res.data.manual_phones.map(normalizePhone) : cleaned;
            setManualPhonesOverride((prev) => ({ ...prev, [companyId]: saved }));
            setPhonesDialog({ open: false, companyId: null });
            toast.success('Telefones atualizados.');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Erro ao salvar telefones.');
        } finally {
            setSavingPhones(false);
        }
    };

    // Registros (empresas) distintos atrelados ao ticket, a partir dos clientes
    // selecionados. Usado no cadastro rapido de contato para escolher a qual
    // registro o contato ficara vinculado (o seletor so aparece se houver > 1).
    const getTicketCompanies = () => {
        const seen = new Map();
        (selectedClients || []).forEach((cl) => {
            const co = cl.company || {};
            const cid = co.id || co.company_id || null;
            if (cid && !seen.has(cid)) {
                seen.set(cid, { id: cid, label: co.business_name || co.name || `Empresa ${cid}` });
            }
        });
        return Array.from(seen.values());
    };

    const openContactDialog = () => {
        const companies = getTicketCompanies();
        if (companies.length === 0) {
            toast.info('Selecione um cliente/registro antes de cadastrar um contato.');
            return;
        }
        setContactDraft({
            // Nome e telefone vão cada um para o SEU campo (ponto 14 da
            // Gisele, 20/10). O `contact` do chamado traz os dois juntos de
            // propósito desde 19/10 -- aqui eles se separam, porque o cadastro
            // tem coluna para cada. Ver src/utils/contatoDoChamado.js.
            name: nomeInicialDoContato(ticketData.contact),
            whatsapp: telefoneInicialDoContato(ticketData.contact),
            companyId: companies[0].id,
        });
        setContactDialog({ open: true });
    };

    const saveContact = async () => {
        const name = String(contactDraft.name || '').trim();
        const companyId = contactDraft.companyId;
        if (!name) {
            toast.error('Informe o nome do contato.');
            return;
        }
        if (!companyId) {
            toast.error('Selecione o registro.');
            return;
        }
        try {
            setSavingContact(true);
            const res = await http.post(`/companies/${companyId}/clients`, {
                name,
                whatsapp_user_number: String(contactDraft.whatsapp || '').trim() || null,
            });
            const created = res.data || {};
            const companyLabel =
                (getTicketCompanies().find((c) => String(c.id) === String(companyId)) || {}).label || 'Outros';
            // Adiciona a nova opcao ao autocomplete e ja seleciona o contato criado.
            setContactOptions((prev) => {
                const base = Array.isArray(prev) ? prev : [];
                return [
                    ...base,
                    {
                        type: 'contact',
                        id: `contact-${companyId}-${created.id || name}`,
                        companyId,
                        companyLabel,
                        label: created.name || name,
                        whatsapp: created.whatsapp_user_number || '',
                        phone: '',
                        area_code: '',
                    },
                ];
            });
            handleInputChange({ target: { name: 'contact', value: created.name || name } });
            setContactDialog({ open: false });
            toast.success('Contato cadastrado.');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Erro ao cadastrar contato.');
        } finally {
            setSavingContact(false);
        }
    };

    // Ação obrigatória ao abrir (item 17): falta ação quando é ticket novo e não há
    // ação adicionada (pendingComments) nem conteúdo no editor (texto, imagem
    // embutida ou anexo). Fonte única — usado na validação do salvar e na borda
    // vermelha do campo de ação. Regex inline (os helpers removeEmptyHtmlTags/
    // commentHtmlHasInlineImage são const definidos mais abaixo — TDZ aqui).
    const actionMissing = useMemo(() => {
        if (!isNewTicket) return false;
        const editorPlain = String(newComment || '').replace(/<[^>]+>/g, '').trim();
        const editorHasText = Boolean(editorPlain) || /<img\b/i.test(String(newComment || ''));
        return pendingComments.length === 0 && !editorHasText && commentAttachments.length === 0;
    }, [isNewTicket, newComment, pendingComments, commentAttachments]);

    const requiredSaveValidation = useMemo(() => {
        const missing = [];
        if (!String(ticketData?.title || '').trim()) {
            missing.push('título');
        }
        const assignRaw = ticketData?.assigned_to?.id ?? ticketData?.assigned_to;
        let assignOk = false;
        if (assignRaw != null && assignRaw !== '') {
            if (typeof assignRaw === 'number' && !Number.isNaN(assignRaw) && assignRaw > 0) {
                assignOk = true;
            } else if (typeof assignRaw === 'string') {
                if (!assignRaw.includes('default') && !assignRaw.includes('existing')) {
                    const n = Number(assignRaw);
                    assignOk = !Number.isNaN(n) && n > 0;
                }
            }
        }
        if (!assignOk) {
            missing.push('responsável');
        }
        /*
         * O CLIENTE deixa de ser exigido quando ha um colaborador como
         * solicitante (Gisele, 23/10/2026; decisao do dono do produto em
         * 26/10).
         *
         * O caso e o chamado interno entre departamentos: nao ha cliente
         * externo nenhum para escolher, e exigir um obrigava a apontar um
         * cliente de fachada -- que depois aparece nos relatorios dele.
         *
         * Um dos dois continua obrigatorio: chamado sem cliente E sem
         * solicitante nao responde "de quem e isto?".
         */
        if (!(selectedClients?.length > 0) && !solicitanteId) {
            missing.push('cliente ou solicitante');
        }
        // Campos obrigatórios na abertura: Serviço, Canal e Contato.
        const serviceIdRaw = ticketData?.service_id;
        const serviceOk = serviceIdRaw != null && serviceIdRaw !== '' && Number(serviceIdRaw) > 0;
        if (!serviceOk) {
            missing.push('serviço');
        }
        if (!String(ticketData?.channel || '').trim()) {
            missing.push('canal');
        }
        // Categoria entrou junto do Serviço (ponto 4 da Gisele, 16/10/2026):
        // classificar o chamado é trabalho da abertura, não de depois.
        if (!String(ticketData?.category || '').trim()) {
            missing.push('categoria');
        }
        if (!String(ticketData?.contact || '').trim()) {
            missing.push('contato');
        }
        // Item 17: a ação é obrigatória ao abrir o ticket (ver actionMissing).
        if (actionMissing) {
            missing.push('de ação');
        }
        missing.push(...getTicketStatusValidation(ticketData, ticketStatuses).missing);
        return { missing, isInvalid: missing.length > 0 };
        /*
         * `ticketData?.category` FALTAVA AQUI (Gisele, 23/10/2026).
         *
         * O corpo lê a categoria desde 16/10, e a lista de dependências não.
         * O resultado só se recalculava quando OUTRO campo mudava, e foi assim
         * que o aviso sumia: escolher a categoria junto de um serviço (que
         * também muda `service_id`) recalculava e limpava a pendência; apagar
         * a categoria depois não mexia em dependência nenhuma, então o memo
         * devolvia o cálculo velho -- "não falta nada" -- e o campo deixava de
         * ser obrigatório até a próxima mudança qualquer.
         *
         * `pendenciasDeAbertura.test.js` guarda a classe inteira: ele lê este
         * bloco e exige que todo `ticketData?.campo` lido esteja na lista.
         */
    }, [ticketData?.title, ticketData?.assigned_to, ticketData?.status_id, ticketData?.substatus_id, ticketData?.service_id, ticketData?.channel, ticketData?.category, ticketData?.contact, selectedClients, solicitanteId, ticketStatuses, actionMissing]);

    const editableTicketStatuses = useMemo(
        () => (ticketStatuses || []).filter((s) => s.name !== 'Resolvido' && s.name !== 'Cancelado'),
        [ticketStatuses]
    );

    const { getUsers } = props;

    useEffect(() => {
        getUsers();
    }, [getUsers]);

    useEffect(() => {
        http.get('/ticket-statuses').then((res) => {
            setTicketStatuses(Array.isArray(res.data) ? res.data : []);
        }).catch(() => setTicketStatuses([]));
    }, []);

    /*
     * Quais campos o chamado precisa ter para ser concluído (pontos 17 e 31).
     *
     * A falha cai no PADRÃO, e não em "não exige nada": o servidor é quem
     * garante a regra, então não avisar aqui só faria o operador levar um 422
     * sem explicação. Avisar a mais é o erro barato dos dois.
     *
     * ## Esta rota responde A MINHA regra (03/11/2026)
     *
     * Desde que a configuração passou a ser por perfil, `GET
     * /regra-de-conclusao` devolve a regra de QUEM PEDE -- a do perfil dele,
     * ou a da empresa. Esta tela não muda por causa disso, e é de propósito:
     * ela nunca precisou saber que existem outras.
     *
     * A tela de CONFIGURAÇÃO é que lê `/regra-de-conclusao/perfis`, que traz
     * todas. Trocar uma pela outra aqui mostraria ao operador a regra do
     * administrador que configurou.
     */
    useEffect(() => {
        http.get('/regra-de-conclusao')
            .then((res) => setRegraDeConclusao(res.data || REGRA_PADRAO))
            .catch(() => setRegraDeConclusao(REGRA_PADRAO));
    }, []);

    // Os departamentos para o campo "Departamento responsável" (ponto 7 da
    // Gisele). Só os ativos: departamento desativado não é opção nova -- mas o
    // chamado que já aponta para um deles continua mostrando o id, porque o
    // valor é histórico.
    useEffect(() => {
        http.get('/groups')
            .then((res) => {
                const lista = Array.isArray(res.data) ? res.data : [];
                setDepartamentos(lista.filter((g) => g && (g.status === true || g.status === 1)));
                /*
                 * O mapa sai da lista COMPLETA, e a filtrada continua servindo
                 * o seletor. Departamento desativado não é opção nova, mas o
                 * chamado que já aponta para um deles precisa mostrar o nome --
                 * resolver só pela lista ativa faria um chamado real parecer
                 * sem departamento.
                 */
                const mapa = {};
                lista.forEach((g) => {
                    if (g?.id != null) mapa[String(g.id)] = g.description || g.code || '';
                });
                setMapaDeDepartamentos(mapa);
            })
            .catch(() => { setDepartamentos([]); setMapaDeDepartamentos({}); });
    }, []);

    useEffect(() => {
        http.get('/services')
            .then((res) => {
                const next = Array.isArray(res.data) ? res.data : [];
                setServices(next);
            })
            .catch((err) => {
                setServices([]);
            });
        http.get('/ticket-categories').then((res) => setTicketCategories(Array.isArray(res.data) ? res.data : [])).catch(() => setTicketCategories([]));
    }, []);

    useEffect(() => {
        http.get('/macros?for_select=1').then((res) => setMacros(Array.isArray(res.data) ? res.data : [])).catch(() => setMacros([]));
    }, []);

    useEffect(() => {
        if (ticketData.is_internal) {
            setCommentIsInternal(true);
        }
    }, [ticketData.is_internal]);

    // Carregar grupos de clientes disponíveis (para seleção no campo Cliente)
    useEffect(() => {
        let active = true;
        http.get('/client-groups')
            .then(({ data }) => {
                if (active) setClientGroups(Array.isArray(data) ? data : []);
            })
            .catch(() => { /* opcional: grupos indisponíveis */ });
        return () => { active = false; };
    }, []);

    // Carregar ticket quando o ID mudar -- ou quando o "Atualizar Ticket"
    // pedir (ver `recarregarEm`).
    useEffect(() => {
        if (id && id !== 'new') {
            setLoading(true);
            http.get(`/ticket/${id}`)
                .then(response => {
                    const ticketDataFromAPI = response.data;

                    // Verificar permissões
                    if (ticketDataFromAPI.is_internal && !canViewInternalTickets) {
                        props.history.push('/chat');
                        toast.error('Você não tem permissão para visualizar tickets internos');
                        return;
                    }

                    // Ticket mesclado (item 7): o antigo não é mais editável nem
                    // aparece nas listas. Redireciona direto para o ticket principal
                    // onde ele foi mesclado, para o usuário não ficar preso num ticket
                    // "fantasma". Usa replace para o voltar não reabrir o mesclado
                    // (o que dispararia o redirect de novo). Cadeias (#52->#53->#54)
                    // se resolvem sozinhas: ao carregar o #53, se ele também estiver
                    // mesclado, redireciona de novo.
                    const mergedIntoId = ticketDataFromAPI.merged_into_ticket_id
                        || ticketDataFromAPI.mergedIntoTicket?.id
                        || ticketDataFromAPI.merged_into_ticket?.id;
                    if (mergedIntoId && Number(mergedIntoId) !== Number(ticketDataFromAPI.id)) {
                        // navega pelo id (a chave real), anuncia pelo numero
                        const mergedIntoNumber = ticketDataFromAPI.mergedIntoTicket?.number
                            ?? ticketDataFromAPI.merged_into_ticket?.number
                            ?? null;
                        toast.info(mergedIntoNumber
                            ? `Ticket #${ticketDataFromAPI.number} foi mesclado no #${mergedIntoNumber}. Redirecionando…`
                            : `Ticket #${ticketDataFromAPI.number} foi mesclado em outro ticket. Redirecionando…`);
                        props.history.replace(`/ticket/${mergedIntoId}`);
                        return;
                    }

                    guardarResponsavelForaDaLista(ticketDataFromAPI.assigned_to);

                    const ticketWithCorrectAssignedTo = {
                        ...ticketDataFromAPI,
                        assigned_to: ticketDataFromAPI.assigned_to?.id || ticketDataFromAPI.assigned_to || '',
                        cc_users: ticketDataFromAPI.cc_users || [],
                        cc_emails: ticketDataFromAPI.cc_emails || [],
                        status_id: ticketDataFromAPI.status_id ?? ticketDataFromAPI.ticket_status?.id ?? null,
                        substatus_id: ticketDataFromAPI.substatus_id ?? ticketDataFromAPI.ticket_substatus?.id ?? null,
                        service_id: ticketDataFromAPI.service_id ?? ticketDataFromAPI.service?.id ?? null
                    };
                    setTicketData(ticketWithCorrectAssignedTo);
                    setPersistedStatus(Number(ticketDataFromAPI.status));
                    setCommentIsInternal(ticketDataFromAPI.is_internal);
                    setAttendanceRefreshKey((k) => k + 1);

                    try {
                        const tid = ticketDataFromAPI.id;
                        if (tid != null) {
                            const exists = props.viewedTickets.some((t) => Number(t.id) === Number(tid));
                            if (!exists) {
                                const limitReached = localStorage.getItem('quickAccessLimitReached') === 'true';
                                if (!limitReached) {
                                    props.setViewedTickets([
                                        ...props.viewedTickets,
                                        {
                                            id: tid,
                                            // sem o numero aqui, a aba do acesso
                                            // rapido ficaria sem protocolo
                                            number: ticketDataFromAPI.number,
                                            title: ticketDataFromAPI.title || 'Sem título',
                                        },
                                    ]);
                                }
                            }
                        }
                    } catch {}

                    // Carregar clientes vinculados ao ticket
                    const ticketClientsFromApi = Array.isArray(ticketDataFromAPI.ticket_clients)
                        ? ticketDataFromAPI.ticket_clients
                        : [];

                    if (ticketClientsFromApi.length > 0) {
                        const normalizedClients = ticketClientsFromApi.map((tc, index) => {
                            const clientFromRelation = tc.client || ticketDataFromAPI.client || {};
                            const companyFromRelation = tc.company || ticketDataFromAPI.company || {};
                            return {
                                ...clientFromRelation,
                                id: clientFromRelation.id ?? tc.client_id,
                                company: {
                                    ...companyFromRelation,
                                    id: companyFromRelation.id ?? tc.company_id,
                                },
                            };
                        });
                        setSelectedClients(normalizedClients);
                    } else if (ticketDataFromAPI.client && ticketDataFromAPI.company) {
                        // Dados já vêm com relacionamentos carregados do backend (cliente único)
                        setSelectedClients([{
                            ...ticketDataFromAPI.client,
                            company: ticketDataFromAPI.company
                        }]);
                    } else if (ticketDataFromAPI.company_id) {
                        // Fallback: buscar dados da empresa se não vierem carregados
                        http.get(`/companies/${ticketDataFromAPI.company_id}`)
                            .then((companyResponse) => {
                                const companyData = Array.isArray(companyResponse.data)
                                    ? companyResponse.data[0]
                                    : companyResponse.data;

                                if (companyData) {
                                    // Descobrir o ID correto da empresa para reuso nas buscas
                                    const companyIdForSearch = companyData.id ?? companyData.company_id ?? ticketDataFromAPI.company_id;

                                    // Garantir que o objeto company tenha o id correto
                                    const normalizedCompanyData = {
                                        ...companyData,
                                        id: companyIdForSearch,
                                    };

                                    // Buscar clientes da empresa (API retorna data: { company, clients })
                                    http.get(`/client-search/company/${companyIdForSearch}`)
                                        .then(response => {
                                            const data = response.data?.data;
                                            const clientsFromCompany = Array.isArray(data?.clients)
                                                ? data.clients
                                                : (Array.isArray(data) && data[0]?.clients ? data[0].clients : []);
                                            const firstClient = clientsFromCompany[0];

                                            if (firstClient) {
                                                setSelectedClients([{
                                                    ...firstClient,
                                                    company: {
                                                        ...normalizedCompanyData,
                                                        clients: clientsFromCompany
                                                    }
                                                }]);
                                            } else {
                                                setSelectedClients([{
                                                    id: 'existing_client',
                                                    name: ticketDataFromAPI.client || 'Cliente',
                                                    company: normalizedCompanyData
                                                }]);
                                            }
                                        })
                                        .catch(() => {
                                            // Fallback: criar objeto básico
                                            setSelectedClients([{
                                                id: 'existing_client',
                                                name: ticketDataFromAPI.client || 'Cliente',
                                                company: companyData
                                            }]);
                                        });
                                }
                            })
                            .catch(error => {
                                console.error('Erro ao carregar dados do cliente:', error);
                                // Fallback para dados básicos se houver apenas o nome do cliente
                                if (ticketDataFromAPI.client) {
                                    setSelectedClients([{
                                        id: 'existing_client',
                                        name: ticketDataFromAPI.client,
                                        company: {
                                            business_name: ticketDataFromAPI.client,
                                            name: ticketDataFromAPI.client
                                        }
                                    }]);
                                }
                            });
                    } else if (ticketDataFromAPI.client) {
                        // Fallback para dados básicos se não houver IDs
                        setSelectedClients([{
                            id: 'existing_client',
                            name: ticketDataFromAPI.client,
                            company: {
                                business_name: ticketDataFromAPI.client,
                                name: ticketDataFromAPI.client
                            }
                        }]);
                    }
                })
                .catch(error => {
                    console.error('Erro ao carregar ticket:', error);
                    toast.error('Erro ao carregar ticket');
                    props.history.push('/ticket');
                })
                .finally(() => {
                    setLoading(false);
                });
        } else if (id === 'new') {
            // Reset para novo ticket
            setTicketData(buildBlankTicketData(props.currentUser?.id));
            setSelectedClients([]);
            setPendingComments([]);
            setNewComment('');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, canViewInternalTickets, props.currentUser?.id, props.history, recarregarEm]);

    const buildDraftStorageKey = (draft) => `ticketDraft:${draft}`;
    const buildDraftDiscardedKey = (draft) => `ticketDraftDiscarded:${draft}`;
    // Rascunho da caixa de ação por ticket existente (isolado entre tickets).
    const buildActionDraftKey = (ticketId) => `ticketActionDraft:${ticketId}`;

    const generateDraftId = () => {
        const rand = Math.random().toString(36).slice(2, 10);
        return `${Date.now().toString(36)}-${rand}`;
    };

    useEffect(() => {
        if (!isNewTicket) return;
        const params = new URLSearchParams(location.search || '');
        const fromUrl = params.get('draft');
        const effectiveDraftId = fromUrl || generateDraftId();

        try {
            const discarded = localStorage.getItem(buildDraftDiscardedKey(effectiveDraftId)) === '1';
            if (discarded) {
                let closeInProgress = false;
                try {
                    const raw = sessionStorage.getItem('quickAccessDraftClose');
                    const parsed = raw ? JSON.parse(raw) : null;
                    const sameDraft = parsed?.draftId && String(parsed.draftId) === String(effectiveDraftId);
                    const fresh = parsed?.ts && (Date.now() - Number(parsed.ts)) < 2500;
                    closeInProgress = Boolean(sameDraft && fresh);
                } catch {}
                if (!closeInProgress) {
                    history.replace('/');
                }
                return;
            }
        } catch {}

        setDraftId(effectiveDraftId);
        if (!fromUrl) {
            // Rascunho novo (abrir outro ticket por cima de um já iniciado):
            // zera o formulário para não herdar os dados do ticket anterior.
            setTicketData(buildBlankTicketData(props.currentUser?.id));
            setSelectedClients([]);
            setPendingComments([]);
            setNewComment('');
            params.set('draft', effectiveDraftId);
            history.replace(`/ticket/new?${params.toString()}`);
        }
        try {
            const stored = localStorage.getItem(buildDraftStorageKey(effectiveDraftId));
            if (stored) {
                const parsed = JSON.parse(stored);
                if (parsed?.ticketData) setTicketData((prev) => ({ ...prev, ...parsed.ticketData }));
                if (Array.isArray(parsed?.selectedClients)) setSelectedClients(parsed.selectedClients);
                if (Array.isArray(parsed?.pendingComments)) setPendingComments(parsed.pendingComments);
                if (typeof parsed?.newComment === 'string') setNewComment(parsed.newComment);
            }
        } catch {}

        try {
            const exists = (viewedTickets || []).some((t) => t?.isDraft && t?.draftId === effectiveDraftId);
            if (!exists) {
                const discarded = localStorage.getItem(buildDraftDiscardedKey(effectiveDraftId)) === '1';
                if (discarded) return;
                const limitReached = localStorage.getItem('quickAccessLimitReached') === 'true';
                if (!limitReached) {
                    setViewedTickets([
                        ...(viewedTickets || []),
                        { id: `draft-${String(effectiveDraftId).slice(0, 8)}`, title: '', isDraft: true, draftId: effectiveDraftId },
                    ]);
                }
            }
        } catch {}
    }, [isNewTicket, location.search, history, setViewedTickets, viewedTickets]);

    useEffect(() => {
        if (!isNewTicket || !draftId) return;
        try {
            const payload = {
                ticketData,
                selectedClients,
                pendingComments,
                newComment,
            };
            localStorage.setItem(buildDraftStorageKey(draftId), JSON.stringify(payload));
        } catch {}
    }, [isNewTicket, draftId, ticketData, selectedClients, pendingComments, newComment]);

    // Checklist/lembrete padrão do ticket novo (item 15). NÃO é injetado na caixa
    // de ação — ela fica VAZIA (o técnico escreve a ação de verdade). É exibido no
    // lugar do skeleton da timeline de ações, como guia. O texto vem da macro
    // reservada "Lembrete padrão", editável pelo admin no cadastro de macros.
    const reminderChecklistHtml = useMemo(() => {
        if (!isNewTicket || !macros.length) return '';
        const macro = macros.find(isReminderMacro);
        if (!macro) return '';
        const { messageBody } = extractMacroMessageEffects(macro.actions, ticketData);
        return (messageBody && !isQuillEmpty(messageBody)) ? messageBody : '';
    }, [isNewTicket, macros, ticketData]);

    // Cada ticket tem sua própria caixa de ação: ao trocar de ticket, carrega o
    // rascunho daquele ticket (ou limpa), evitando que o texto vaze entre tickets.
    const actionDraftIdRef = useRef(null);
    useEffect(() => {
        if (isNewTicket || !id) {
            actionDraftIdRef.current = null;
            return;
        }
        let stored = '';
        try {
            stored = localStorage.getItem(buildActionDraftKey(id)) || '';
        } catch {}
        // Marca este id como "ainda não reconciliado" para o efeito de persistência
        // não gravar o texto do ticket anterior na chave do novo.
        actionDraftIdRef.current = null;
        setNewComment(stored);
        // Anexos são File objects (não serializáveis); reseta para não vazar entre tickets.
        setCommentAttachments([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, isNewTicket]);

    // Persiste o rascunho da ação no ticket atual a cada edição. Só grava quando
    // o newComment já corresponde a este ticket (evita corromper na troca).
    useEffect(() => {
        if (isNewTicket || !id) return;
        if (actionDraftIdRef.current !== id) {
            // Primeira passada após carregar este ticket: apenas marca como ativo.
            actionDraftIdRef.current = id;
            return;
        }
        try {
            if (newComment && removeEmptyHtmlTags(newComment)?.trim()) {
                localStorage.setItem(buildActionDraftKey(id), newComment);
            } else {
                localStorage.removeItem(buildActionDraftKey(id));
            }
        } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, isNewTicket, newComment]);



    useEffect(() => {
        if (ticketData && ticketData.id) {
            http.get(`/ticket/${ticketData.id}/comments`)
                .then(response => setComments(response.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))))
                .catch(error => console.error(error));
        }
    }, [ticketData]);

    // Responde ao Orby (botão "Usar este ticket") com um resumo do ticket + timeline.
    useEffect(() => {
        const handler = () => {
            try {
                const strip = (s) => String(s || '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
                const tid = ticketData?.number;
                const title = ticketData?.title || '(sem título)';
                const statusName = (ticketStatuses || []).find(s => Number(s.id) === Number(ticketData?.status_id))?.name;
                const c0 = Array.isArray(selectedClients) ? selectedClients[0] : null;
                const company = c0?.company;
                const clientName = c0?.name || ticketData?.client || '';
                const companyName = company?.business_name || company?.name || '';
                const code = company?.code || '';
                const head = [
                    `Ticket #${tid} - ${title}`,
                    statusName ? `Status: ${statusName}` : null,
                    (clientName || companyName) ? `Cliente: ${clientName}${companyName ? ` / ${companyName}` : ''}${code ? ` (cód. ${code})` : ''}` : null,
                    ticketData?.contact ? `Contato: ${ticketData.contact}` : null,
                    '',
                    'Histórico de ações (mais recente primeiro):',
                ].filter(l => l !== null);
                const acts = (Array.isArray(comments) ? comments : []).slice(0, 15).map((c) => {
                    const when = c.created_at ? new Date(c.created_at).toLocaleString('pt-BR') : '';
                    const who = c.user?.name || c.user_name || 'Sistema';
                    const kind = c.is_internal ? '[interna]' : '[pública]';
                    return `- ${when} ${kind} ${who}: ${strip(c.comment).slice(0, 400)}`;
                });
                const text = [...head, ...acts].join('\n');
                window.dispatchEvent(new CustomEvent('orbyContextResponse', { detail: { label: `Ticket #${tid}`, text } }));
            } catch (e) {
                window.dispatchEvent(new CustomEvent('orbyContextResponse', { detail: {} }));
            }
        };
        window.addEventListener('orbyRequestContext', handler);
        return () => window.removeEventListener('orbyRequestContext', handler);
    }, [ticketData, comments, selectedClients, ticketStatuses]);

    const fetchTicketRelationships = useCallback(() => {
        const ticketId = ticketData?.id;
        if (!ticketId || isNewTicket) return Promise.resolve();
        setRelationshipsLoading(true);
        return http.get(`/ticket/${ticketId}/relationships`)
            .then((res) => {
                const data = res?.data || {};
                setRelationshipsData({
                    parent: data.parent || null,
                    children: Array.isArray(data.children) ? data.children : [],
                });
            })
            .catch(() => {
                setRelationshipsData({ parent: null, children: [] });
            })
            .finally(() => setRelationshipsLoading(false));
    }, [ticketData?.id, isNewTicket]);

    useEffect(() => {
        fetchTicketRelationships();
    }, [fetchTicketRelationships]);

    // Buscar histórico de auditoria e tempo de atendimento quando checkbox for ativado
    useEffect(() => {
        if (!showAuditHistory || !ticketData?.id) {
            setAttendanceTimelineItems([]);
            return;
        }
        http.get(`/ticket/${ticketData.id}/audit-history`)
            .then((response) => setAuditHistory(response.data))
            .catch((error) => console.error(error));
        http.get(`/ticket/${ticketData.id}/attendance`)
            .then((response) => setAttendanceTimelineItems(flattenAttendanceForTimeline(response.data)))
            .catch(() => setAttendanceTimelineItems([]));
    }, [showAuditHistory, ticketData?.id, attendanceRefreshKey]);

    useEffect(() => {
        if (!selectedClients?.length) {
            setContactOptions([]);
            return;
        }

        let cancelled = false;

        const buildOptionsFromClients = (clientsArray) => {
            const options = [];

            (clientsArray || []).forEach((client) => {
                const company = client.company || {};
                const companyId = company.id || company.company_id || null;
                const companyLabel = String(company.business_name || company.name || '').trim();

                if (companyLabel) {
                    const existsCompany = options.some(
                        (opt) => typeof opt === 'object' && opt.type === 'company' && opt.companyId === companyId && opt.label === companyLabel
                    );
                    if (!existsCompany) {
                        options.push({
                            type: 'company',
                            id: `company-${companyId || companyLabel}`,
                            companyId,
                            companyLabel,
                            label: companyLabel,
                        });
                    }
                }

                const companyClients = company.clients;
                if (Array.isArray(companyClients)) {
                    companyClients.forEach((c) => {
                        const contactLabel = String(c.name || c.contact_name || c.contact || '').trim();
                        if (!contactLabel) return;

                        const existsContact = options.some(
                            (opt) =>
                                typeof opt === 'object' &&
                                opt.type === 'contact' &&
                                opt.companyId === companyId &&
                                opt.label === contactLabel
                        );
                        if (!existsContact) {
                            options.push({
                                type: 'contact',
                                id: `contact-${companyId || companyLabel}-${c.id || contactLabel}`,
                                companyId,
                                companyLabel,
                                label: contactLabel,
                                whatsapp: c.whatsapp_user_number || '',
                                phone: c.phone || '',
                                area_code: c.area_code || '',
                            });
                        }
                    });
                }
            });

            setContactOptions(options);
        };

        const toFetch = selectedClients.filter(
            (c) => c.company?.id && (!c.company.clients || c.company.clients.length === 0)
        );

        // Se todas as empresas já têm clients carregados, só monta as opções
        if (toFetch.length === 0) {
            buildOptionsFromClients(selectedClients);
            return;
        }

        // API retorna { success, data: { company, clients } } — não array
        const parseClientsFromCompanyResponse = (data) => {
            if (!data?.success || !data.data) return [];
            const d = data.data;
            if (Array.isArray(d?.clients)) return d.clients;
            if (Array.isArray(d) && d[0]?.clients) return d[0].clients;
            return [];
        };

        const fetchCompanyClients = async (companyId) => {
            try {
                const res = await http.get(`/client-search/company/${companyId}`);
                if (cancelled) return null;
                return parseClientsFromCompanyResponse(res.data);
            } catch (_) {
                return [];
            }
        };

        Promise.all(toFetch.map((c) => fetchCompanyClients(c.company.id))).then((results) => {
            if (cancelled) return;
            let updated = false;
            const next = selectedClients.map((client) => {
                const idx = toFetch.findIndex((f) => f.company?.id === client.company?.id);
                if (idx === -1 || !results[idx]?.length) return client;
                updated = true;
                return { ...client, company: { ...client.company, clients: results[idx] } };
            });
            if (updated) {
                setSelectedClients(next);
                buildOptionsFromClients(next);
            } else {
                buildOptionsFromClients(selectedClients);
            }
        });

        return () => { cancelled = true; };
    }, [selectedClients, id]);

    const selectedContactMeta = useMemo(() => {
        const current = String(ticketData.contact || '').trim();
        if (!current) return null;
        const list = Array.isArray(contactOptions) ? contactOptions : [];
        const exact = list.find((opt) => typeof opt === 'object' && opt.type === 'contact' && opt.label === current);
        if (!exact) return null;
        return exact;
    }, [ticketData.contact, contactOptions]);

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).replace(", ", " ");
    };

    // Função para formatar endereço de forma sucinta (sem repetir "Rua", "Bairro", etc.)
    const formatAddress = (company) => {
        if (!company) return '-';

        const parts = [];

        if (company.address) {
            // Remove prefixos comuns como "Rua", "Avenida", etc.
            const address = company.address
                .replace(/^(Rua|Av|Avenida|Rod|Rodovia|Al|Alameda|Trav|Travessa|Pça|Praça|Est|Estrada)\s+/i, '')
                .trim();
            if (address) {
                parts.push(address);
            }
        }

        if (company.number) {
            parts.push(`nº ${company.number}`);
        }

        if (company.district) {
            parts.push(company.district);
        }

        if (company.city && company.state) {
            parts.push(`${company.city}/${company.state}`);
        } else if (company.city) {
            parts.push(company.city);
        } else if (company.state) {
            parts.push(company.state);
        }

        if (company.zip_code) {
            parts.push(`CEP: ${company.zip_code}`);
        }

        return parts.length > 0 ? parts.join(', ') : '-';
    };

    // Função para obter comentários filtrados
    const getFilteredComments = () => {
        return comments.filter(comment => {
            if (!canViewInternalComments) {
                return !comment.is_internal;
            }
            return true;
        });
    };

    const latestVisibleCommentId = useMemo(() => {
        if (!comments.length) return null;
        const sorted = [...comments].sort((a, b) => {
            const t = new Date(b.created_at) - new Date(a.created_at);
            if (t !== 0) return t;
            return Number(b.id) - Number(a.id);
        });
        return sorted[0]?.id ?? null;
    }, [comments]);

    // Função para obter histórico de auditoria formatado
    const getFormattedAuditHistory = () => {
        return auditHistory.map(audit => ({
            id: `audit_${audit.id}`,
            type: 'audit',
            created_at: audit.created_at,
            action_type: audit.action_type,
            action_description: audit.action_description,
            old_values: audit.old_values,
            new_values: audit.new_values,
            metadata: audit.metadata,
            users: audit.users || []
        }));
    };

    // Função para combinar comentários e histórico de auditoria
    const getCombinedTimeline = () => {
        const commentItems = getFilteredComments().map(comment => ({
            id: `comment_${comment.id}`,
            commentId: comment.id,
            type: 'comment',
            created_at: comment.created_at,
            updated_at: comment.updated_at,
            comment: comment.comment,
            is_internal: comment.is_internal,
            user: comment.user,
            attachments: comment.attachments || null
        }));

        const pendingItems = isNewTicket ? pendingComments.map((p, idx) => ({
            id: `pending_${idx}`,
            type: 'comment',
            created_at: p.created_at,
            comment: p.comment,
            is_internal: p.is_internal,
            user: props.currentUser,
            attachments: p.attachments || null
        })) : [];

        const allCommentItems = [...commentItems, ...pendingItems];

        if (!showAuditHistory) {
            return allCommentItems.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        }

        const auditItems = getFormattedAuditHistory();

        const combined = [...auditItems, ...attendanceTimelineItems, ...allCommentItems]
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        return combined;
    };


    const removeEmptyHtmlTags = (html) => {
        return html.replace(/<p><br><\/p>/g, '').trim();
    };

    const commentHtmlHasInlineImage = (html) => /<img\b/i.test(String(html || ''));

    const buildCommentFormData = (comment, isInternal, files, removePaths = []) => {
        const form = new FormData();
        form.append('comment', comment);
        form.append('is_internal', isInternal ? '1' : '0');
        (removePaths || []).forEach((path) => {
            if (path) form.append('remove_attachments[]', path);
        });
        let reuseIdx = 0;
        (files || []).forEach((f) => {
            if (!f) return;
            if (f.__reused) {
                // Anexo reaproveitado de outra ação do ticket (referência, sem re-upload).
                form.append(`reuse_attachments[${reuseIdx}][path]`, f.path);
                form.append(`reuse_attachments[${reuseIdx}][original_name]`, f.original_name || '');
                reuseIdx += 1;
            } else {
                form.append('attachments[]', f);
            }
        });
        return form;
    };

    // Anexos já salvos nas ações deste ticket (deduplicados por caminho).
    const existingTicketAttachments = useMemo(() => {
        const seen = new Set();
        const list = [];
        (comments || []).forEach((c) => {
            let atts = c.attachments;
            if (typeof atts === 'string') {
                try { atts = JSON.parse(atts); } catch { atts = []; }
            }
            if (!Array.isArray(atts)) return;
            atts.forEach((a) => {
                if (a && a.path && !seen.has(a.path)) {
                    seen.add(a.path);
                    list.push({ path: a.path, original_name: a.original_name || String(a.path).split('/').pop() });
                }
            });
        });
        return list;
    }, [comments]);

    const openReuseAttachModal = () => {
        const current = new Set(commentAttachments.filter((a) => a?.__reused).map((a) => a.path));
        setReuseSelectedPaths(current);
        setReuseAttachModalOpen(true);
    };

    const toggleReusePath = (path) => {
        setReuseSelectedPaths((prev) => {
            const next = new Set(prev);
            if (next.has(path)) next.delete(path); else next.add(path);
            return next;
        });
    };

    const confirmReuseAttachments = () => {
        setCommentAttachments((prev) => {
            const files = prev.filter((a) => !a?.__reused);
            const chosen = existingTicketAttachments
                .filter((a) => reuseSelectedPaths.has(a.path))
                .map((a) => ({ __reused: true, path: a.path, original_name: a.original_name }));
            return [...files, ...chosen];
        });
        setReuseAttachModalOpen(false);
    };

    const readFileAsDataUrl = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });

    const collectClipboardImageFiles = (clipboardData) => {
        if (!clipboardData) return [];
        const fromFiles = clipboardData.files?.length ? Array.from(clipboardData.files) : [];
        const imageFiles = fromFiles.filter((f) => f.type?.startsWith('image/'));
        if (imageFiles.length) return imageFiles;

        const fromItems = [];
        if (clipboardData.items?.length) {
            for (const item of clipboardData.items) {
                if (item.type?.startsWith('image/')) {
                    const file = item.getAsFile();
                    if (file) fromItems.push(file);
                }
            }
        }
        return fromItems;
    };

    const insertImageFilesInline = async (imageFiles, quillRef, onHtmlChange) => {
        const quill = quillRef.current?.getEditor?.();
        if (!quill || !imageFiles.length) return 0;

        const range = quill.getSelection(true);
        let index = range ? range.index : Math.max(0, quill.getLength() - 1);
        let inserted = 0;

        for (const file of imageFiles) {
            try {
                const dataUrl = await readFileAsDataUrl(file);
                quill.insertEmbed(index, 'image', dataUrl, 'user');
                index += 1;
                inserted += 1;
            } catch (_) {
                toast.error('Não foi possível inserir a imagem colada.', { position: toast.POSITION.BOTTOM_CENTER });
            }
        }

        if (inserted > 0) {
            quill.setSelection(index, 0, 'user');
            onHtmlChange?.(quill.root.innerHTML);
        }

        return inserted;
    };

    const handleCommentPasteCapture = (e, { quillRef, setHtml, onNonImageFiles }) => {
        const clipboardData = e.clipboardData;
        const imageFiles = collectClipboardImageFiles(clipboardData);
        const allFiles = clipboardData?.files?.length ? Array.from(clipboardData.files) : [];
        const nonImages = allFiles.filter((f) => !f.type?.startsWith('image/'));
        if (!imageFiles.length && !nonImages.length) return;
        e.preventDefault();
        e.stopPropagation();
        if (nonImages.length && onNonImageFiles) {
            onNonImageFiles(nonImages);
            toast.success(`${nonImages.length} arquivo(s) anexado(s).`, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        }
        if (imageFiles.length) {
            insertImageFilesInline(imageFiles, quillRef, setHtml).then((inserted) => {
                if (inserted > 0) {
                    toast.success(
                        inserted === 1 ? 'Imagem inserida na ação.' : `${inserted} imagens inseridas na ação.`,
                        { position: toast.POSITION.BOTTOM_CENTER, autoClose: 2500 }
                    );
                }
            });
        }
    };

    const openCommentForEdit = async (item) => {
        setEditingCommentId(item.commentId);
        setEditCommentAttachments([]);
        setEditRemovedAttachmentPaths([]);
        setEditCommentDraft('');
        // A mesma conversao da exibicao: o Quill tambem monta o conteudo por
        // innerHTML, entao uma acao importada do Movidesk abriria no editor
        // como um paragrafo corrido -- e salvar dali gravaria o paragrafo
        // corrido de volta, agora como HTML, perdendo as quebras de vez.
        const normalized = normalizeInlineImageParagraphs(ticketCommentToHtml(item.comment || ''));
        try {
            const html = await loadTicketCommentHtmlForQuillEditor(normalized);
            setEditCommentDraft(html);
        } catch (_) {
            setEditCommentDraft(normalized);
        }
    };

    const parseCcSelection = (newValue) => {
        const ccUserIds = [];
        const ccEmails = [];
        const seenEmails = new Set();
        newValue.forEach((item) => {
            if (typeof item === 'string') {
                const email = item.trim().toLowerCase();
                if (isValidEmail(email) && !seenEmails.has(email)) {
                    ccEmails.push(email);
                    seenEmails.add(email);
                }
                return;
            }
            if (item?.isEmail && item.email) {
                const email = item.email.trim().toLowerCase();
                if (isValidEmail(email) && !seenEmails.has(email)) {
                    ccEmails.push(email);
                    seenEmails.add(email);
                }
                return;
            }
            if (item?.id) {
                ccUserIds.push(item.id);
                if (item.email) seenEmails.add(item.email.trim().toLowerCase());
            }
        });
        return { ccUserIds, ccEmails };
    };

    const ccAutocompleteValue = useMemo(() => {
        const userOpts = (users || []).filter((u) => (ticketData.cc_users || []).includes(u.id));
        const emailOpts = (ticketData.cc_emails || []).map((email) => ({
            email,
            isEmail: true,
            name: email,
        }));
        return [...userOpts, ...emailOpts];
    }, [users, ticketData.cc_users, ticketData.cc_emails]);

    const isEmailLike = (v) => typeof v === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

    // Tenta descobrir o e-mail do cliente/contato para pré-preencher o destinatário.
    const guessTicketEmail = () => {
        if (isEmailLike(ticketData?.contact)) return ticketData.contact.trim();
        for (const c of selectedClients || []) {
            if (isEmailLike(c?.email)) return c.email.trim();
            const co = c?.company;
            if (isEmailLike(co?.email)) return co.email.trim();
            const list = Array.isArray(co?.clients) ? co.clients : [];
            const withEmail = list.find((x) => isEmailLike(x?.email));
            if (withEmail) return withEmail.email.trim();
        }
        return '';
    };

    const openEmailDialog = () => {
        if (!canEditTicket) {
            toast.error('Você não tem permissão para enviar e-mails neste ticket.');
            return;
        }
        const ccList = Array.isArray(ticketData?.cc_emails) ? ticketData.cc_emails.filter(Boolean) : [];
        setEmailForm({
            to: guessTicketEmail(),
            cc: ccList.join(', '),
            subject: `Ticket #${ticketData?.number}: ${ticketData?.title || ''}`.trim(),
            body: '',
        });
        setEmailDialogOpen(true);
    };

    const handleSendEmail = async () => {
        const to = String(emailForm.to || '').trim();
        if (!isEmailLike(to)) {
            toast.warn('Informe um e-mail de destinatário válido.');
            return;
        }
        const bodyClean = removeEmptyHtmlTags(emailForm.body);
        if (!bodyClean || !bodyClean.trim()) {
            toast.warn('Escreva o conteúdo do e-mail.');
            return;
        }
        const cc = String(emailForm.cc || '')
            .split(/[\s,;]+/)
            .map((e) => e.trim())
            .filter((e) => isEmailLike(e));
        setSendingEmail(true);
        try {
            const res = await http.post(`/ticket/${ticketData?.id || id}/send-email`, {
                to,
                cc,
                subject: String(emailForm.subject || '').trim(),
                body: emailForm.body,
            });
            if (res?.data) {
                setComments((prev) => [...prev, res.data].sort((a, b) => new Date(b.created_at) - new Date(a.created_at)));
            }
            setEmailDialogOpen(false);
            toast.success('E-mail enviado.');
        } catch (e) {
            const msg = e?.response?.data?.errors?.email?.[0] || e?.response?.data?.message || 'Não foi possível enviar o e-mail.';
            toast.error(msg);
        } finally {
            setSendingEmail(false);
        }
    };

    const handleAddComment = () => {
        if (!isNewTicket && !canEditTicket) {
            toast.error('Você não tem permissão para adicionar ações neste ticket. Apenas o responsável ou perfis com permissão para gerenciar tickets podem fazê-lo.', {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            return;
        }
        const cleanedComment = removeEmptyHtmlTags(newComment);
        const hasAttachments = commentAttachments.length > 0;
        const hasInlineImage = commentHtmlHasInlineImage(cleanedComment);
        const statusNum = Number(ticketData.status);
        const resolvedOrCancelledIds = (ticketStatuses || []).filter((s) => s.name === 'Resolvido' || s.name === 'Cancelado').map((s) => s.id);
        const isResolvidoOrCancelledByStatusId = ticketData.status_id && resolvedOrCancelledIds.includes(ticketData.status_id);
        const requiresCommentForStatus = (statusNum === 3 || statusNum === 4) || isResolvidoOrCancelledByStatusId;
        const plainText = cleanedComment?.replace(/<[^>]+>/g, '')?.trim() ?? '';

        /*
         * O QUE FALTA CLASSIFICAR É CONFERIDO ANTES DE GRAVAR A AÇÃO.
         *
         * Relato (Gisele, 28/10): "o encerramento apaga a ação já preenchida
         * quando há campo obrigatório vazio -- perde o que o operador
         * digitou".
         *
         * Fechar pelo "Fechar ticket..." não grava nada sozinho: ele só marca
         * o status na tela, e quem fecha de verdade é este botão, que grava a
         * ação E o status. Só que a ordem era: POST da ação -> `editTicket` ->
         * o servidor recusa por falta de serviço/categoria. A ação já tinha
         * sido gravada e a caixa já tinha sido esvaziada, então o chamado
         * continuava aberto e o motivo que ele escreveu virava uma ação
         * solta. Para tentar de novo, tinha de escrever tudo outra vez --
         * porque fechar EXIGE motivo no comentário, e o comentário já tinha
         * ido embora.
         *
         * A guarda já existia no outro caminho de gravação
         * (`persistTicketChanges`), mas ESTE caminho não passava por ela. É a
         * mesma regra, do mesmo lugar: quem garante continua sendo o servidor
         * (`ClassificacaoParaFinalizar`), e aqui ela só evita consumir o que
         * o operador escreveu.
         *
         * Vem ANTES do "informe o motivo" de propósito: se faltam os dois,
         * pedir o motivo primeiro faria ele escrever um texto que seria
         * recusado em seguida.
         */
        const faltaClassificarParaFechar = impedimentoAoFinalizar(
            ticketData,
            requiresCommentForStatus,
            regraDeConclusao
        );
        if (faltaClassificarParaFechar.length > 0) {
            toast.error(
                `Não é possível finalizar o chamado sem ${faltaClassificarParaFechar.join(' e ')}. A ação continua aqui.`,
                { position: toast.POSITION.BOTTOM_CENTER }
            );
            return;
        }

        if (requiresCommentForStatus && !plainText) {
            toast.warning('Para Resolvido ou Cancelado, informe o motivo no comentário.', {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            return;
        }
        if (!cleanedComment && !hasAttachments && !hasInlineImage) return;

        const isInternal = canViewInternalComments ? commentIsInternal : ticketData.is_internal;
        /*
         * A assinatura entra AQUI, e não no editor (3º bloco da Gisele).
         *
         * ## Por que depois das validações, e não antes
         *
         * As duas guardas acima -- "ação vazia não salva" e "Resolvido exige
         * motivo" -- medem o que o operador ESCREVEU. Assinando antes delas,
         * uma ação só com a assinatura passaria como preenchida, e daria para
         * resolver um chamado sem dizer nada.
         *
         * ## Por que não dentro do Quill
         *
         * Era o caminho óbvio, "como e-mail": a assinatura aparece na caixa e
         * o operador ajusta. Mas o Quill reconstrói o HTML a partir do modelo
         * dele e descarta atributo que não conhece -- inclusive o
         * `data-assinatura` que marca o bloco. Sem o marcador, salvar duas
         * vezes assina duas vezes, e desmarcar não acha o que remover.
         *
         * Então a assinatura vive FORA do editor: a caixa de seleção e a
         * prévia ficam embaixo dele, o operador vê exatamente o que vai sair,
         * e o texto dele nunca é tocado.
         *
         * ## Por que isto não assina duas vezes
         *
         * Não é pelo marcador `data-assinatura` -- medido em 14/10, a api o
         * REMOVE ao gravar. São duas propriedades do desenho: a assinatura sai
         * do `cleanedComment` (o editor, que nunca a contém), e EDITAR uma ação
         * existente passa por `handleSaveCommentEdit`, que não assina. Se algum
         * dia o caminho de edição começar a assinar, isto precisa de um guard
         * de verdade -- e o marcador não serve, porque não volta do banco.
         */
        const commentText = incluirAssinatura
            // A imagem (Gisele, 19/10) vai junto do texto: são os dois pedaços
            // da mesma assinatura, e a caixa de seleção liga ou desliga os
            // dois de uma vez.
            ? comAssinatura(cleanedComment || '', props.currentUser?.assinatura, props.currentUser?.assinatura_imagem)
            : (cleanedComment || '');

        if (isNewTicket) {
            setPendingComments(prev => [...prev, {
                comment: commentText,
                is_internal: isInternal,
                created_at: new Date().toISOString(),
                attachments: hasAttachments ? [...commentAttachments] : null
            }]);
            setNewComment('');
            setCommentAttachments([]);
            toast.success('Ação salva. Será enviada ao criar o ticket.', {
                position: toast.POSITION.BOTTOM_CENTER,
                style: {
                    backgroundColor: theme.palette.background.toast,
                    color: theme.palette.success.contrastText,
                },
            });
            return;
        }

        const ticketId = ticketData?.id || (id && id !== 'new' ? id : null);
        if (!ticketId) {
            toast.info('Comentários estarão disponíveis após criar o ticket', {
                position: toast.POSITION.BOTTOM_CENTER,
                style: {
                    backgroundColor: theme.palette.background.toast,
                    color: theme.palette.info.contrastText,
                },
            });
            return;
        }

        const hasFiles = commentAttachments.length > 0;
        const payload = hasFiles
            ? buildCommentFormData(commentText, isInternal, commentAttachments)
            : { comment: commentText, is_internal: isInternal };

        http.post(`/ticket/${ticketId}/comments`, payload)
            .then(response => {
                setComments([...comments, response.data].sort((a, b) => new Date(b.created_at) - new Date(a.created_at)));
                setAttendanceRefreshKey((k) => k + 1);
                notifyTicketStakeholders(ticketData, { comment: 'Nova ação registrada' });
                const statusNum = Number(ticketData.status);
                if (statusNum === 3 || statusNum === 4) {
                    const payloadToSave = buildTicketPayloadForApi({ ...ticketData, id: ticketId });
                    props.editTicket(payloadToSave).then(() => {
                        setPersistedStatus(statusNum);
                    }).catch(() => {});
                }
                /*
                 * A caixa só se esvazia DEPOIS que o servidor aceitou.
                 *
                 * Relatado pela Gisele em 20/10 (ponto 17): a ação que ela já
                 * tinha digitado sumiu. Isto limpava fora da promessa, antes de
                 * saber se o POST deu certo -- e o rascunho ia junto: o efeito
                 * que grava `ticketActionDraft:<id>` apaga a chave quando o
                 * editor fica vazio. Falha do servidor, anexo recusado ou queda
                 * de rede levavam o texto dos DOIS lugares, e o operador via um
                 * toast de erro com a caixa limpa.
                 */
                setNewComment('');
                setCommentAttachments([]);
            })
            .catch(error => {
                console.error(error);
                toast.error(error.response?.data?.errors ? mensagemDeAnexoRecusado() : 'Erro ao adicionar ação.');
            });
    };

    const handleSaveCommentEdit = () => {
        if (!ticketData?.id || editingCommentId == null) return;
        const edited = comments.find((c) => Number(c.id) === Number(editingCommentId));
        const isOwnComment =
            edited?.user?.id != null &&
            props.currentUser?.id != null &&
            Number(edited.user.id) === Number(props.currentUser.id);
        const isLatestComment =
            edited?.id != null &&
            latestVisibleCommentId != null &&
            Number(edited.id) === Number(latestVisibleCommentId);
        if (!canEditAllTicketActions && !(isLatestComment && isOwnComment)) {
            toast.error('Você não tem permissão para editar esta ação.', { position: toast.POSITION.BOTTOM_CENTER });
            return;
        }
        const cleaned = removeEmptyHtmlTags(editCommentDraft);
        const hasInlineImage = commentHtmlHasInlineImage(cleaned);
        const plain = cleaned?.replace(/<[^>]+>/g, '')?.trim() ?? '';
        const hasNewAttachments = editCommentAttachments.length > 0;
        const removePaths = editRemovedAttachmentPaths;
        // Anexos salvos que sobram após as remoções marcadas pelo usuário.
        const remainingExisting = (Array.isArray(edited?.attachments) ? edited.attachments : [])
            .filter((att) => !removePaths.includes(att?.path));
        const hasExistingAttachments = remainingExisting.length > 0;
        if (!plain && !hasInlineImage && !hasExistingAttachments && !hasNewAttachments) {
            toast.error('Informe o texto da ação ou anexe um arquivo.', { position: toast.POSITION.BOTTOM_CENTER });
            return;
        }
        setSavingCommentEdit(true);
        const commentBody = cleaned || (hasInlineImage ? editCommentDraft : '');
        const payload = hasNewAttachments
            ? buildCommentFormData(commentBody, Boolean(edited?.is_internal), editCommentAttachments, removePaths)
            : { comment: commentBody, remove_attachments: removePaths };
        const saveRequest = hasNewAttachments
            ? http.post(`/ticket/${ticketData.id}/comments/${editingCommentId}`, payload)
            : http.put(`/ticket/${ticketData.id}/comments/${editingCommentId}`, payload);
        saveRequest
            .then((response) => {
                setComments((prev) =>
                    prev
                        .map((c) => (Number(c.id) === Number(editingCommentId) ? { ...c, ...response.data } : c))
                        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                );
                setEditingCommentId(null);
                setEditCommentDraft('');
                setEditCommentAttachments([]);
                setEditRemovedAttachmentPaths([]);
                setAttendanceRefreshKey((k) => k + 1);
                notifyTicketStakeholders(ticketData, { comment: 'Ação atualizada' });
                toast.success('Ação atualizada.', { position: toast.POSITION.BOTTOM_CENTER });
            })
            .catch((error) => {
                const msg =
                    error.response?.data?.errors?.comment?.[0] ||
                    error.response?.data?.errors?.['attachments.0']?.[0] ||
                    error.response?.data?.message ||
                    (error.response?.data?.errors ? mensagemDeAnexoRecusado() : null) ||
                    'Não foi possível atualizar a ação.';
                toast.error(msg, { position: toast.POSITION.BOTTOM_CENTER });
            })
            .finally(() => setSavingCommentEdit(false));
    };

    const handleAdjustNewCommentWithGpt = async () => {
        const current = String(newComment || '').trim();
        if (!current) {
            toast.warning('Informe o texto da ação antes de ajustar com GPT.', { position: toast.POSITION.BOTTOM_CENTER });
            return;
        }
        try {
            setGptAdjustingNewComment(true);
            const res = await quillAdjustTextWithGpt(newComment, { kind: 'texto da ação do ticket' });
            if (!res.ok) {
                toast.error(res.message || 'Não foi possível ajustar o texto.', { position: toast.POSITION.BOTTOM_CENTER });
                return;
            }
            setNewComment(res.text);
        } catch (e) {
            toast.error('Erro ao ajustar texto com GPT.', { position: toast.POSITION.BOTTOM_CENTER });
        } finally {
            setGptAdjustingNewComment(false);
        }
    };

    const handleAdjustEditingCommentWithGpt = async () => {
        const currentId = editingCommentId;
        if (!ticketData?.id || currentId == null) return;
        const current = String(editCommentDraft || '').trim();
        if (!current) {
            toast.warning('Informe o texto da ação antes de ajustar com GPT.', { position: toast.POSITION.BOTTOM_CENTER });
            return;
        }
        try {
            setGptAdjustingComment(true);
            const res = await quillAdjustTextWithGpt(editCommentDraft, { kind: 'texto da ação do ticket' });
            if (!res.ok) {
                toast.error(res.message || 'Não foi possível ajustar o texto.', { position: toast.POSITION.BOTTOM_CENTER });
                return;
            }
            if (editingCommentId !== currentId) return;
            setEditCommentDraft(res.text);
        } catch (e) {
            toast.error('Erro ao ajustar texto com GPT.', { position: toast.POSITION.BOTTOM_CENTER });
        } finally {
            setGptAdjustingComment(false);
        }
    };

    const executeCreateTicket = async () => {
        if (!isNewTicket) return;

        const sanitizeId = (id) => {
            if (!id) return null;
            if (typeof id === 'number' && !isNaN(id) && id > 0) return id;
            if (typeof id === 'string') {
                if (id.includes('default') || id.includes('existing')) return null;
                const numId = Number(id);
                if (!isNaN(numId) && numId > 0) return numId;
            }
            return null;
        };

        const ticketDataToSave = {
            ...ticketData,
            client_id: sanitizeId(ticketData.client_id),
            company_id: sanitizeId(ticketData.company_id),
        };

        // A primeira ação pode estar já na lista (pendingComments) OU ainda no
        // editor (usuário digitou e não clicou "Adicionar ação"). Envia as duas,
        // para o ticket nunca nascer sem ação. Adicionar limpa o editor, então não
        // há duplicação.
        const commentsToPost = [...pendingComments];
        const cleanedEditor = removeEmptyHtmlTags(newComment);
        const editorHasContent = Boolean(cleanedEditor?.replace(/<[^>]+>/g, '')?.trim())
            || commentHtmlHasInlineImage(cleanedEditor)
            || commentAttachments.length > 0;
        if (editorHasContent) {
            commentsToPost.push({
                comment: cleanedEditor || '',
                is_internal: canViewInternalComments ? commentIsInternal : ticketData.is_internal,
                attachments: commentAttachments.length > 0 ? [...commentAttachments] : null,
            });
        }

        setLoading(true);
        const payloadToCreate = buildTicketPayloadForApi(ticketDataToSave);
        try {
            const response = await http.post('/ticket', payloadToCreate);
            const createdTicket = response.data;
            for (const { comment, is_internal, attachments } of commentsToPost) {
                const hasFiles = attachments && attachments.length > 0;
                const payload = hasFiles
                    ? buildCommentFormData(comment, payloadToCreate.is_internal || is_internal, attachments)
                    : { comment, is_internal: payloadToCreate.is_internal || is_internal };
                await http.post(`/ticket/${createdTicket.id}/comments`, payload);
            }
            props.fetchTickets();
            props.notifyNewTicketAssigned(
                createdTicket.id,
                createdTicket.title,
                payloadToCreate.assigned_to,
                payloadToCreate.created_by
            );
            // Abre o modal de sucesso SEM navegar nem descartar o rascunho ainda.
            // Motivo: a rota usa component={() => ...} (remonta ao navegar) e o effect
            // do rascunho redireciona rascunho descartado para '/'. Fazer qualquer um
            // dos dois aqui desmontaria o componente e o modal nem apareceria. A
            // limpeza (descartar rascunho + trocar a aba) e a navegação ficam nos
            // botões do modal (finalizeCreatedDraft).
            // O mapeamento mora em `utils/ticketCriado` e tem teste: o modal
            // lia `number`, que nunca era gravado aqui, e mostrava "#" sozinho
            // com o ticket criado normalmente. `number` e `id` são coisas
            // diferentes -- um é o que a pessoa cita, o outro é por onde a
            // navegação abre o ticket.
            setCreatedTicketInfo(dadosDoTicketCriado(createdTicket, ticketData));
        } catch (error) {
            console.error(error);
            toast.error('Erro ao criar ticket');
        } finally {
            setLoading(false);
        }
    };

    const handleCreateClick = () => {
        if (!isNewTicket) return;
        if (requiredSaveValidation.isInvalid) {
            toast.error(buildRequiredFieldsMessage(requiredSaveValidation.missing), { position: toast.POSITION.BOTTOM_CENTER });
            return;
        }
        // Cria direto — sem modal de confirmação. O feedback é o modal de sucesso.
        executeCreateTicket();
    };

    // Limpa o rascunho recém-criado: marca como descartado e troca a aba do
    // rascunho pela aba do ticket criado. Chamado ao fechar o modal de sucesso.
    const finalizeCreatedDraft = (createdId, createdTitle) => {
        if (draftId) {
            try {
                localStorage.setItem(buildDraftDiscardedKey(draftId), '1');
                localStorage.removeItem(buildDraftStorageKey(draftId));
            } catch {}
        }
        const currentViewed = props.viewedTickets || [];
        const withoutDraft = currentViewed.filter((t) => !(t?.isDraft && t?.draftId === draftId));
        const alreadyHasTicket = withoutDraft.some((t) => Number(t.id) === Number(createdId));
        props.setViewedTickets(
            alreadyHasTicket ? withoutDraft : [...withoutDraft, { id: createdId, title: createdTitle }]
        );
    };

    /**
     * Copia o endereço do chamado recém-criado.
     *
     * O link é montado a partir da janela atual, e não de uma constante: o
     * AloDesk é white-label e cada empresa entra por um endereço diferente.
     * Ver `utils/linkDoChamado`.
     */
    const copiarLinkDoChamadoCriado = async () => {
        const link = linkDoChamado(createdTicketInfo?.id);

        if (!link) return;

        const copiou = await copiarTexto(link);

        if (copiou) {
            toast.success('Link do chamado copiado.', { position: toast.POSITION.BOTTOM_CENTER });
        } else {
            toast.error('Não foi possível copiar o link.', { position: toast.POSITION.BOTTOM_CENTER });
        }
    };

    // Botões do modal de sucesso pós-criação.
    const handleSuccessNewTicket = () => {
        const info = createdTicketInfo;
        setCreatedTicketInfo(null);
        if (info?.id) finalizeCreatedDraft(info.id, info.title);
        props.history.push('/ticket/new');
    };
    const handleSuccessGoToTicket = () => {
        // "Continuar editando" / "OK": fecha o modal, limpa o rascunho e vai ao ticket criado.
        const info = createdTicketInfo;
        setCreatedTicketInfo(null);
        if (info?.id) {
            finalizeCreatedDraft(info.id, info.title);
            props.history.push(`/ticket/${info.id}`);
        }
    };

    const handleOpenMergeModal = async () => {
        if (isNewTicket || !ticketData?.id || !canMergeTickets) return;
        const preferred = localStorage.getItem('ticketMergePrimaryPreference');
        setMergePrimaryChoice(preferred === 'target' ? 'target' : 'current');
        setRememberMergeChoice(false);
        setMergeTargetTicket(null);
        // A lista nasce VAZIA e enche conforme se digita.
        //
        // Antes era um `GET /ticket` SEM escopo -- todos os chamados já
        // criados, 266 mil em produção. O processo do PHP morria, o `catch`
        // esvaziava a lista, e este modal abria sem nenhum chamado para
        // escolher: não dava para mesclar. Ver `utils/buscaDeChamados`.
        setMergeCandidates([]);
        setMergeLoadingOptions(false);
        setMergeModalOpen(true);
    };

    /**
     * Busca chamados para os seletores de mesclar e de relacionado.
     *
     * Com atraso entre as teclas: sem ele, "certificado" dispararia onze
     * consultas e a última a responder poderia não ser a da última tecla.
     */
    const buscarChamadosParaSelecao = useCallback((termo, setLista, setCarregando) => {
        const params = paramsDaBusca(termo);

        if (buscaDeChamadosRef.current) {
            clearTimeout(buscaDeChamadosRef.current);
        }

        if (!params) {
            setLista([]);
            setCarregando(false);
            return;
        }

        setCarregando(true);

        buscaDeChamadosRef.current = setTimeout(() => {
            http.get('/ticket/paginated', { params })
                .then((res) => setLista(candidatosDaResposta(res.data, ticketData?.id)))
                .catch(() => setLista([]))
                .finally(() => setCarregando(false));
        }, 350);
    }, [ticketData?.id]);

    const handleCloseMergeModal = () => {
        setMergeModalOpen(false);
        setMergeLoadingOptions(false);
        setMergeSaving(false);
        setMergeTargetTicket(null);
        setRememberMergeChoice(false);
    };

    const handleConfirmMerge = async () => {
        if (!ticketData?.id || !mergeTargetTicket?.id) return;
        setMergeSaving(true);
        try {
            const primaryId = mergePrimaryChoice === 'target' ? mergeTargetTicket.id : ticketData.id;
            await http.post('/ticket/merge', {
                source_ticket_id: ticketData.id,
                target_ticket_id: mergeTargetTicket.id,
                primary_ticket_id: primaryId,
            });
            if (rememberMergeChoice) {
                localStorage.setItem('ticketMergePrimaryPreference', mergePrimaryChoice === 'target' ? 'target' : 'current');
            }
            toast.success('Tickets mesclados com sucesso.');
            setMergeSaving(false);
            setMergeModalOpen(false);
            if (Number(primaryId) !== Number(ticketData.id)) {
                props.history.push(`/ticket/${primaryId}`);
                return;
            }
            await props.fetchTickets();
            await http.get(`/ticket/${ticketData.id}`).then((response) => {
                const ticketDataFromAPI = response.data;
                guardarResponsavelForaDaLista(ticketDataFromAPI.assigned_to);
                setTicketData({
                    ...ticketDataFromAPI,
                    assigned_to: ticketDataFromAPI.assigned_to?.id || ticketDataFromAPI.assigned_to || '',
                    cc_users: ticketDataFromAPI.cc_users || [],
                    cc_emails: ticketDataFromAPI.cc_emails || [],
                    status_id: ticketDataFromAPI.status_id ?? ticketDataFromAPI.ticket_status?.id ?? null,
                    substatus_id: ticketDataFromAPI.substatus_id ?? ticketDataFromAPI.ticket_substatus?.id ?? null,
                    service_id: ticketDataFromAPI.service_id ?? ticketDataFromAPI.service?.id ?? null
                });
            });
        } catch (error) {
            const msg = error?.response?.data?.message || 'Não foi possível mesclar os tickets.';
            toast.error(msg);
            setMergeSaving(false);
        }
    };

    const handleOpenTicketOptions = (e) => {
        setTicketOptionsAnchorEl(e.currentTarget);
    };

    const handleCloseTicketOptions = () => {
        setTicketOptionsAnchorEl(null);
    };

    const handleDeleteTicket = async () => {
        const tid = ticketData?.id;
        if (!tid) return;
        try {
            setDeletingTicket(true);
            await http.delete(`/ticket/${tid}`);
            toast.success('Ticket excluído com sucesso.', { position: toast.POSITION.BOTTOM_CENTER });
            setDeleteDialogOpen(false);
            const remaining = (props.viewedTickets || []).filter((t) => Number(t.id) !== Number(tid));
            props.setViewedTickets(remaining);
            props.fetchTickets();
            props.history.push('/ticket');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Erro ao excluir o ticket.', { position: toast.POSITION.BOTTOM_CENTER });
        } finally {
            setDeletingTicket(false);
        }
    };

    const handleOpenRelatedModal = async () => {
        handleCloseTicketOptions();
        setRelatedMode('create_new');
        setRelatedCopyMode('all');
        setRelatedTargetTicket(null);
        setRelatedLinkDirection('current_as_child');
        setRelatedRegistroFilter('');
        setRelatedModalOpen(true);
        const currentId = Number(ticketData?.id);
        if (!currentId || isNewTicket) return;
        // Igual ao de mesclar: a lista nasce vazia e enche conforme se digita.
        // O placeholder do campo já prometia "Buscar por # ou título" -- agora
        // ele busca de verdade, no servidor.
        setRelatedTicketOptions([]);
        setRelatedOptionsLoading(false);
    };

    const handleOpenMergeFromMenu = () => {
        handleCloseTicketOptions();
        handleOpenMergeModal();
    };

    const handleCloseRelatedModal = () => {
        if (creatingRelatedTicket) return;
        setRelatedModalOpen(false);
    };

    const handleConfirmRelated = async () => {
        const ticketId = ticketData?.id;
        if (!ticketId || isNewTicket) return;

        if (relatedMode === 'link_existing' && !relatedTargetTicket?.id) {
            toast.warning('Selecione o ticket para vincular.', { position: toast.POSITION.BOTTOM_CENTER });
            return;
        }

        setCreatingRelatedTicket(true);
        try {
            const payload = relatedMode === 'link_existing'
                ? {
                    mode: 'link_existing',
                    target_ticket_id: relatedTargetTicket.id,
                    link_direction: relatedLinkDirection,
                }
                : {
                    mode: 'create_new',
                    copy_actions: relatedCopyMode,
                };

            const res = await http.post(`/ticket/${ticketId}/related`, payload);

            if (relatedMode === 'link_existing') {
                toast.success('Tickets vinculados com sucesso.', { position: toast.POSITION.BOTTOM_CENTER });
                setRelatedModalOpen(false);
                if (relatedLinkDirection === 'current_as_child') {
                    const refreshed = await http.get(`/ticket/${ticketId}`);
                    const t = refreshed.data;
                    setTicketData((prev) => ({
                        ...prev,
                        ...t,
                        assigned_to: t.assigned_to?.id || t.assigned_to || prev.assigned_to,
                        parent_ticket_id: t.parent_ticket_id ?? relatedTargetTicket.id,
                    }));
                }
                await fetchTicketRelationships();
            } else {
                const created = res?.data;
                const createdId = created?.id ?? created?.ticket_id ?? null;
                toast.success('Ticket relacionado criado com sucesso.', { position: toast.POSITION.BOTTOM_CENTER });
                setRelatedModalOpen(false);
                if (createdId != null) {
                    props.history.push(`/ticket/${createdId}`);
                } else {
                    props.history.push('/ticket');
                }
            }
        } catch (e) {
            const msg = e?.response?.data?.message || 'Não foi possível concluir o relacionamento.';
            toast.error(msg, { position: toast.POSITION.BOTTOM_CENTER });
        } finally {
            setCreatingRelatedTicket(false);
        }
    };

    const startEditingSubject = () => {
        if (isNewTicket || !canEditTicket) return;
        setSubjectDraft(String(ticketData?.title || ''));
        setIsEditingSubject(true);
    };

    const cancelEditingSubject = () => {
        setIsEditingSubject(false);
        setSubjectDraft('');
        setSavingSubject(false);
    };

    const saveSubject = async () => {
        if (isNewTicket || !ticketData?.id || !canEditTicket) return;
        const nextTitle = String(subjectDraft || '').trim();
        if (!nextTitle) {
            toast.warning('Informe o assunto.', { position: toast.POSITION.BOTTOM_CENTER });
            return;
        }
        if (nextTitle === String(ticketData?.title || '').trim()) {
            cancelEditingSubject();
            return;
        }
        setSavingSubject(true);
        const nextData = { ...ticketData, title: nextTitle };
        setTicketData(nextData);
        try {
            const subjectPayload = buildTicketPayloadForApi(nextData);
            await props.editTicket(subjectPayload);
            await ensureAssigneeAttendanceRunning(nextData.id, subjectPayload.assigned_to);
            setAttendanceRefreshKey((k) => k + 1);
            toast.success('Assunto atualizado.', { position: toast.POSITION.BOTTOM_CENTER });
            cancelEditingSubject();
        } catch (_) {
            toast.error('Não foi possível atualizar o assunto.', { position: toast.POSITION.BOTTOM_CENTER });
            setSavingSubject(false);
        }
    };


    const buildTicketPayloadForApi = (data, clientsSnapshot = selectedClients) => {
        const sanitizeId = (id) => {
            if (!id) return null;
            if (typeof id === 'number' && !isNaN(id) && id > 0) return id;
            if (typeof id === 'string') {
                if (id.includes('default') || id.includes('existing')) return null;
                const numId = Number(id);
                if (!isNaN(numId) && numId > 0) return numId;
            }
            return null;
        };
        const clientStr = typeof data.client === 'string'
            ? data.client
            : (data.client && (data.client.name || data.client.business_name || (data.client.company && (data.client.company.business_name || data.client.company.name)))) || '';
        const clientsPayload = (clientsSnapshot || []).map((client, index) => ({
            client_id: sanitizeId(client.id),
            company_id: sanitizeId(client.company?.id),
            is_primary: index === 0
        }));

        const rawDue = data.solution_due_at;
        const solutionDueNormalized =
            rawDue == null || rawDue === '' || (typeof rawDue === 'string' && !String(rawDue).trim())
                ? null
                : rawDue;

        return {
            ...data,
            id: data.id,
            client: clientStr,
            client_id: sanitizeId(data.client_id),
            company_id: sanitizeId(data.company_id),
            client_group_id: sanitizeId(data.client_group_id),
            assigned_to: data.assigned_to?.id ?? data.assigned_to,
            // O solicitante viaja como ID, como os outros vinculos de usuario:
            // a tela guarda o objeto para desenhar nome e foto.
            requester: sanitizeId(data.requester?.id ?? data.requester),
            created_by: data.created_by?.id ?? data.created_by,
            status_id: data.status_id ? Number(data.status_id) : null,
            substatus_id: data.substatus_id ? Number(data.substatus_id) : null,
            service_id: sanitizeId(data.service_id),
            service_group_id: sanitizeId(data.service_group_id),
            clients: clientsPayload,
            solution_due_at: solutionDueNormalized
        };
    };

    const ensureAssigneeAttendanceRunning = useCallback(async (ticketId, assigneeId) => {
        if (!ticketId || ticketId === 'new' || props.currentUser?.id == null) return;
        const resolvedAssignee = assigneeId?.id ?? assigneeId;
        if (resolvedAssignee == null || Number(resolvedAssignee) !== Number(props.currentUser.id)) return;
        try {
            await http.post(`/ticket/${ticketId}/attendance/start`);
        } catch (_) {
            // idempotente: sessão já ativa ou backend já iniciou no PUT do ticket
        }
    }, [props.currentUser?.id]);

    const persistTicketChanges = useCallback(async (data, clientsSnapshot = selectedClients, options = {}) => {
        if (isNewTicket) return;
        const ticketId = data?.id ?? ticketData?.id ?? (id && id !== 'new' ? id : null);
        if (!ticketId || !canEditTicket) return;
        const statusValidation = getTicketStatusValidation(data, ticketStatuses);
        if (statusValidation.isInvalid) {
            toast.error(buildRequiredFieldsMessage(statusValidation.missing), { position: toast.POSITION.BOTTOM_CENTER });
            return;
        }
        /*
         * O chamado vindo do chat não FINALIZA sem classificação (ponto 4 da
         * Gisele). Ele nasce sem serviço nem categoria -- o cliente escolhe um
         * departamento na conversa, que não é nem um nem outro --, e a decisão
         * dele foi que a triagem preenche os dois à mão.
         *
         * A exigência cai só ao finalizar, e só nesse chamado. Esta tela grava
         * a cada mudança, sem botão de salvar: travar qualquer salvamento faria
         * o operador perder a alteração que acabou de fazer por um campo que
         * preencheria depois. E exigir de TODO chamado travaria o fechamento
         * das centenas de milhares de antigos sem classificação.
         *
         * A regra mora em `utils/classificacaoDoChamado`, com teste. Quais
         * campos ela exige deixou de ser fixo em 22/10 (pontos 17 e 31): vem
         * de `/regra-de-conclusao`, com serviço e categoria como padrão.
         */
        const faltaClassificar = impedimentoParaFinalizar(data, idsFinalizados(ticketStatuses), regraDeConclusao);
        if (faltaClassificar.length > 0) {
            toast.error(
                `Não é possível finalizar o chamado sem ${faltaClassificar.join(' e ')}.`,
                { position: toast.POSITION.BOTTOM_CENTER }
            );
            return;
        }
        try {
            const payload = buildTicketPayloadForApi({ ...data, id: ticketId }, clientsSnapshot);
            await props.editTicket(payload);
            await ensureAssigneeAttendanceRunning(ticketId, payload.assigned_to);
            if (options.refreshAttendance !== false) {
                setAttendanceRefreshKey((k) => k + 1);
            }
        } catch (_) {
            // 403 e demais erros tratados em editTicket
        }
    }, [isNewTicket, ticketData?.id, id, canEditTicket, selectedClients, props, ensureAssigneeAttendanceRunning, ticketStatuses, regraDeConclusao]);

    const applyMacroMessageEffectsToForm = (messageEffects) => {
        if (!messageEffects?.hasMessageText) return;
        setNewComment(messageEffects.messageBody);
        setCommentIsInternal(messageEffects.messageIsInternal);
    };

    const applyMacroToCurrentTicket = async (macroId, source = 'manual') => {
        if (!macroId || !canEditTicket) return;

        if (isNewTicket) {
            const { ticketData: updated, messageEffects } = applyMacroToTicketDraft(ticketData, macroId, macros, {
                ticketStatuses,
                commentIsInternal,
            });
            setTicketData(updated);
            applyMacroMessageEffectsToForm(messageEffects);
            if (messageEffects?.hasMessageText) {
                toast.success('Macro aplicada com sucesso.');
            }
            return;
        }

        const ticketId = ticketData?.id || id;
        if (!ticketId) return;

        const macro = macros.find((m) => m.id === Number(macroId) || m.id === macroId);
        const messagePreview = extractMacroMessageEffects(
            macro?.actions,
            ticketData,
            commentIsInternal
        );

        try {
            const res = await http.post(`/ticket/${ticketId}/apply-macro`, {
                macro_id: macroId,
                skip_comment: messagePreview.hasMessageText,
            });
            setTicketData(res.data.ticket);
            if (res.data.comment) {
                setComments((prev) =>
                    [res.data.comment, ...prev].sort(
                        (a, b) => new Date(b.created_at) - new Date(a.created_at)
                    )
                );
                notifyTicketStakeholders(res.data.ticket || ticketData, { comment: 'Nova ação registrada' });
            }

            applyMacroMessageEffectsToForm(messagePreview);
            if (messagePreview.hasMessageText) {
                toast.success('Macro aplicada com sucesso.');
            }
        } catch (err) {
            toast.error(err.response?.data?.message || 'Erro ao aplicar macro.');
        }
    };

    const solutionDueToInputValue = (isoOrNull) => {
        if (!isoOrNull) return '';
        const d = new Date(isoOrNull);
        if (Number.isNaN(d.getTime())) return '';
        const pad = (n) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    const serviceBlocksCloseNow = useCallback(() => {
        const flatSvcs = (services || []).flatMap((s) => [s, ...(s.subservices || [])]);
        const curSvc = flatSvcs.find((x) => String(x.id) === String(ticketData.service_id));
        return curSvc && curSvc.block_close ? curSvc : null;
    }, [services, ticketData.service_id]);

    const isFinalizingStatusId = useCallback((sid) => {
        const st = (ticketStatuses || []).find((s) => Number(s.id) === Number(sid));
        return !!st && ['Resolvido', 'Cancelado', 'Fechado'].includes(st.name);
    }, [ticketStatuses]);

    const handleStatusJustificationChange = ({ statusId, substatusId }) => {
        if (!canEditTicket || statusId == null) return;
        if (isFinalizingStatusId(statusId)) {
            const blockingSvc = serviceBlocksCloseNow();
            if (blockingSvc) {
                toast.error(`Não é possível fechar este ticket enquanto o serviço "${blockingSvc.name}" estiver selecionado.`, { position: toast.POSITION.BOTTOM_CENTER });
                return;
            }
        }

        // Fechando chamado de OUTRA pessoa: pergunta antes de quem fica com
        // ele. Guarda a mudança e devolve o controle ao modal -- nada é
        // salvo até a pessoa escolher. Ver `utils/assumirTicket`.
        if (precisaPerguntarSeAssume({
            statusId,
            ticketStatuses,
            assignedTo: ticketData?.assigned_to,
            currentUserId: props.currentUser?.id,
        })) {
            setAssumirPendente({ statusId, substatusId });
            return;
        }

        aplicarFechamentoDeStatus({ statusId, substatusId });
    };

    /**
     * A escolha do modal, aplicada ao caminho de onde a pergunta veio.
     *
     * Os dois controles de fechamento guardam formatos diferentes
     * (`{statusId, substatusId}` do seletor do topo, `{campo, valor}` do
     * "Fechar ticket..."), e cada um volta pelo seu próprio caminho. Mandar
     * os dois por um só exigiria traduzir um no outro -- e a tradução entre o
     * `status` antigo e o `status_id` novo é justamente onde esta tela já
     * tem remendos.
     */
    const aplicarPendenteDeAssumir = (assumir) => {
        const pendente = assumirPendente;
        setAssumirPendente(null);

        if (!pendente) return;

        if (pendente.campo) {
            handleInputChange(null, pendente.valor, pendente.campo, { jaPerguntou: true, assumir });
            return;
        }

        aplicarFechamentoDeStatus(pendente, assumir);
    };

    /**
     * Aplica a mudança de status, opcionalmente assumindo o chamado.
     *
     * Separado de `handleStatusJustificationChange` porque o modal precisa
     * executar exatamente isto DEPOIS da escolha -- e repetir o corpo aqui
     * faria os dois divergirem no primeiro conserto feito só num deles.
     */
    const aplicarFechamentoDeStatus = ({ statusId, substatusId }, assumir = false) => {
        const nextData = {
            ...ticketData,
            status_id: statusId,
            substatus_id: substatusId,
            ...(assumir ? { assigned_to: props.currentUser?.id } : {}),
        };
        setTicketData(nextData);
        if (!isNewTicket && (ticketData?.id || id) && canEditTicket) {
            const statusNum = Number(nextData.status);
            const skipAutoApply = statusNum === 3 || statusNum === 4;
            if (!skipAutoApply) {
                persistTicketChanges(nextData, selectedClients).then(() => {
                    notifyTicketStakeholders(nextData, { status_id: statusId, substatus_id: substatusId });
                });
            }
        }
    };

    /**
     * @param {{jaPerguntou?: boolean, assumir?: boolean}} opcoes  usado só
     *   pelo modal de "assumir o chamado": `jaPerguntou` pula a pergunta (que
     *   acabou de ser respondida, e repetir seria um laço) e `assumir` passa
     *   o chamado para quem está fechando.
     */
    const handleInputChange = (e, newValue, name, opcoes = {}) => {
        /*
         * Marca que EU estou mexendo agora (Gisele, 23/10). O batimento le
         * este instante para avisar os outros operadores -- e e por isso
         * que ele fica aqui, no caminho por onde toda alteracao de campo
         * passa, e nao em cada campo.
         *
         * Os EDITORES nao passam por aqui -- ver `marcarQueEstouEditando`.
         */
        marcarQueEstouEditando();

        const fieldName = name || e.target?.name;
        const rawValue = name !== undefined ? newValue : e.target?.value;
        let value = fieldName === 'status' ? Number(rawValue) : rawValue;
        let pendingMacroId = null;

        // Bloqueio de fechamento por serviço (block_close).
        const willFinalize =
            (fieldName === 'status' && (Number(rawValue) === 3 || Number(rawValue) === 4)) ||
            (fieldName === 'status_id' && rawValue != null && rawValue !== '' && isFinalizingStatusId(rawValue));
        if (willFinalize) {
            const blockingSvc = serviceBlocksCloseNow();
            if (blockingSvc) {
                toast.error(`Não é possível fechar este ticket enquanto o serviço "${blockingSvc.name}" estiver selecionado.`, { position: toast.POSITION.BOTTOM_CENTER });
                return;
            }

            // O MESMO modal do seletor de status. Este controle ("Fechar
            // ticket...") manda o `status` numérico antigo, por isso a regra
            // recebe `statusLegado` -- ver `utils/assumirTicket`.
            if (!opcoes.jaPerguntou && precisaPerguntarSeAssume({
                statusId: fieldName === 'status_id' ? rawValue : null,
                statusLegado: fieldName === 'status' ? rawValue : null,
                ticketStatuses,
                assignedTo: ticketData?.assigned_to,
                currentUserId: props.currentUser?.id,
            })) {
                setAssumirPendente({ campo: fieldName, valor: rawValue });
                return;
            }
        }

        if (fieldName === 'service_id') {
            if (rawValue === '' || rawValue === null || rawValue === undefined) {
                value = null;
            } else {
                const num = Number(rawValue);
                value = !isNaN(num) ? num : rawValue;
            }
        }

        const nextData = {
            ...ticketData,
            [fieldName]: value,
            // Vem junto da MESMA atualização de propósito. Trocar o
            // responsável antes, num `setTicketData` separado, deixaria este
            // `...ticketData` com o valor velho -- o chamado fecharia e a
            // troca se perderia, sem erro nenhum.
            ...(opcoes.assumir ? { assigned_to: props.currentUser?.id } : {}),
        };
        if (fieldName === 'status_id') {
            const numStatusId = value != null && value !== '' ? Number(value) : null;
            const st = numStatusId != null ? ticketStatuses.find((s) => Number(s.id) === numStatusId) : null;
            const subs = Array.isArray(st?.substatuses) ? st.substatuses : [];
            const currentSub = nextData.substatus_id;
            const subStillValid =
                currentSub != null &&
                currentSub !== '' &&
                subs.some((sub) => Number(sub.id) === Number(currentSub));
            if (!subStillValid) {
                nextData.substatus_id = null;
            }
        }
        if (fieldName === 'status' && (value === 3 || value === 4)) {
            const statusName = value === 3 ? 'Resolvido' : 'Cancelado';
            const st = ticketStatuses.find((s) => s.name === statusName);
            if (st) nextData.status_id = st.id;
        }
        if (fieldName === 'service_id') {
            const flat = (services || []).flatMap((s) => [s, ...(s.subservices || [])]);
            const svc = flat.find((x) => String(x.id) === String(value));

            if (svc && svc.accept_all_categories === false && (svc.categories || []).length && nextData.category) {
                const allowedNames = (svc.categories || []).map((c) => c.name);
                if (!allowedNames.includes(nextData.category)) nextData.category = '';
            }
            // Aplica urgência e previsão de SLA padrão do serviço, quando definidos.
            if (svc && svc.default_priority != null && svc.default_priority !== '') {
                nextData.priority = Number(svc.default_priority);
            }
            if (svc && svc.default_sla_minutes != null && svc.default_sla_minutes !== '' && Number(svc.default_sla_minutes) > 0) {
                nextData.solution_due_at = new Date(Date.now() + Number(svc.default_sla_minutes) * 60000).toISOString();
            }
            if (svc && svc.macro_id) {
                pendingMacroId = svc.macro_id;
            }
        }

        let dataToSet = nextData;
        if (fieldName === 'service_id' && pendingMacroId && isNewTicket) {
            const macroResult = applyMacroToTicketDraft(nextData, pendingMacroId, macros, {
                ticketStatuses,
                commentIsInternal,
            });
            dataToSet = macroResult.ticketData;
            if (dataToSet.service_id != null) {
                const flatAfterMacro = (services || []).flatMap((s) => [s, ...(s.subservices || [])]);
                const svcAfterMacro = flatAfterMacro.find((x) => String(x.id) === String(dataToSet.service_id));
                if (
                    svcAfterMacro &&
                    svcAfterMacro.accept_all_categories === false &&
                    (svcAfterMacro.categories || []).length &&
                    dataToSet.category
                ) {
                    const allowedNames = (svcAfterMacro.categories || []).map((c) => c.name);
                    if (!allowedNames.includes(dataToSet.category)) {
                        dataToSet = { ...dataToSet, category: '' };
                    }
                }
            }
            applyMacroMessageEffectsToForm(macroResult.messageEffects);
        }

        setTicketData(dataToSet);

        if (!isNewTicket && (ticketData?.id || id) && canEditTicket) {
            const statusNum = fieldName === 'status' ? value : nextData.status;
            const skipAutoApply = fieldName === 'status' && (statusNum === 3 || statusNum === 4);
            const isStatusField = fieldName === 'status' || fieldName === 'status_id' || fieldName === 'substatus_id';
            if (!skipAutoApply) {
                persistTicketChanges(dataToSet, selectedClients).then(() => {
                    if (isStatusField) {
                        notifyTicketStakeholders(dataToSet, { [fieldName]: value });
                    }
                    if (pendingMacroId) {
                        applyMacroToCurrentTicket(pendingMacroId, 'service_change_after_save');
                    }
                });
            }
        }
    };

    const handleTypeChange = (newIsInternal) => {
        if (!canEditTicket) return;
        // Se é um ticket novo, não precisa de confirmação
        if (isNewTicket) {
            setTicketData({ ...ticketData, is_internal: newIsInternal });
            return;
        }

        // Se não há mudança, não faz nada
        if (ticketData.is_internal === newIsInternal) {
            return;
        }

        // Salva a mudança pendente e mostra o modal
        setPendingTypeChange(newIsInternal);
        setShowTypeChangeModal(true);
    };

    const confirmTypeChange = () => {
        const nextData = { ...ticketData, is_internal: pendingTypeChange };
        setTicketData(nextData);
        setShowTypeChangeModal(false);
        setPendingTypeChange(null);
        persistTicketChanges(nextData);
    };

    const cancelTypeChange = () => {
        setShowTypeChangeModal(false);
        setPendingTypeChange(null);
    };

    const handleReabrirTicket = async () => {
        if (isNewTicket || !ticketData?.id || !canEditTicket) return;
        const abertoStatus = ticketStatuses.find((s) => s.name === 'Aberto');
        const nextData = { ...ticketData, status: 1, status_id: abertoStatus?.id ?? ticketData.status_id, substatus_id: null };
        setTicketData(nextData);
        setPersistedStatus(1);
        try {
            const reopenPayload = buildTicketPayloadForApi(nextData);
            await props.editTicket(reopenPayload);
            await ensureAssigneeAttendanceRunning(nextData.id, reopenPayload.assigned_to);
            setAttendanceRefreshKey((k) => k + 1);
            notifyTicketStakeholders(nextData, { status: 1, status_id: nextData.status_id });
            toast.success('Ticket reaberto.', {
                position: toast.POSITION.BOTTOM_CENTER,
                style: {
                    backgroundColor: theme.palette.background.toast,
                    color: theme.palette.success.contrastText,
                },
            });
        } catch (_) {}
    };

    const buildTicketDataForClientList = (clients) => {
        if (!clients?.length) {
            return { client: '', client_id: null, company_id: null };
        }
        const mainClient = clients[0];
        const mainClientId = (typeof mainClient.id === 'number' && mainClient.id > 0)
            ? mainClient.id
            : (typeof mainClient.id === 'string' && !isNaN(Number(mainClient.id)) && Number(mainClient.id) > 0)
                ? Number(mainClient.id)
                : null;
        const mainCompanyId = (typeof mainClient.company?.id === 'number' && mainClient.company.id > 0)
            ? mainClient.company.id
            : (typeof mainClient.company?.id === 'string' && !isNaN(Number(mainClient.company?.id)) && Number(mainClient.company.id) > 0)
                ? Number(mainClient.company.id)
                : null;
        return {
            client: mainClient.company?.business_name || mainClient.company?.name || '',
            client_id: mainClientId,
            company_id: mainCompanyId,
        };
    };

    const handleClientSelect = (client) => {
        if (selectedClients.some((c) => String(c.id) === String(client.id))) return;

        const nextClients = [...selectedClients, client];
        // Ao clicar num contato, preenche o campo "Contato" com o nome dele.
        // Empresas adicionadas a partir de um grupo (id com prefixo
        // group-company-) nao sao contatos, entao nao sobrescrevem o campo.
        const isGroupCompany = String(client.id).startsWith(GROUP_CLIENT_PREFIX);
        const contactValue = !isGroupCompany && client.name ? client.name : ticketData.contact;
        const nextData = {
            ...ticketData,
            ...buildTicketDataForClientList(nextClients),
            contact: contactValue,
        };
        setSelectedClients(nextClients);
        setTicketData(nextData);
        persistTicketChanges(nextData, nextClients);
    };

    const handleRemoveClient = (clientId) => {
        const nextClients = selectedClients.filter((c) => String(c.id) !== String(clientId));
        const nextData = { ...ticketData, ...buildTicketDataForClientList(nextClients) };
        setSelectedClients(nextClients);
        setTicketData(nextData);
        persistTicketChanges(nextData, nextClients);
    };

    // Prefixo usado nos clientes adicionados automaticamente a partir de um grupo.
    const GROUP_CLIENT_PREFIX = 'group-company-';

    // Seleciona um grupo: expande todos os membros (empresas) em ticket_clients,
    // vinculando-os a este único ticket.
    const handleGroupSelect = async (groupId) => {
        if (!groupId || !canEditTicket) return;
        const group = clientGroups.find((g) => String(g.id) === String(groupId));
        setApplyingGroup(true);
        try {
            const { data } = await http.get(`/client-groups/${groupId}`);
            const companies = Array.isArray(data?.companies) ? data.companies : [];
            const existingCompanyIds = new Set(
                selectedClients.map((c) => String(c.company?.id)).filter(Boolean)
            );
            const newEntries = companies
                .filter((co) => co?.id && !existingCompanyIds.has(String(co.id)))
                .map((co) => ({
                    id: `${GROUP_CLIENT_PREFIX}${co.id}`,
                    name: co.name || co.code || 'Cliente',
                    fromGroup: true,
                    company: {
                        id: co.id,
                        code: co.code,
                        name: co.name,
                        business_name: co.name,
                    },
                }));
            const nextClients = [...selectedClients, ...newEntries];
            const nextData = {
                ...ticketData,
                ...buildTicketDataForClientList(nextClients),
                client_group_id: group?.id || Number(groupId) || null,
            };
            setSelectedClients(nextClients);
            setTicketData(nextData);
            persistTicketChanges(nextData, nextClients);
            if (!companies.length) {
                toast.info('Este grupo ainda não tem empresas vinculadas.');
            } else if (!newEntries.length) {
                toast.info('Todos os clientes deste grupo já estavam no ticket.');
            } else {
                toast.success(`${newEntries.length} cliente(s) do grupo adicionados ao ticket.`);
            }
        } catch (e) {
            toast.error('Não foi possível carregar os clientes do grupo.');
        } finally {
            setApplyingGroup(false);
        }
    };

    // Remove o vínculo de grupo e os clientes que haviam sido adicionados por ele
    // (mantém os clientes incluídos manualmente).
    const handleClearGroup = () => {
        if (!canEditTicket) return;
        const nextClients = selectedClients.filter(
            (c) => !String(c.id).startsWith(GROUP_CLIENT_PREFIX)
        );
        const nextData = {
            ...ticketData,
            ...buildTicketDataForClientList(nextClients),
            client_group_id: null,
        };
        setSelectedClients(nextClients);
        setTicketData(nextData);
        persistTicketChanges(nextData, nextClients);
    };

    // Grupo aplicado ao ticket atual (derivado — nunca vaza entre tickets).
    const selectedGroupId = ticketData?.client_group_id ? String(ticketData.client_group_id) : '';

    const handleAssignToMe = () => {
        if (!canEditTicket) return;
        handleInputChange(null, props.currentUser.id, 'assigned_to');
    };

    /**
     * Atribuir o chamado a um DEPARTAMENTO, e não a uma pessoa.
     *
     * Pedido da Gisele (18/10/2026): poder escolher o departamento na mesma
     * lista de responsáveis, clicando no título da seção.
     *
     * O chamado fica **"Não atribuído"** na lista e no kanban -- `assigned_to`
     * vai a nulo de propósito, porque ninguém assumiu --, e ao mesmo tempo
     * entra nos filtros daquele departamento, pela coluna `service_group_id`.
     * Os dois campos existem separados justamente para isso: sem a coluna, as
     * duas metades do pedido seriam contraditórias.
     *
     * Grava os dois numa gravação só. Em duas, o salvamento do meio deixaria o
     * chamado um instante sem responsável E sem departamento -- e é nesse
     * instante que o kanban recarrega.
     */
    /**
     * Uma opção de seletor para cada departamento.
     *
     * O `id` leva prefixo para nunca colidir com id de usuário, que é número.
     * `name` é o que a caixa mostra, porque é dele que o `getOptionLabel` do
     * Autocomplete tira o rótulo.
     */
    const opcoesDeDepartamento = useMemo(
        () => (departamentos || []).map((g) => ({
            id: `departamento:${g.id}`,
            name: g.description || g.code || `#${g.id}`,
            ehDepartamento: true,
            departamentoId: g.id,
        })),
        [departamentos]
    );

    /**
     * O que a caixa de Responsável mostra: a pessoa, o departamento, ou nada.
     *
     * A ordem importa. `assigned_to` preenchido ganha sempre -- um chamado
     * pode ter responsável E `service_group_id` (o do responsável), e mostrar
     * o departamento ali esconderia quem está cuidando dele.
     */
    const valorDoResponsavel = useMemo(() => {
        const pessoa = operadoresParaOSeletor.find((u) => Number(u.id) === Number(ticketData.assigned_to));

        if (pessoa) return pessoa;
        if (ticketData.assigned_to) return null;

        return opcoesDeDepartamento.find((o) => Number(o.departamentoId) === Number(ticketData.service_group_id)) || null;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [operadoresParaOSeletor, opcoesDeDepartamento, ticketData.assigned_to, ticketData.service_group_id]);

    const escolherDepartamentoComoResponsavel = (departamento) => {
        if (!canEditTicket || !departamento?.id) return;

        const nextData = { ...ticketData, assigned_to: null, service_group_id: departamento.id };

        setTicketData(nextData);
        setAssigneeOpen(false);

        if (!isNewTicket && (ticketData?.id || id)) {
            persistTicketChanges(nextData, selectedClients);
        }

        toast.success(`Chamado atribuído ao departamento ${departamento.description || departamento.code}.`);
    };

    const handleRemoveTicket = (ticketId) => {
        if (isNewTicket) {
            props.history.goBack();
        } else {
            props.history.goBack();
            const updatedViewedTickets = viewedTickets.filter(t => t.id !== ticketId);
            props.setViewedTickets(updatedViewedTickets);
        }
    };

    const modules = useMemo(() => ({
        toolbar: {
            container: [
                ["bold", "italic", "underline", "strike", "blockquote"],
                [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            ],
        },
        clipboard: {
            matchVisual: false,
        },
    }), []);

    const quillFormats = useMemo(() => [
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent', 'image',
    ], []);

    const CommentSkeletons = () => (
        <>
            <Typography variant="body2" color="textSecondary" sx={{ marginTop: '2rem' }}>Comentários</Typography>
            <Box sx={{
                border: '1px solid #e0e0e0', borderRadius: '8px', padding: '1rem 1rem 0 1rem',
                bgcolor: theme.palette.background.default, marginRight: 2, marginBottom: 2
            }}>
                {[1, 2, 3].map((index) => (
                    <Box key={index} sx={{
                        marginBottom: 2, backgroundColor: theme.palette.background.textField,
                        borderRadius: '8px',
                        padding: '0.4rem'
                    }}>
                        <Skeleton variant="text" width="40%" height={20} sx={{ marginBottom: 0.5 }} />
                        <Skeleton variant="text" width="100%" height={16} />
                        <Skeleton variant="text" width="80%" height={16} />
                    </Box>
                ))}
            </Box>
        </>
    );

    // Mostrar loading enquanto carrega o ticket
    if (loading) {
        return (
            <Box sx={{
                display: 'flex',
                height: '100vh',
                backgroundColor: theme.palette.background.default,
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Typography variant="h6">Carregando ticket...</Typography>
            </Box>
        );
    }

    // Campo de status (picker editável ou rótulo somente-leitura quando o ticket
    // já está resolvido/cancelado). Extraído para função porque agora é exibido
    // no cabeçalho do ticket (topo direito, como no Movidesk), não mais no
    // formulário lateral (item 39).
    const renderStatusField = () => {
        const statusRow = (ticketStatuses || []).find((s) => Number(s.id) === Number(ticketData.status_id));
        const resolvedOrCancelledIds = (ticketStatuses || [])
            .filter((s) => s.name === 'Resolvido' || s.name === 'Cancelado')
            .map((s) => s.id);
        const legacy = Number(ticketData.status);
        const isClosedLikeStatus =
            legacy === 3 ||
            legacy === 4 ||
            (ticketData.status_id != null &&
                ticketData.status_id !== '' &&
                resolvedOrCancelledIds.includes(Number(ticketData.status_id))) ||
            (statusRow && (statusRow.name === 'Resolvido' || statusRow.name === 'Cancelado'));

        let readOnlyLabel = '';
        if (statusRow) {
            const sub = (statusRow.substatuses || []).find(
                (s) => Number(s.id) === Number(ticketData.substatus_id)
            );
            readOnlyLabel = sub
                ? `${statusRow.name} · ${sub.name}`
                : statusRow.name;
        }
        if (!readOnlyLabel && legacy === 3) readOnlyLabel = 'Resolvido';
        if (!readOnlyLabel && legacy === 4) readOnlyLabel = 'Cancelado';

        if (isClosedLikeStatus) {
            return (
                <Box
                    aria-readonly="true"
                    sx={{
                        width: '100%',
                        minHeight: 36,
                        px: 1.5,
                        py: 0.75,
                        display: 'flex',
                        alignItems: 'center',
                        boxSizing: 'border-box',
                        borderRadius: 1,
                        border: `1px solid ${theme.palette.divider}`,
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                    }}
                >
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {readOnlyLabel || '—'}
                    </Typography>
                </Box>
            );
        }

        return (
            <StatusJustificationPicker
                statuses={editableTicketStatuses}
                statusId={ticketData.status_id}
                substatusId={ticketData.substatus_id}
                disabled={!canEditTicket}
                error={
                    (isNewTicket && (ticketData.status_id == null || ticketData.status_id === ''))
                    || faltaJustificativa(editableTicketStatuses, ticketData.status_id, ticketData.substatus_id)
                }
                helperText={avisoDeJustificativa(editableTicketStatuses, ticketData.status_id, ticketData.substatus_id)}
                onSelect={handleStatusJustificationChange}
                placeholder="Selecione o status ou a justificativa"
            />
        );
    };

    return (
        <Box sx={{
            display: 'flex',
            height: '100%',
            minHeight: 0,
            backgroundColor: theme.palette.background.default,
            overflow: 'hidden',
            position: 'relative'
        }}>
            <Prompt
                when={false}
                message="O ticket que você está abrindo ainda não foi salvo. Se você sair, as informações serão perdidas. Deseja continuar?"
            />

            {/*
              * Status, agenda, cronometro e fechar MORAVAM AQUI, numa caixa
              * `position: absolute` ancorada no canto da tela com
              * `z-index: 1000`. Mudaram para dentro da faixa do cabecalho, na
              * coluna das acoes -- veja la embaixo, em `clusterDoCabecalho`.
              *
              * O motivo nao e arrumacao: flutuando, eles COBRIAM o assunto.
              * Medido em 29/10/2026 com 1.024px de largura -- o titulo ocupava
              * x=427..859 e a barra, x=506..1014, passava por cima. Quem olhava
              * o chamado nessa largura simplesmente nao lia o assunto dele.
              *
              * Na faixa, a disputa por espaco vira reticencia no assunto em vez
              * de sobreposicao, e o cabecalho passa a dizer as duas coisas que
              * se quer saber de um chamado ao abri-lo: o que e, e onde esta.
              */}

            <Box
                sx={{
                    width: { xs: '100%', md: `${leftPanelWidth}%` },
                    minWidth: 0,
                    padding: 0.75,
                    borderRight: `1px solid ${theme.palette.divider}`,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],

                    // Labels/títulos de campos sem bold
                    '& .MuiTypography-body2': {
                        fontWeight: 400
                    },

                    // Densidade: campos mais baixos e mais juntos, no espírito do
                    // Movidesk — economiza espaço vertical mantendo todos os campos.
                    // Campos sem fundo, só borda (Outlined)
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: 'transparent',
                        minHeight: 30,
                        fontSize: '0.8125rem',
                    },
                    '& .MuiFilledInput-root': {
                        backgroundColor: 'transparent',
                        minHeight: 30,
                        fontSize: '0.8125rem',
                    },
                    '& .MuiInputBase-root': {
                        backgroundColor: 'transparent',
                        fontSize: '0.8125rem',
                    },
                    '& .MuiOutlinedInput-input, & .MuiFilledInput-input': {
                        py: 0.5,
                        px: 1.25,
                        fontSize: '0.8125rem',
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: '0.8125rem',
                    },
                    '& .MuiInputLabel-shrink': {
                        fontSize: '0.72rem',
                    },
                    '& .MuiFormControl-root': {
                        marginTop: '2px',
                        marginBottom: '5px',
                    },
                    '& .MuiTextField-root': {
                        marginTop: '1px',
                        marginBottom: '4px',
                    },
                    '& .MuiAutocomplete-root .MuiOutlinedInput-root': {
                        minHeight: 30,
                    },
                    '& textarea.MuiInputBase-input': {
                        minHeight: 52,
                        paddingTop: '6px',
                        paddingBottom: '6px',
                    },
                    '& .MuiSelect-select': {
                        backgroundColor: 'transparent !important'
                    },
                    '& .MuiInputBase-input::placeholder': {
                        color: `${theme.palette.text.secondary} !important`,
                        opacity: '1 !important'
                    },
                    '& textarea::placeholder': {
                        color: `${theme.palette.text.secondary} !important`,
                        opacity: '1 !important'
                    },

                    // Borda: não mudar ao focar, só no hover
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.divider
                    },
                    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main
                    },
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: `${theme.palette.divider} !important`
                    },
                    '& .MuiOutlinedInput-root.Mui-focused fieldset': {
                        borderColor: `${theme.palette.divider} !important`
                    },
                    '& .MuiOutlinedInput-root.Mui-focused:hover fieldset': {
                        borderColor: `${theme.palette.primary.main} !important`
                    },
                    '& .MuiOutlinedInput-root.Mui-focused': {
                        boxShadow: 'none'
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: theme.palette.text.secondary
                    }
                }}
            >

            {/* Divisor arrastável para redimensionar painel esquerdo */}
            {/** Apenas em telas md+ o redimensionamento faz sentido; em xs usamos 100% */}
            {/** O handle visual ficará entre os dois painéis, posicionado após este Box via CSS do contêiner pai */}

                {/*
                  * O protocolo e o assunto SAIRAM daqui (pontos 18 e 20 da
                  * Gisele, 20/10/2026: "protocolo e assunto em destaque, acima
                  * da área de ações").
                  *
                  * Eles viviam no topo desta coluna, que é a estreita e
                  * redimensionável: o assunto saía cortado com reticência em
                  * qualquer largura usável. Agora moram no topo da coluna das
                  * AÇÕES, que é a larga -- e esta coluna passa a começar pela
                  * busca de cliente, que é o ponto 18.
                  *
                  * O que sobrou aqui é o botão Criar, e ele fica: num chamado
                  * novo tudo o que se preenche está nesta coluna, e mandar o
                  * botão para a outra ponta da tela seria afastá-lo do
                  * trabalho. Por isso a faixa inteira some quando o chamado já
                  * existe, em vez de deixar uma linha vazia com uma borda.
                  */}
                {isNewTicket && (
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    marginBottom: 1,
                    paddingBottom: 0.75,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    flexShrink: 0,
                    gap: 1,
                }}>
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexShrink: 0 }}>
                            {/* O botao fica habilitado mesmo com campos faltando: e o clique
                                que dispara o aviso dizendo QUAIS faltam (handleCreateClick).
                                Desabilitado, o usuario so via um botao morto, sem explicacao. */}
                            <Button
                                onClick={handleCreateClick}
                                variant='contained'
                                color="primary"
                                size="small"
                                disabled={loading}
                            >
                                Criar
                            </Button>
                        </Box>
                </Box>
                )}

                <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', pr: 0.5 }}>
                {!isNewTicket && (
                    <>
                    {(ticketData?.merged_into_ticket_id || ticketData?.mergedIntoTicket?.id || ticketData?.merged_into_ticket?.id) && (
                        <Box
                            sx={{
                                backgroundColor: theme.palette.background.paper,
                                color: theme.palette.text.primary,
                                p: 1,
                                borderRadius: 1,
                                mb: 1,
                                border: `1px solid ${theme.palette.divider}`,
                            }}
                        >
                            <Typography variant="caption" sx={{ fontWeight: 600 }}>
                                Este ticket foi mesclado em{' '}
                                <Button
                                    size="small"
                                    variant="text"
                                    sx={{
                                        textTransform: 'none',
                                        minWidth: 0,
                                        p: 0,
                                        ml: 0.25,
                                        color: theme.palette.primary.main,
                                        fontWeight: 700,
                                        '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
                                    }}
                                    onClick={() => {
                                        const tid = ticketData?.mergedIntoTicket?.id || ticketData?.merged_into_ticket?.id || ticketData?.merged_into_ticket_id;
                                        if (tid) props.history.push(`/ticket/${tid}`);
                                    }}
                                >
                                    #{ticketData?.mergedIntoTicket?.number || ticketData?.merged_into_ticket?.number || '?'}
                                </Button>
                            </Typography>
                        </Box>
                    )}
                    {!!(Array.isArray(ticketData?.mergedFromTickets || ticketData?.merged_from_tickets) && (ticketData?.mergedFromTickets || ticketData?.merged_from_tickets).length > 0) && (
                        <Box
                            sx={{
                                backgroundColor: theme.palette.background.paper,
                                color: theme.palette.text.primary,
                                p: 1,
                                borderRadius: 1,
                                mb: 1,
                                border: `1px solid ${theme.palette.divider}`,
                            }}
                        >
                            <Typography
                                variant="caption"
                                sx={{
                                    fontWeight: 700,
                                    display: 'block',
                                    mb: 0.5,
                                    color: `${theme.palette.text.secondary} !important`,
                                }}
                            >
                                Tickets mesclados (originais):
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {(ticketData.mergedFromTickets || ticketData.merged_from_tickets).map((t) => (
                                    <Chip
                                        key={t.id}
                                        size="small"
                                        label={`#${t.number}${t.title ? ` — ${t.title}` : ''}`}
                                        onClick={() => props.history.push(`/ticket/${t.id}`)}
                                        variant="outlined"
                                        sx={{
                                            cursor: 'pointer',
                                            color: theme.palette.text.primary,
                                            borderColor: theme.palette.divider,
                                            '&:hover': {
                                                borderColor: theme.palette.primary.main,
                                                backgroundColor: theme.palette.action.hover,
                                            },
                                        }}
                                    />
                                ))}
                            </Box>
                        </Box>
                    )}
                    <Box sx={{
                        backgroundColor: theme.palette.background.paper,
                        padding: 1,
                        borderRadius: 1,
                        marginBottom: 1.5,
                        border: `1px solid ${theme.palette.text.primary}`,
                        flexShrink: 0
                    }}>
                        <Typography
                            variant="caption"
                            sx={{
                                color: `${theme.palette.text.primary} !important`,
                                fontSize: '0.75rem',
                                fontWeight: 500,
                            }}
                        >
                            Ticket aberto via sistema pelo agente {ticketData?.created_by?.name} em {formatDate(ticketData?.created_at)}
                        </Typography>
                    </Box>
                    </>
                )}

                {/*
                  * QUEM MAIS ESTÁ NESTE CHAMADO, e ele mudou? (Gisele, 23/10/2026)
                  *
                  * Fica no TOPO do formulário, antes de qualquer campo: o aviso
                  * existe para ser visto ANTES de a pessoa começar a digitar --
                  * depois disso, ele só informa que o trabalho já foi perdido.
                  *
                  * O componente só desenha algo quando há o que dizer, então
                  * não ocupa espaço no caso comum (ninguém mais no chamado).
                  */}
                {!isNewTicket && (
                    <PresencaNoChamado
                        ticketId={ticketData?.id || id}
                        ultimaAlteracaoEm={ultimaAlteracaoEm}
                        carimboCarregado={ticketData?.updated_at}
                        onAtualizar={() => setRecarregarEm((n) => n + 1)}
                    />
                )}

                {isNewTicket && (
                    <Box sx={{ marginBottom: 1.5, flexShrink: 0 }}>
                        <Typography variant="body2" sx={{
                            fontWeight: 'bold',
                            marginBottom: 1,
                            color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary
                        }}>
                            Assunto *
                        </Typography>
                        <TextField
                            value={ticketData.title}
                            name="title"
                            onChange={handleInputChange}
                            fullWidth
                            required
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    backgroundColor: theme.palette.background.default
                                }
                            }}
                        />
                    </Box>
                )}

                {/* Cliente */}
                <Box sx={{ marginBottom: 1 }}>
                    <Typography variant="body2" sx={{
                        fontWeight: 'bold',
                        marginBottom: 0.5,
                        color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                        fontSize: '12px'
                    }}>
                        Cliente *
                    </Typography>
                    {/*
                      Campo compacto: aqui ele serve so para PESQUISAR, e sai
                      de cena assim que o cliente e escolhido -- quem responde
                      "de quem e este chamado?" e o card, logo acima.

                      Pedido da Gisele (item 14): "ajustar o tamanho devido ser
                      so pesquisa".
                    */}
                    <ClientSearch
                        size="small"
                        onClientSelect={(client) => {
                            setExpandedClientIds({});
                            handleClientSelect(client);
                        }}
                        selectedClient={selectedClients[0] || null}
                        placeholder="Digite código (ex: 1405), nome ou CNPJ..."
                        hasError={isNewTicket && !(selectedClients?.length > 0)}
                        clientGroups={clientGroups}
                        onGroupSelect={canEditTicket ? (groupId) => handleGroupSelect(String(groupId)) : undefined}
                    />

                    {/*
                      * O SOLICITANTE INTERNO (Gisele, 23/10/2026).
                      *
                      * Fica junto do cliente porque responde a MESMA pergunta --
                      * "de quem e este chamado?" --, so que para o chamado que
                      * nasce dentro de casa. Um campo noutra aba faria o operador
                      * preencher um cliente de fachada antes de achar o certo.
                      *
                      * Nao e um `ClientSearch` estendido: aquele componente serve
                      * cinco telas e busca no cadastro de clientes do ERP. Mistura-lo
                      * com a lista de colaboradores mudaria o que ele significa em
                      * todas elas.
                      */}
                    <Box sx={{ mt: 1 }}>
                        <Typography variant="body2" sx={{
                            fontWeight: 'bold',
                            marginBottom: 0.5,
                            color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                            fontSize: '12px'
                        }}>
                            Solicitante interno
                        </Typography>
                        <Autocomplete
                            size="small"
                            options={users || []}
                            getOptionLabel={(opcao) => opcao?.name || ''}
                            isOptionEqualToValue={(opcao, valor) => Number(opcao?.id) === Number(valor?.id)}
                            value={solicitanteEscolhido}
                            disabled={!canEditTicket}
                            onChange={(e, escolhido) => {
                                handleInputChange(null, escolhido ? escolhido.id : null, 'requester');
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Colaborador que pediu (chamado interno)"
                                    inputProps={{ ...params.inputProps, 'data-testid': 'solicitante-interno' }}
                                />
                            )}
                        />
                    </Box>

                    {/* Seleção por grupo de clientes: adiciona todos os membros ao ticket */}
                    {clientGroups.length > 0 && (
                        <Box sx={{ mt: 0.75, display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                            <Select
                                size="small"
                                displayEmpty
                                value={selectedGroupId}
                                disabled={!canEditTicket || applyingGroup}
                                onChange={(e) => handleGroupSelect(e.target.value)}
                                sx={{ minWidth: 220, flex: 1, fontSize: '0.8125rem' }}
                                renderValue={(val) => {
                                    if (!val) return <span style={{ opacity: 0.6 }}>Ou selecione um grupo de clientes…</span>;
                                    const g = clientGroups.find((x) => String(x.id) === String(val));
                                    return g ? g.name : 'Grupo';
                                }}
                            >
                                <MenuItem value="" disabled>
                                    Selecione um grupo…
                                </MenuItem>
                                {clientGroups.map((g) => (
                                    <MenuItem key={g.id} value={String(g.id)} sx={{ fontSize: '0.8125rem' }}>
                                        {g.name}
                                        {typeof g.companies_count === 'number' ? ` (${g.companies_count})` : ''}
                                    </MenuItem>
                                ))}
                            </Select>
                            {applyingGroup && <CircularProgress size={16} />}
                            {selectedGroupId && !applyingGroup && (
                                <Chip
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                    label={`Grupo: ${clientGroups.find((x) => String(x.id) === String(selectedGroupId))?.name || ''}`}
                                    onDelete={canEditTicket ? handleClearGroup : undefined}
                                />
                            )}
                        </Box>
                    )}

                </Box>

                {/*
                  A BUSCA vem primeiro, e os dados do cliente logo abaixo dela
                  (pontos 18 e 19 da Gisele, 20/10/2026: "a pesquisa do cliente
                  vira o primeiro campo, no canto superior esquerdo" e "os dados
                  do cliente ficam logo abaixo dela").

                  Isto INVERTE o arranjo de 14/10, que era pedido dela também:
                  o card vinha antes da busca, "em destaque logo abaixo do
                  assunto". O assunto saiu desta coluna no mesmo dia (ponto 20),
                  então aquele "logo abaixo do assunto" deixou de existir aqui --
                  e o que sobrava era um card empurrando a busca para baixo da
                  dobra num chamado com vários registros.

                  Quem vier mexer nisso de novo: as duas ordens já foram pedidas
                  pela mesma pessoa, com meses de diferença. A diferença entre
                  elas é o que está em cima na coluna.
                */}
                {/* Cards de clientes adicionados ao ticket */}
                {selectedClients.length > 0 && (
                    <Box sx={{ mt: 0.75 }} data-testid="dados-do-cliente">
                        {selectedClients.length > 1 && (
                            <Box
                                onClick={() => setClientsCollapsed((v) => !v)}
                                sx={{ display: 'flex', alignItems: 'center', gap: 0.25, cursor: 'pointer', mb: 0.5, userSelect: 'none' }}
                            >
                                <IconButton size="small" sx={{ p: 0.25 }} aria-label="Minimizar registros">
                                    {clientsCollapsed ? <ExpandMore fontSize="small" /> : <ExpandLess fontSize="small" />}
                                </IconButton>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontWeight: 600 }}>
                                    {clientsCollapsed
                                        ? `Mostrar todos os ${selectedClients.length} registros`
                                        : `${selectedClients.length} registros`}
                                </Typography>
                            </Box>
                        )}
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 0.5,
                                // No maximo ~3 cards visiveis; passando disso, rola.
                                // Enquanto algum card estiver com "detalhes" aberto, solta o
                                // limite pra mostrar o conteudo inteiro; ao minimizar, volta ao normal.
                                ...(!clientsCollapsed
                                    && selectedClients.length > 3
                                    && !Object.values(expandedClientIds).some(Boolean)
                                    ? { maxHeight: 216, overflowY: 'auto', pr: 0.5 }
                                    : {}),
                            }}
                        >
                            {(clientsCollapsed ? selectedClients.slice(0, 1) : selectedClients).map((client) => {
                            const key = `${client.id}-${client.company?.id || client.company?.name || ''}`;
                            const isExpanded = !!expandedClientIds[key];
                            const statusInfo = getClientStatusInfo(client.company?.active, theme);
                            return (
                                <Box
                                    key={key}
                                    sx={{
                                        py: 0.75,
                                        px: 1,
                                        backgroundColor: theme.palette.background.paper,
                                        borderRadius: 'var(--radius-md, 10px)',
                                        border: `1px solid ${theme.palette.divider}`,
                                        boxShadow: theme.palette.mode === 'dark'
                                            ? 'none'
                                            : '0 1px 2px rgba(0,0,0,0.04)',
                                    }}
                                >
                                    {/*
                                      * QUEBRA A LINHA quando os botoes nao cabem.
                                      *
                                      * O grupo de acoes a direita e `flexShrink: 0` e mede
                                      * 138px. Numa coluna de 192px ele ficava com 72% do
                                      * card e empurrava o lado do conteudo para 48px --
                                      * medido em 30/10/2026. Nesses 48px moravam o NOME do
                                      * cliente (cortado) e as seis etiquetas, com o valor
                                      * de "Loja" renderizado em 11px de largura.
                                      *
                                      * Ou seja: o card gastava a largura com tres botoes e
                                      * truncava justamente o unico campo que tinha conteudo.
                                      */}
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 0.75, flexWrap: 'wrap', rowGap: 0.5 }}>
                                        <Box sx={{ flex: '1 1 160px', minWidth: 0 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5, minWidth: 0 }}>
                                                <Typography
                                                    variant="body2"
                                                    noWrap
                                                    sx={{
                                                        fontWeight: 600,
                                                        fontSize: '0.8125rem',
                                                        lineHeight: 1.3,
                                                        color: 'text.primary',
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    {client.company?.business_name || client.company?.name || client.name || 'Cliente sem nome'}
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: 0.5,
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {[
                                                    {
                                                        short: 'Loja',
                                                        label: 'Nome fantasia',
                                                        value: client.company?.name || client.company?.business_name || '-',
                                                    },
                                                    {
                                                        short: 'Cód.',
                                                        label: 'Código',
                                                        value: client.company?.code || '-',
                                                    },
                                                    {
                                                        // Tipo = linha do produto (Sysfar / Next / Max).
                                                        //
                                                        // A regra mora em utils/linhaDoProduto.js desde que o
                                                        // resultado da BUSCA passou a mostrar o mesmo rótulo:
                                                        // duas cópias divergiriam, e a que ficasse para trás
                                                        // diria um tipo diferente para a mesma empresa em
                                                        // duas telas.
                                                        short: 'Tipo',
                                                        label: 'Tipo',
                                                        value: linhaDoProduto(client.company) || '-',
                                                    },
                                                    {
                                                        // Aplicacao = produto completo (antigo rotulo "Tipo").
                                                        short: 'Aplic.',
                                                        label: 'Aplicação',
                                                        value: client.company?.product_description || '-',
                                                    },
                                                    {
                                                        // Representante = service_group_description (mesma origem do
                                                        // filtro "Representante" e do painel do chat). business_name
                                                        // e a razao social da propria loja, nao o representante.
                                                        short: 'Rep.',
                                                        label: 'Representante',
                                                        value: client.company?.service_group_description || '-',
                                                    },
                                                    {
                                                        short: 'Ver.',
                                                        label: 'Versão',
                                                        value: client.company?.version_in_use || '-',
                                                    },
                                                ].map((item) => (
                                                    <Tooltip key={item.label} title={`${item.label}: ${item.value}`} arrow>
                                                        <Box
                                                            sx={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: 0.4,
                                                                maxWidth: '100%',
                                                                /*
                                                                  * Sem isto, as etiquetas se
                                                                  * espremem umas nas outras em
                                                                  * vez de descer de linha: o
                                                                  * contorno continua la, com o
                                                                  * valor reduzido a uma letra e
                                                                  * reticencia. Encolher so e
                                                                  * aceitavel quando ainda sobra
                                                                  * texto para ler.
                                                                  */
                                                                flexShrink: 0,
                                                                px: 0.75,
                                                                py: 0.2,
                                                                borderRadius: 'var(--radius-sm, 8px)',
                                                                bgcolor: alpha(
                                                                    theme.palette.primary.main,
                                                                    theme.palette.mode === 'dark' ? 0.12 : 0.06
                                                                ),
                                                                border: '1px solid',
                                                                borderColor: alpha(theme.palette.primary.main, 0.12),
                                                            }}
                                                        >
                                                            <Typography
                                                                component="span"
                                                                sx={{
                                                                    fontSize: '10px',
                                                                    fontWeight: 700,
                                                                    color: 'primary.main',
                                                                    lineHeight: 1.2,
                                                                }}
                                                            >
                                                                {item.short}
                                                            </Typography>
                                                            <Typography
                                                                component="span"
                                                                noWrap
                                                                sx={{
                                                                    fontSize: '11px',
                                                                    fontWeight: 500,
                                                                    color: 'text.primary',
                                                                    lineHeight: 1.2,
                                                                    maxWidth: { xs: 88, sm: 120 },
                                                                }}
                                                            >
                                                                {item.value}
                                                            </Typography>
                                                        </Box>
                                                    </Tooltip>
                                                ))}
                                                {statusInfo && (
                                                    <Tooltip title={`Status do cliente: ${statusInfo.label}`} arrow>
                                                        <Box
                                                            component="span"
                                                            sx={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                px: 0.75,
                                                                py: 0.2,
                                                                borderRadius: 'var(--radius-sm, 8px)',
                                                                fontSize: '10px',
                                                                fontWeight: 700,
                                                                lineHeight: 1.4,
                                                                whiteSpace: 'nowrap',
                                                                color: statusInfo.color,
                                                                bgcolor: alpha(statusInfo.color, 0.15),
                                                                border: `1px solid ${alpha(statusInfo.color, 0.3)}`,
                                                            }}
                                                        >
                                                            {statusInfo.label}
                                                        </Box>
                                                    </Tooltip>
                                                )}
                                            </Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, flexShrink: 0, pt: 0.1 }}>
                                            <Tooltip title="Ver tickets deste cliente" arrow>
                                                <span>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => {
                                                            const cid = Number(client?.id);
                                                            if (!Number.isNaN(cid) && cid > 0) {
                                                                props.history.push(`/cliente/${cid}/tickets`);
                                                            }
                                                        }}
                                                        disabled={!(Number(client?.id) > 0)}
                                                        sx={{
                                                            border: `1px solid ${theme.palette.divider}`,
                                                            width: 24,
                                                            height: 24,
                                                            color: theme.palette.primary.main,
                                                            '&:hover': {
                                                                backgroundColor: theme.palette.action.hover,
                                                                borderColor: theme.palette.primary.main,
                                                            },
                                                        }}
                                                    >
                                                        <LaunchOutlinedIcon sx={{ fontSize: 14 }} />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={() =>
                                                    setExpandedClientIds((prev) => ({
                                                        ...prev,
                                                        [key]: !prev[key]
                                                    }))
                                                }
                                                sx={{
                                                    textTransform: 'none',
                                                    fontSize: '10px',
                                                    minWidth: 0,
                                                    px: 0.75,
                                                    py: 0.15,
                                                    lineHeight: 1.3,
                                                    borderRadius: 'var(--radius-sm, 8px)',
                                                }}
                                            >
                                                {isExpanded ? 'Ocultar' : 'Detalhes'}
                                            </Button>
                                            <IconButton
                                                size="small"
                                                onClick={() => handleRemoveClient(client.id)}
                                                sx={{ width: 24, height: 24 }}
                                            >
                                                <CloseSharp sx={{ fontSize: 14 }} />
                                            </IconButton>
                                        </Box>
                                    </Box>

                                    {/*
                                        A OBSERVAÇÃO do cliente (Gisele, 19/10/2026).

                                        FORA do `isExpanded` de propósito: ela é um aviso
                                        sobre como atender aquele cliente, e um aviso que só
                                        aparece depois de clicar em "expandir" não é aviso. Os
                                        campos de cadastro abaixo seguem recolhidos -- eles se
                                        consultam, esta se lê sem pedir.

                                        `onMudou` atualiza `selectedClients`, que é estado
                                        local desta tela, como faz a fase: o cartão redesenha
                                        na hora, sem recarregar o chamado.
                                    */}
                                    {client.company && (
                                        <Box sx={{ mt: 0.75 }}>
                                            <ObservacaoDoCliente
                                                empresa={client.company}
                                                onMudou={(empresaAtualizada) => setSelectedClients((anteriores) => anteriores.map((c) => (
                                                    Number(c.company?.id) === Number(empresaAtualizada?.id)
                                                        ? { ...c, company: { ...c.company, ...empresaAtualizada } }
                                                        : c
                                                )))}
                                            />
                                        </Box>
                                    )}

                                    {isExpanded && client.company && (
                                        <Box sx={{
                                            columnCount: { xs: 1, sm: 2 },
                                            columnGap: 2,
                                            mt: 0.5,
                                            pt: 0.5,
                                            borderTop: `1px solid ${theme.palette.divider}`,
                                            // Colunas CSS: cada campo ocupa só a altura natural (sem
                                            // vãos entre colunas do grid). break-inside evita quebrar
                                            // um campo entre colunas.
                                            '& > *': { breakInside: 'avoid', mb: 0.75 },
                                        }}>
                            {/* Produto e Representante: fixos aqui, independentes da
                                configuracao de campos do filtro (que so afeta lista/kanban). */}
                            <Box>
                                <Typography sx={{
                                    color: theme.palette.text.secondary,
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    display: 'block',
                                    marginBottom: 0.25
                                }}>
                                    Produto
                                </Typography>
                                <Typography variant="body2" sx={{
                                    color: theme.palette.text.primary,
                                    fontSize: '13px',
                                    fontWeight: 400,
                                    lineHeight: 1.3
                                }}>
                                    {client.company?.product_description || '-'}
                                </Typography>
                            </Box>

                            <Box>
                                <Typography sx={{
                                    color: theme.palette.text.secondary,
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    display: 'block',
                                    marginBottom: 0.25
                                }}>
                                    Representante
                                </Typography>
                                <Typography variant="body2" sx={{
                                    color: theme.palette.text.primary,
                                    fontSize: '13px',
                                    fontWeight: 400,
                                    lineHeight: 1.3
                                }}>
                                    {client.company?.service_group_description || '-'}
                                </Typography>
                            </Box>

                            {/*
                                Fase do relacionamento (item 7): fixa aqui,
                                junto de Produto e Representante, e nao vinda
                                da configuracao de campos do filtro.

                                O rotulo chega pronto da api
                                (`relationship_phase_label`); um mapa aqui
                                seria a segunda copia da lista de fases.
                            */}
                            <Box>
                                <Typography sx={{
                                    color: theme.palette.text.secondary,
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    display: 'block',
                                    marginBottom: 0.25
                                }}>
                                    Fase
                                </Typography>
                                <Typography variant="body2" sx={{
                                    color: theme.palette.text.primary,
                                    fontSize: '13px',
                                    fontWeight: 400,
                                    lineHeight: 1.3
                                }}>
                                    {/*
                                        Mudavel aqui mesmo (pedido de 05/10).
                                        `onMudou` atualiza `selectedClients`,
                                        que e estado local desta tela -- assim
                                        o cartao redesenha na hora, sem
                                        recarregar o chamado.
                                    */}
                                    <FaseDoRelacionamento
                                        empresa={client.company}
                                        fases={fasesDoRelacionamento}
                                        semValor="-"
                                        // O destaque (3o bloco da Gisele): aqui a
                                        // fase dividia um grid com Codigo, Endereco
                                        // e Telefone, toda em 13px, e desaparecia --
                                        // sendo o dado que muda COMO se atende.
                                        variante="destaque"
                                        onMudou={(empresaAtualizada) => setSelectedClients((anteriores) => anteriores.map((c) => (
                                            Number(c.company?.id) === Number(empresaAtualizada.id)
                                                ? { ...c, company: { ...c.company, ...empresaAtualizada } }
                                                : c
                                        )))}
                                    />
                                </Typography>
                            </Box>

                            {/* Endereço */}
                            <Box sx={{ gridColumn: { xs: '1', sm: client.company.code ? '2' : '2' } }}>
                                <Typography sx={{
                                    color: theme.palette.text.secondary,
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    display: 'block',
                                    marginBottom: 0.25
                                }}>
                                    Endereço
                                </Typography>
                                <Typography variant="body2" sx={{
                                    color: theme.palette.text.primary,
                                    fontSize: '13px',
                                    fontWeight: 400,
                                    lineHeight: 1.3
                                }}>
                                    {formatAddress(client.company)}
                                </Typography>
                            </Box>

                            {/* E-mail da loja */}
                            <Box>
                                <Typography sx={{
                                    color: theme.palette.text.secondary,
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    display: 'block',
                                    marginBottom: 0.25
                                }}>
                                    E-mail da loja
                                </Typography>
                                <Typography variant="body2" sx={{
                                    color: theme.palette.text.primary,
                                    fontSize: '13px',
                                    fontWeight: 400,
                                    lineHeight: 1.3
                                }}>
                                    {client.company?.email || '-'}
                                </Typography>
                            </Box>

                            {/* Telefone da loja */}
                            <Box>
                                <Typography sx={{
                                    color: theme.palette.text.secondary,
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    display: 'block',
                                    marginBottom: 0.25
                                }}>
                                    Telefone da loja
                                </Typography>
                                <Typography variant="body2" sx={{
                                    color: theme.palette.text.primary,
                                    fontSize: '13px',
                                    fontWeight: 400,
                                    lineHeight: 1.3
                                }}>
                                    {formatCompanyPhone(client.company) || '-'}
                                </Typography>
                            </Box>

                            {/* Telefones adicionais (cadastro manual) */}
                            <Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                                    <Typography sx={{
                                        color: theme.palette.text.secondary,
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                    }}>
                                        Telefones adicionais
                                    </Typography>
                                    {canEditTicket && (
                                        <Tooltip title="Gerenciar telefones" arrow>
                                            <IconButton size="small" onClick={() => openPhonesDialog(client.company)} sx={{ p: 0.25 }}>
                                                <EditOutlinedIcon sx={{ fontSize: 15 }} />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </Box>
                                {getManualPhones(client.company).length > 0 ? (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {getManualPhones(client.company).map((ph, i) => {
                                            const base = ph.name ? `${ph.name}: ${ph.phone}` : ph.phone;
                                            // A observação (WhatsApp, gerente, balconista...) fica no
                                            // próprio chip: é o que identifica o contato de relance.
                                            const label = ph.note ? `${base} · ${ph.note}` : base;
                                            return (
                                                <Tooltip key={`${ph.phone}-${i}`} title={label} arrow>
                                                    <Chip size="small" label={label} variant="outlined" />
                                                </Tooltip>
                                            );
                                        })}
                                    </Box>
                                ) : (
                                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontSize: '13px' }}>
                                        Nenhum telefone adicional.
                                    </Typography>
                                )}
                            </Box>

                            {/* Classificação */}
                            <Box>
                                <Typography sx={{
                                    color: theme.palette.text.secondary,
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    display: 'block',
                                    marginBottom: 0.25
                                }}>
                                    Classificação
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                    {(() => {
                                        // Buscar classificacao em diferentes formatos possíveis
                                        const classificationValue = client.company.classificacao 
                                            || client.company.classification 
                                            || null;

                                        if (classificationValue != null && classificationValue >= 1 && classificationValue <= 5) {
                                            return (
                                                <>
                                                    <Box sx={{ 
                                                        '& .MuiRating-iconFilled': {
                                                            color: '#FFD700',
                                                            '& svg': {
                                                                fill: '#FFD700'
                                                            }
                                                        },
                                                        '& .MuiRating-iconEmpty': {
                                                            color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300],
                                                            '& svg': {
                                                                fill: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300]
                                                            }
                                                        }
                                                    }}>
                                                        <Rating
                                                            value={classificationValue}
                                                            max={5}
                                                            readOnly
                                                            size="small"
                                                        />
                                                    </Box>
                                                </>
                                            );
                                        } else {
                                            return (
                                                <Typography variant="body2" sx={{
                                                    color: theme.palette.text.secondary,
                                                    fontSize: '14px',
                                                    fontWeight: 400,
                                                    fontStyle: 'italic'
                                                }}>
                                                    Sem classificação
                                                </Typography>
                                            );
                                        }
                                    })()}
                                </Box>
                            </Box>

                            {/* Informações Financeiras */}
                            {/* Sempre mostrar seção financeira, mesmo que valores sejam zero/null */}
                            {canViewFinancialInfo ? (
                                <Box>
                                    <Typography sx={{
                                        color: theme.palette.text.secondary,
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        display: 'block',
                                        marginBottom: 0.25
                                    }}>
                                        Fatura
                                    </Typography>
                                    
                                    {/* Mensalidade */}
                                    <Box sx={{ mb: 0.25 }}>
                                        <Typography variant="body2" sx={{
                                            color: theme.palette.text.secondary,
                                            fontSize: '12px',
                                            display: 'inline-block',
                                            mr: 1
                                        }}>
                                            Mensalidade:
                                        </Typography>
                                        <Typography variant="body2" component="span" sx={{
                                            color: theme.palette.text.primary,
                                            fontSize: '14px',
                                            fontWeight: 500
                                        }}>
                                            {(() => {
                                                // Verificar múltiplas possibilidades de nome do campo
                                                const valor = client.company.valor_mensalidade 
                                                    || client.company.valorMensalidade 
                                                    || client.company.monthly_fee 
                                                    || null;
                                                if (valor === null || valor === undefined || valor === '') {
                                                    return 'R$ 0,00';
                                                }
                                                const valorNum = parseFloat(String(valor).replace(',', '.')) || 0;
                                                return `R$ ${valorNum.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                                            })()}
                                        </Typography>
                                    </Box>
                                    
                                    {/* Módulos */}
                                    <Box sx={{ mb: 0.25 }}>
                                        <Typography variant="body2" sx={{
                                            color: theme.palette.text.secondary,
                                            fontSize: '12px',
                                            display: 'inline-block',
                                            mr: 1
                                        }}>
                                            Módulos:
                                        </Typography>
                                        <Typography variant="body2" component="span" sx={{
                                            color: theme.palette.text.primary,
                                            fontSize: '14px',
                                            fontWeight: 500
                                        }}>
                                            {(() => {
                                                const valor = client.company.valor_modulos 
                                                    || client.company.valorModulos 
                                                    || null;
                                                if (valor === null || valor === undefined || valor === '') {
                                                    return 'R$ 0,00';
                                                }
                                                const valorNum = parseFloat(String(valor).replace(',', '.')) || 0;
                                                return `R$ ${valorNum.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                                            })()}
                                        </Typography>
                                    </Box>
                                    
                                    {/* Desconto */}
                                    <Box sx={{ mb: 0.25 }}>
                                        <Typography variant="body2" sx={{
                                            color: theme.palette.text.secondary,
                                            fontSize: '12px',
                                            display: 'inline-block',
                                            mr: 1
                                        }}>
                                            Desconto:
                                        </Typography>
                                        <Typography variant="body2" component="span" sx={{
                                            color: (() => {
                                                const valor = client.company.valor_desconto || client.company.valorDesconto || null;
                                                return (valor && parseFloat(String(valor).replace(',', '.')) > 0) ? theme.palette.success.main : theme.palette.text.primary;
                                            })(),
                                            fontSize: '14px',
                                            fontWeight: 500
                                        }}>
                                            {(() => {
                                                const valor = client.company.valor_desconto 
                                                    || client.company.valorDesconto 
                                                    || null;
                                                if (valor === null || valor === undefined || valor === '') {
                                                    return 'R$ 0,00';
                                                }
                                                const valorNum = parseFloat(String(valor).replace(',', '.')) || 0;
                                                return `R$ ${valorNum.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                                            })()}
                                        </Typography>
                                    </Box>
                                    
                                    {/* Total */}
                                    {(() => {
                                        const mensalidade = parseFloat(String(client.company.valor_mensalidade || client.company.valorMensalidade || client.company.monthly_fee || 0).replace(',', '.')) || 0;
                                        const modulos = parseFloat(String(client.company.valor_modulos || client.company.valorModulos || 0).replace(',', '.')) || 0;
                                        const desconto = parseFloat(String(client.company.valor_desconto || client.company.valorDesconto || 0).replace(',', '.')) || 0;
                                        const total = mensalidade + modulos - desconto;
                                        
                                        return (
                                            <Box sx={{ mb: 0.25, pt: 0.5, borderTop: `1px solid ${theme.palette.divider}` }}>
                                                <Typography variant="body2" sx={{
                                                    color: theme.palette.text.secondary,
                                                    fontSize: '12px',
                                                    display: 'inline-block',
                                                    mr: 1,
                                                    fontWeight: 600
                                                }}>
                                                    Total:
                                                </Typography>
                                                <Typography variant="body2" component="span" sx={{
                                                    color: theme.palette.text.primary,
                                                    fontSize: '15px',
                                                    fontWeight: 600
                                                }}>
                                                    R$ {total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </Typography>
                                            </Box>
                                        );
                                    })()}
                                    
                                    {/* Dia Pagamento */}
                                    {client.company.dia_pagamento && (
                                        <Box sx={{ mb: 0.25 }}>
                                            <Typography variant="body2" sx={{
                                                color: theme.palette.text.secondary,
                                                fontSize: '12px',
                                                display: 'inline-block',
                                                mr: 1
                                            }}>
                                                Dia Pagamento:
                                            </Typography>
                                            <Typography variant="body2" component="span" sx={{
                                                color: theme.palette.text.primary,
                                                fontSize: '14px',
                                                fontWeight: 500
                                            }}>
                                                {client.company.dia_pagamento}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            ) : (
                                <Box sx={{ mb: 0.25 }}>
                                    <Typography variant="body2" sx={{
                                        color: theme.palette.text.secondary,
                                        fontSize: '12px',
                                        fontStyle: 'italic'
                                    }}>
                                        Informações financeiras ocultas para o seu perfil.
                                    </Typography>
                                </Box>
                            )}

                            {/* Dia de Pagamento */}
                            {client.company.dia_pagamento && (
                                <Box>
                                    <Typography sx={{
                                        color: theme.palette.text.secondary,
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        display: 'block',
                                        marginBottom: 0.25
                                    }}>
                                        Dia de Pagamento
                                    </Typography>
                                    <Typography variant="body2" sx={{
                                        color: theme.palette.text.primary,
                                        fontSize: '14px',
                                        fontWeight: 500
                                    }}>
                                        Dia {client.company.dia_pagamento}
                                    </Typography>
                                </Box>
                            )}

                            {/* Módulos Ativos */}
                            <Box>
                                <Typography sx={{
                                    color: theme.palette.text.secondary,
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    display: 'block',
                                    marginBottom: 0.25
                                }}>
                                    Módulos Ativos
                                </Typography>
                                {(() => {
                                    // Tratar active_modules que pode vir como JSON string ou array
                                    let modulesArray = [];
                                    
                                    if (client.company.active_modules) {
                                        try {
                                            // Se for string JSON, fazer parse
                                            if (typeof client.company.active_modules === 'string') {
                                                const trimmed = client.company.active_modules.trim();
                                                // Verificar se é string vazia ou apenas espaços
                                                if (trimmed === '' || trimmed === '[]' || trimmed === 'null') {
                                                    modulesArray = [];
                                                } else {
                                                    const parsed = JSON.parse(trimmed);
                                                    modulesArray = Array.isArray(parsed) ? parsed : [parsed];
                                                }
                                            } else if (Array.isArray(client.company.active_modules)) {
                                                modulesArray = client.company.active_modules;
                                            }
                                        } catch (e) {
                                            // Não é JSON: formato separado por pipe/vírgula/ponto-e-vírgula
                                            // (ex.: "SNGPC|FPOP|NFCE"). Quebra em itens individuais.
                                            const strValue = String(client.company.active_modules).trim();
                                            if (strValue && strValue !== '' && strValue !== '[]') {
                                                modulesArray = strValue.split(/[|,;]/);
                                            }
                                        }
                                    }
                                    
                                    // Fallback para módulos antigos
                                    if (modulesArray.length === 0 && client.company.modules) {
                                        const modulesValue = client.company.modules;
                                        if (Array.isArray(modulesValue) && modulesValue.length > 0) {
                                            modulesArray = modulesValue;
                                        } else if (typeof modulesValue === 'string' && modulesValue.trim() !== '') {
                                            modulesArray = [modulesValue];
                                        }
                                    }
                                    
                                    // Filtrar valores vazios ou nulos
                                    modulesArray = modulesArray.filter(m => m !== null && m !== undefined && String(m).trim() !== '');
                                    
                                    if (modulesArray.length === 0) {
                                        return (
                                            <Typography variant="body2" sx={{
                                                color: theme.palette.text.secondary,
                                                fontSize: '14px',
                                                fontStyle: 'italic'
                                            }}>
                                                Nenhum módulo ativo
                                            </Typography>
                                        );
                                    }
                                    
                                    // Item 5: cada módulo vira um chip (antes: tudo junto
                                    // numa string truncada em 25 chars) — leitura muito melhor.
                                    const moduleLabel = (m) => (m && typeof m === 'object')
                                        ? (m.name || m.description || m.code || JSON.stringify(m))
                                        : String(m).trim();
                                    return (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.25 }}>
                                            {modulesArray.map((mod, i) => (
                                                <Box
                                                    key={`${moduleLabel(mod)}-${i}`}
                                                    component="span"
                                                    sx={{
                                                        px: 0.75,
                                                        py: 0.25,
                                                        borderRadius: 'var(--radius-sm, 8px)',
                                                        fontSize: '11px',
                                                        fontWeight: 600,
                                                        lineHeight: 1.4,
                                                        color: theme.palette.text.primary,
                                                        bgcolor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.14 : 0.07),
                                                        border: `1px solid ${alpha(theme.palette.primary.main, 0.18)}`,
                                                    }}
                                                >
                                                    {moduleLabel(mod)}
                                                </Box>
                                            ))}
                                        </Box>
                                    );
                                })()}
                            </Box>

                            {/* Usuário e Senha do Site */}
                            {(client.company.usuario_site || client.company.senha_site) && (
                                <Box>
                                    <Typography sx={{
                                        color: theme.palette.text.secondary,
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        display: 'block',
                                        marginBottom: 0.25
                                    }}>
                                        Credenciais do Site
                                    </Typography>
                                    {client.company.usuario_site && (
                                        <Typography variant="body2" sx={{
                                            color: theme.palette.text.primary,
                                            fontSize: '14px',
                                            fontWeight: 500,
                                            mb: 0.5
                                        }}>
                                            Usuário: {client.company.usuario_site}
                                        </Typography>
                                    )}
                                    {client.company.senha_site && (
                                        <Typography variant="body2" sx={{
                                            color: theme.palette.text.primary,
                                            fontSize: '14px',
                                            fontWeight: 500
                                        }}>
                                            Senha: {client.company.senha_site}
                                        </Typography>
                                    )}
                                </Box>
                            )}


                            {/* Situação / Status */}
                            <Box>
                                <Typography sx={{
                                    color: `${theme.palette.text.secondary} !important`,
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    display: 'block',
                                    marginBottom: 0.25
                                }}>
                                    Situação
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                    <Box sx={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: '50%',
                                        backgroundColor: (() => {
                                            // active: 'S'=Ativo, 'N'=Bloqueado, 'C'=Cancelado, 'T'=Inativo
                                            const activeStatus = client.company.active;
                                            switch (activeStatus) {
                                                case 'S':
                                                    return theme.palette.success.main; // Verde - Ativo
                                                case 'N':
                                                    return theme.palette.warning.main; // Amarelo/Laranja - Bloqueado
                                                case 'C':
                                                    return theme.palette.error.main; // Vermelho - Cancelado
                                                case 'T':
                                                    return theme.palette.grey[500]; // Cinza - Inativo
                                                default:
                                                    return client.company.status === 1
                                                        ? theme.palette.success.main
                                                        : theme.palette.error.main;
                                            }
                                        })(),
                                        boxShadow: (() => {
                                            const activeStatus = client.company.active;
                                            let color;
                                            switch (activeStatus) {
                                                case 'S':
                                                    color = theme.palette.success.main;
                                                    break;
                                                case 'N':
                                                    color = theme.palette.warning.main;
                                                    break;
                                                case 'C':
                                                    color = theme.palette.error.main;
                                                    break;
                                                case 'T':
                                                    color = theme.palette.grey[500];
                                                    break;
                                                default:
                                                    color = client.company.status === 1 
                                                        ? theme.palette.success.main 
                                                        : theme.palette.error.main;
                                            }
                                            return `0 0 0 3px ${color}20`;
                                        })()
                                    }} />
                                    <Box>
                                        <Typography variant="body2" sx={{
                                            color: `${theme.palette.text.primary} !important`,
                                            fontSize: '14px',
                                            fontWeight: 500
                                        }}>
                                            {(() => {
                                                // active: 'S'=Ativo, 'N'=Bloqueado, 'C'=Cancelado, 'T'=Inativo
                                                const activeStatus = client.company.active;
                                                switch (activeStatus) {
                                                    case 'S':
                                                        return 'Ativo';
                                                    case 'N':
                                                        return 'Bloqueado';
                                                    case 'C':
                                                        return 'Cancelado';
                                                    case 'T':
                                                        return 'Inativo';
                                                    default:
                                                        return client.company.status === 1 ? 'Ativo' : 'Inativo';
                                                }
                                            })()}
                                        </Typography>
                                        {client.company.active === 'S' && (
                                            <Typography variant="caption" sx={{
                                                color: `${theme.palette.text.secondary} !important`,
                                                fontSize: '12px',
                                                display: 'block',
                                                mt: 0.5
                                            }}>
                                                Atendimento: Normal
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                            </Box>

                            {/* Última Sincronização */}
                            {client.company.sync_date && (
                                <Box>
                                    <Typography sx={{
                                        color: theme.palette.text.secondary,
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        display: 'block',
                                        marginBottom: 0.25
                                    }}>
                                        Última Sincronização
                                    </Typography>
                                    <Typography variant="body2" sx={{
                                        color: theme.palette.text.primary,
                                        fontSize: '14px',
                                        fontWeight: 500
                                    }}>
                                        {formatDate(client.company.sync_date)}
                                    </Typography>
                                </Box>
                            )}
                                        </Box>
                                    )}
                                </Box>
                            );
                        })}
                        </Box>
                    </Box>
                )}


                <Box sx={{ marginBottom: 1.5, flexShrink: 0 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Tabs
                            value={ticketData.is_internal ? 1 : 0}
                            onChange={(e, newValue) => handleTypeChange(newValue === 1)}
                            sx={{
                                '& .MuiTab-root': {
                                    fontWeight: 'bold',
                                    textTransform: 'none',
                                    fontSize: '12px',
                                    color: `${theme.palette.text?.caption ?? theme.palette.text.secondary} !important`,
                                    minHeight: '36px',
                                    padding: '6px 12px'
                                },
                                '& .MuiTab-root.Mui-selected': {
                                    color: `${theme.palette.text?.tabSelected ?? theme.palette.text.primary} !important`,
                                    borderRadius: '4px'
                                }
                            }}
                        >
                            <Tab label="PÚBLICO" />
                            <Tab label="INTERNO" />
                        </Tabs>
                    </Box>
                </Box>


                {/*
                  * Contato e Canal lado a lado -- ate a coluna estreitar.
                  *
                  * Com `flex: 1` nos dois e sem quebra, cada metade ficava com
                  * ~108px numa coluna de 224px; tirando o botao "+" e o
                  * respiro, o campo de Contato era renderizado com 42px de
                  * largura e mostrava "Cli…" no lugar do nome. Medido em
                  * 30/10/2026.
                  *
                  * Com a base de 140px eles descem um sobre o outro antes de
                  * chegar a esse ponto, e cada um fica com a coluna inteira.
                  */}
                <Box sx={{ display: 'flex', gap: 1, marginBottom: 1, flexWrap: 'wrap', rowGap: 1 }}>
                    <Box sx={{ flex: '1 1 140px', minWidth: 0 }}>
                        <Typography variant="body2" sx={{
                            fontWeight: 'bold',
                            marginBottom: 0.5,
                            color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                            fontSize: '13px'
                        }}>
                            Contato *
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Autocomplete
                                sx={{ flex: 1, minWidth: 0 }}
                                size="small"
                                freeSolo
                                options={(() => {
                                    const base = Array.isArray(contactOptions) ? contactOptions : [];
                                    const current = String(ticketData.contact || '').trim();

                                    // Garante que o valor atual apareça como opção mesmo se não existir na lista
                                    if (!current) return base;
                                    const exists = base.some((opt) =>
                                        typeof opt === 'string'
                                            ? opt === current
                                            : opt.label === current
                                    );
                                    if (exists) return base;
                                    return [
                                        { type: 'contact', id: `manual-${current}`, companyId: null, companyLabel: 'Outros', label: current },
                                        ...base,
                                    ];
                                })()}
                                groupBy={(option) => {
                                    if (typeof option === 'string') return 'Outros';
                                    return option.companyLabel || 'Outros';
                                }}
                                getOptionLabel={(option) => {
                                    if (typeof option === 'string') return option;
                                    return option.label || '';
                                }}
                                value={ticketData.contact || ''}
                                onChange={(_, newValue) => {
                                    const value =
                                        typeof newValue === 'string'
                                            ? newValue
                                            : newValue?.label || '';
                                    handleInputChange({ target: { name: 'contact', value: value } });
                                }}
                                onInputChange={(_, newInputValue, reason) => {
                                    if (reason === 'input') {
                                        handleInputChange({
                                            target: {
                                                name: 'contact',
                                                value: newInputValue ?? '',
                                            },
                                        });
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Selecione ou digite um contato"
                                        error={isNewTicket && !ticketData.contact}
                                    />
                                )}
                                renderGroup={(params) => (
                                    <li key={params.key}>
                                        <ListSubheader
                                            sx={{
                                                backgroundColor: theme.palette.mode === 'dark'
                                                    ? theme.palette.grey[800]
                                                    : theme.palette.grey[100],
                                                fontWeight: 'bold',
                                                fontSize: '12px',
                                                color: theme.palette.text.primary,
                                                py: 0.5,
                                                lineHeight: 1.4,
                                            }}
                                        >
                                            {params.group}
                                        </ListSubheader>
                                        <ul style={{ paddingLeft: 0, margin: 0 }}>
                                            {params.children}
                                        </ul>
                                    </li>
                                )}
                                renderOption={(propsOption, option) => {
                                    const isObj = typeof option === 'object';
                                    // Só o telefone: o e-mail saiu do CONTATO a pedido da
                                    // Gisele (item 2). Ele continua existindo no cliente --
                                    // é de lá que `guessTicketEmail()` tira o destinatário da
                                    // resposta por e-mail.
                                    const subtitle = isObj
                                        ? String(option.whatsapp || option.phone || '')
                                        : '';
                                    return (
                                        <li {...propsOption}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                                                <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                                                    {isObj ? (option.label || '') : option}
                                                </Typography>
                                                {subtitle ? (
                                                    <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                                        {subtitle}
                                                    </Typography>
                                                ) : null}
                                            </Box>
                                        </li>
                                    );
                                }}
                            />
                            <Tooltip title="Cadastrar novo contato" arrow>
                                <IconButton size="small" onClick={openContactDialog}>
                                    <Add fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        {/*
                          Uma linha, nao quatro -- mas COM rotulo.

                          Eram um titulo ("Informações do contato selecionado")
                          mais duas linhas rotuladas, cada uma mostrando "-"
                          quando vazia: quatro linhas de altura para, no caso
                          comum, um telefone.

                          A primeira versao desta compactacao tirou os rotulos
                          junto, e o resultado foi um numero solto embaixo do
                          campo, sem dizer o que era. Rotulo curto ocupa quase
                          nada e e o que faz a informacao servir para alguma
                          coisa -- economizar espaco nao pode custar o sentido.

                          Pedido da Gisele (item 14): "ajustar o tamanho".

                          Sobrou so o telefone: o e-mail saiu do CONTATO no item
                          2. Ele continua existindo no CLIENTE, e e de la que
                          `guessTicketEmail()` tira o destinatario da resposta
                          por e-mail -- o que sumiu foi a exibicao aqui, nao o
                          dado.
                        */}
                        {selectedContactMeta && (selectedContactMeta.whatsapp || selectedContactMeta.phone) && (
                            <Typography
                                variant="caption"
                                sx={{
                                    display: 'block',
                                    mt: 0.5,
                                    color: theme.palette.text.secondary,
                                    wordBreak: 'break-word',
                                }}
                            >
                                {`Telefone: ${selectedContactMeta.whatsapp || selectedContactMeta.phone}`}
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ flex: '1 1 140px', minWidth: 0 }}>
                        <Typography variant="body2" sx={{
                            fontWeight: 'bold',
                            marginBottom: 0.5,
                            color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                            fontSize: '13px'
                        }}>
                            Canal *
                        </Typography>
                        <Select
                            value={ticketData.channel}
                            name="channel"
                            error={isNewTicket && !ticketData.channel}
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            displayEmpty
                            sx={{
                                // Igual ao Contato, que esta ao lado -- em altura
                                // e em fundo.
                                //
                                // ALTURA: medido na tela, o Autocomplete do Contato
                                // tem 45px e este Select tem 34px. A diferenca vem
                                // do MUI: o Autocomplete poe 6px de padding no root,
                                // o Select nao. Como as regras globais de
                                // AppThemeGlobalStyles ja fixam o resto (minHeight 34
                                // e 7px no input), repor esses 6px recompoe a mesma
                                // soma: 6 + 7 + 19 + 7 + 6 = 45.
                                paddingTop: '6px',
                                paddingBottom: '6px',
                                //
                                // Tirar o backgroundColor daqui nao bastava: o TEMA
                                // pinta o fundo de TODO Select
                                // (MuiSelect.styleOverrides.root aplica
                                // background.textField no input). O Contato e um
                                // Autocomplete e nao passa por essa regra -- dai a
                                // diferenca. Entao a sobrescrita precisa ser aqui,
                                // explicita.
                                '& .MuiInputBase-input': {
                                    backgroundColor: 'transparent',
                                },
                                '& .MuiSelect-select': {
                                    color: ticketData.channel ? theme.palette.text.primary : theme.palette.text.secondary
                                }
                            }}
                        >
                            <MenuItem value="">
                                <em>Selecione um canal</em>
                            </MenuItem>
                            <MenuItem value="Central de Notificações">Central de Notificações</MenuItem>
                            <MenuItem value="Chat">Chat</MenuItem>
                            <MenuItem value="Email">Email</MenuItem>
                            <MenuItem value="Formulário Site">Formulário Site</MenuItem>
                            <MenuItem value="Representante">Representante</MenuItem>
                            <MenuItem value="Telefone">Telefone</MenuItem>
                            <MenuItem value="WhatsApp">WhatsApp</MenuItem>
                        </Select>
                    </Box>
                </Box>

                {/* Protocolo WhatsApp: só quando o canal é WhatsApp. Manual por ora;
                    no futuro preenchido pela integração (SMClick/Movidesk). */}
                {ticketData.channel === 'WhatsApp' && (
                    <Box sx={{ marginBottom: 1 }}>
                        <Typography variant="body2" sx={{
                            fontWeight: 'bold',
                            marginBottom: 0.5,
                            color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                            fontSize: '13px'
                        }}>
                            Protocolo WhatsApp
                        </Typography>
                        <TextField
                            value={ticketData.whatsapp_protocol || ''}
                            name="whatsapp_protocol"
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            placeholder="Número do protocolo do WhatsApp"
                            disabled={!canEditTicket}
                            sx={{ backgroundColor: theme.palette.background.default }}
                        />
                    </Box>
                )}

                <Box sx={{ marginBottom: 1 }}>
                    <Typography variant="body2" sx={{
                        fontWeight: 'bold',
                        marginBottom: 0.5,
                        color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                        fontSize: '13px'
                    }}>
                        Serviço *
                    </Typography>
                    <ServicePicker
                        services={services}
                        value={ticketData.service_id}
                        onChange={(nextId) =>
                            handleInputChange(
                                { target: { name: 'service_id', value: nextId } },
                                nextId,
                                'service_id'
                            )
                        }
                        disabled={!canEditTicket}
                        isInternal={ticketData.is_internal}
                        requireLeaf
                    />
                </Box>

                {/*
                  * O seletor separado de "Departamento responsável" SAIU daqui
                  * (19/10/2026). A escolha passou a ser pelo título da seção
                  * na lista de responsáveis, que é onde a Gisele a procurava
                  * -- dois campos para a mesma decisão confundiam mais do que
                  * ajudavam.
                  *
                  * A coluna `tickets.service_group_id` continua, e continua
                  * sendo condição de filtro salvo ("Departamento responsável
                  * (chamado)"). Ela é o que permite o chamado aparecer como
                  * "Não atribuído" e, ao mesmo tempo, entrar no filtro do
                  * departamento -- as duas metades do pedido.
                  */}

                {/*
                  * Categoria e Urgência lado a lado -- ate a coluna estreitar.
                  *
                  * Sem quebra, este par nao encolhia: ele TRANSBORDAVA. Medido
                  * em 30/10/2026, na coluna de 224px (x 182..406), a caixa da
                  * Urgência ia de 380 a 454 -- 48px alem da borda, cortados
                  * pelo `overflow: hidden` da coluna. O campo existia, estava
                  * preenchido, e metade dele ficava fora da tela.
                  */}
                <Box sx={{ display: 'flex', gap: 1, marginBottom: 1, flexWrap: 'wrap', rowGap: 1 }}>
                    <Box sx={{ flex: '1 1 140px', minWidth: 0 }}>
                        <Typography variant="body2" sx={{
                            fontWeight: 'bold',
                            marginBottom: 0.5,
                            color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                            fontSize: '13px'
                        }}>
                            Categoria *
                        </Typography>
                        <Select
                            /*
                             * `?? ''` porque chamado sem categoria vem com
                             * `null`, e `null` num Select controlado rende
                             * DOIS avisos por render ("out-of-range value" e
                             * "`value` prop on `input` should not be null").
                             * Era o aviso mais repetido do console inteiro.
                             * Vazio é o que a tela já mostrava: com
                             * `displayEmpty`, '' cai na opção em branco.
                             */
                            value={ticketData.category ?? ''}
                            name="category"
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            displayEmpty
                            sx={{
                                backgroundColor: theme.palette.background.default,
                                '& .MuiSelect-select': {
                                    color: ticketData.category ? theme.palette.text.primary : theme.palette.text.secondary
                                }
                            }}
                        >
                            <MenuItem value="">
                                <em>Selecione uma categoria</em>
                            </MenuItem>
                            {(() => {
                                const serviceId = ticketData.service_id;
                                let allowedCategoryNames = null;
                                if (serviceId && services.length) {
                                    const flat = services.flatMap((s) => [s, ...(s.subservices || []).map((sub) => ({ ...sub, _parent: s }))]);
                                    const svc = flat.find((x) => x.id === serviceId);
                                    if (svc && svc.accept_all_categories === false && (svc.categories || []).length) {
                                        allowedCategoryNames = (svc.categories || []).map((c) => c.name);
                                    }
                                }
                                const list = allowedCategoryNames
                                    ? ticketCategories.filter((c) => allowedCategoryNames.includes(c.name)).map((c) => c.name)
                                    : (ticketCategories.length ? ticketCategories.map((c) => c.name) : ['Analise', 'Cancelado', 'Cobrança Financeiro', 'Comercial', 'Dev - Suporte', 'Informações', 'Instalação', 'Instalação SysFar Processo Implantação', 'Ligação Perdia', 'Pós Vendas', 'Sugestão', 'Suporte', 'Treinamento']);
                                return list.map((name) => (
                                    <MenuItem key={name} value={name}>{name}</MenuItem>
                                ));
                            })()}
                        </Select>
                    </Box>
                    <Box sx={{ flex: '1 1 140px', minWidth: 0 }}>
                        <Typography variant="body2" sx={{
                            fontWeight: 'bold',
                            marginBottom: 0.5,
                            color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                            fontSize: '13px'
                        }}>
                            Urgência
                        </Typography>
                        <Select
                            value={ticketData.priority}
                            name="priority"
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            sx={{
                                '& .MuiSelect-select': {
                                    backgroundColor: 'transparent',
                                    color:
                                        ticketData.priority === 0 ? theme.palette.success.main :
                                        ticketData.priority === 1 ? theme.palette.warning.main :
                                        ticketData.priority === 2 ? theme.palette.error.main :
                                        theme.palette.error.dark
                                }
                            }}
                        >
                            <MenuItem value={0}>Baixa</MenuItem>
                            <MenuItem value={1}>Média</MenuItem>
                            <MenuItem value={2}>Alta</MenuItem>
                            <MenuItem value={3}>Urgente</MenuItem>
                        </Select>
                    </Box>
                </Box>

                <Box sx={{ marginBottom: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 0.5 }}>
                        <Typography variant="body2" sx={{
                            fontWeight: 'bold',
                            color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                            fontSize: '13px'
                        }}>
                            Responsável *
                        </Typography>
                        {/*
                          * O DEPARTAMENTO ao lado do responsável (ponto 21 da
                          * Gisele, 20/10), e SÓ quando há responsável.
                          *
                          * Logo abaixo do campo já existe, desde 19/10, a linha
                          * "Atribuído ao departamento X — aparece como 'Não
                          * atribuído' na lista e no kanban". Ela cobre o caso
                          * de NÃO haver responsável, e explica a consequência
                          * -- informação que um chip não caberia.
                          *
                          * O que faltava era o outro caso: chamado que tem
                          * responsável E departamento. Ali a linha não aparece,
                          * e o departamento ficava invisível. É literalmente o
                          * "junto com o responsável" do pedido.
                          *
                          * Repetir os dois quando não há responsável seria a
                          * mesma frase duas vezes na mesma caixa.
                          */}
                        {ticketData.assigned_to && nomeDoDepartamento(ticketData, mapaDeDepartamentos) && (
                            <Chip
                                size="small"
                                label={nomeDoDepartamento(ticketData, mapaDeDepartamentos)}
                                data-testid="departamento-do-chamado"
                                sx={{ height: 18, fontSize: '11px' }}
                            />
                        )}
                    </Box>
                    {/*
                      * "Atribuir a mim" DESCE quando nao cabe ao lado.
                      *
                      * O botao mede ~110px e nao encolhe. Numa coluna de
                      * 224px, o campo de responsavel era renderizado com 42px
                      * e mostrava "Ma…" no lugar de "Matheus Torres" -- medido
                      * em 30/10/2026. Quarenta e dois pixels para o nome de
                      * quem esta com o chamado.
                      */}
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', rowGap: 1 }}>
                        <Autocomplete
                            sx={{ flex: '1 1 160px', minWidth: 0 }}
                            noOptionsText="Nenhuma opção"
                            // Aberto de forma controlada só para poder FECHAR ao
                            // escolher um departamento pelo título da seção --
                            // clique em `ListSubheader` não fecha o popup sozinho.
                            open={assigneeOpen}
                            onOpen={() => setAssigneeOpen(true)}
                            onClose={() => setAssigneeOpen(false)}
                            /*
                              * As pessoas MAIS uma opção por departamento.
                              *
                              * As de departamento não aparecem na lista (o
                              * `filterOptions` abaixo as tira): elas existem
                              * para o campo PODER MOSTRAR o departamento
                              * escolhido. Sem estar em `options`, o MUI recusa
                              * o valor ("none of the options match") e deixa a
                              * caixa vazia -- que era o defeito.
                              *
                              * Quem escolhe continua sendo o título clicável da
                              * seção; duas portas para a mesma coisa, uma delas
                              * escondida, seria pior que uma.
                              */
                            options={[...operadoresParaOSeletor, ...opcoesDeDepartamento].sort((a, b) => {
                                const groupA = a.service_group?.description || 'Sem departamento';
                                const groupB = b.service_group?.description || 'Sem departamento';
                                if (groupA !== groupB) return groupA.localeCompare(groupB);
                                return (a.name || '').localeCompare(b.name || '');
                            })}
                            groupBy={(option) => option.service_group?.description || 'Sem departamento'}
                            getOptionLabel={(option) => {
                                if (typeof option === 'string') return option;
                                return option.name || option.email || '';
                            }}
                            filterOptions={(options, state) => {
                                // As opções de departamento nunca entram na
                                // lista: elas só dão lastro ao valor escolhido.
                                const pessoas = options.filter((o) => !o.ehDepartamento);
                                const inputValue = state.inputValue.toLowerCase().trim();
                                if (!inputValue) return pessoas;
                                return pessoas.filter(option => {
                                    const name = (option.name || '').toLowerCase();
                                    const email = (option.email || '').toLowerCase();
                                    return name.includes(inputValue) || email.includes(inputValue);
                                });
                            }}
                            /*
                              * O que a CAIXA mostra.
                              *
                              * Atribuído a um departamento, `assigned_to` fica
                              * nulo de propósito -- e a caixa ficava vazia,
                              * igual a um chamado que ninguém pegou. A escolha
                              * aparecia só numa linha ABAIXO do campo.
                              *
                              * Pedido do dono do produto em 23/10: "deveria
                              * ficar na caixa de texto e não ali embaixo do
                              * campo".
                              */
                            value={valorDoResponsavel}
                            onChange={(event, newValue) => {
                                if (newValue === null) return;
                                // Escolher uma PESSOA tira o chamado da fila do
                                // departamento: era para lá que ele ia enquanto
                                // ninguém assumia.
                                handleInputChange(null, newValue?.id ?? '', 'assigned_to');
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Buscar por nome ou email..."
                                    size="small"
                                    // Item 18: obrigatório na criação manual (borda vermelha,
                                    // igual aos outros). Validação só no front — o backend
                                    // permite ticket sem responsável (ex.: aberto por e-mail).
                                    error={isNewTicket && !(Number(ticketData.assigned_to) > 0)}
                                    sx={{
                                        flex: 1,
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: theme.palette.background.default
                                        }
                                    }}
                                />
                            )}
                            renderGroup={(params) => {
                                /*
                                 * O título do departamento é CLICÁVEL: escolher
                                 * ele atribui o chamado ao departamento em vez
                                 * de a uma pessoa (pedido da Gisele, 18/10).
                                 *
                                 * O chamado fica como "Não atribuído" na lista
                                 * e no kanban -- porque `assigned_to` continua
                                 * nulo, e é isso mesmo que ela quer -- mas
                                 * entra nos filtros daquele departamento, pela
                                 * coluna `service_group_id` do chamado.
                                 *
                                 * Só os departamentos de verdade: "Sem
                                 * departamento" é o balde de quem não tem, e
                                 * não um lugar para onde mandar trabalho.
                                 */
                                const departamento = departamentos.find((g) => (g.description || g.code) === params.group);

                                return (
                                    <li key={params.key}>
                                        <ListSubheader
                                            onClick={departamento ? () => escolherDepartamentoComoResponsavel(departamento) : undefined}
                                            sx={{
                                                backgroundColor: theme.palette.mode === 'dark'
                                                    ? theme.palette.grey[800]
                                                    : theme.palette.grey[100],
                                                fontWeight: 'bold',
                                                fontSize: '12px',
                                                color: theme.palette.text.primary,
                                                py: 0.5,
                                                lineHeight: 1.4,
                                                ...(departamento ? {
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        backgroundColor: theme.palette.action.hover,
                                                        textDecoration: 'underline',
                                                    },
                                                } : {}),
                                            }}
                                        >
                                            {params.group}
                                            {departamento && (
                                                <Typography
                                                    component="span"
                                                    variant="caption"
                                                    sx={{ ml: 1, color: theme.palette.text.secondary, fontWeight: 400 }}
                                                >
                                                    atribuir ao departamento
                                                </Typography>
                                            )}
                                        </ListSubheader>
                                        {params.children}
                                    </li>
                                );
                            }}
                            renderOption={(props, option) => (
                                <Box component="li" {...props} key={option.id}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2 }}>
                                        <Typography variant="body2">{option.name || 'Sem nome'}</Typography>
                                        {option.email && (
                                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                                {option.email}
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                            )}
                            isOptionEqualToValue={(option, value) => option.id === value?.id}
                        />
                        <Button
                            onClick={handleAssignToMe}
                            variant='contained'
                            size="small"
                            color="primary"
                            disabled={ticketData.assigned_to === props.currentUser?.id}
                        >
                            Atribuir a mim
                        </Button>
                    </Box>

                    {/*
                      * A linha "Atribuído ao departamento X -- aparece como
                      * 'Não atribuído' na lista e no kanban" SAIU daqui.
                      *
                      * Dois motivos, e os dois valem sozinhos:
                      *
                      * 1. o departamento agora aparece na própria caixa, que é
                      *    onde ele foi pedido (23/10);
                      * 2. a segunda metade dela virou MENTIRA no mesmo dia: o
                      *    quadro deixou de juntar tudo em "Não atribuído" e
                      *    passou a ter uma faixa por departamento (ponto 25).
                      *    Aviso errado é pior que aviso nenhum.
                      */}
                </Box>

                <Box sx={{ marginBottom: 1 }}>
                    <Typography variant="body2" sx={{
                        fontWeight: 'bold',
                        marginBottom: 0.5,
                        color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                        fontSize: '13px'
                    }}>
                        CC (Cópia para acompanhamento)
                    </Typography>
                    <Autocomplete
                        multiple
                        freeSolo
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        noOptionsText="Nenhuma opção"
                        sx={{ width: '100%' }}
                        options={(users || [])
                            .filter((user) => {
                                const inUsers = ticketData.cc_users?.includes(user.id);
                                const inEmails = (ticketData.cc_emails || []).includes((user.email || '').toLowerCase());
                                return !inUsers && !inEmails;
                            })
                            .sort((a, b) => {
                                const groupA = a.service_group?.description || 'Sem departamento';
                                const groupB = b.service_group?.description || 'Sem departamento';
                                if (groupA !== groupB) {
                                    return groupA.localeCompare(groupB);
                                }
                                return (a.name || '').localeCompare(b.name || '');
                            })}
                        groupBy={(option) => (option?.isEmail ? 'E-mails externos' : (option.service_group?.description || 'Sem departamento'))}
                        getOptionLabel={(option) => {
                            if (typeof option === 'string') return option;
                            if (option?.isEmail) return option.email;
                            return option.name || option.email || '';
                        }}
                        filterOptions={(options, state) => {
                            const inputValue = state.inputValue.toLowerCase().trim();
                            let filtered = options;
                            if (inputValue) {
                                filtered = options.filter((option) => {
                                    const name = (option.name || '').toLowerCase();
                                    const email = (option.email || '').toLowerCase();
                                    return name.includes(inputValue) || email.includes(inputValue);
                                });
                            }
                            const input = state.inputValue.trim();
                            if (input && isValidEmail(input)) {
                                const lower = input.toLowerCase();
                                const existsUser = (users || []).some((u) => (u.email || '').toLowerCase() === lower);
                                const existsEmail = (ticketData.cc_emails || []).some((e) => e.toLowerCase() === lower);
                                if (!existsUser && !existsEmail) {
                                    filtered = [...filtered, { email: lower, isEmail: true, name: lower }];
                                }
                            }
                            return filtered;
                        }}
                        value={ccAutocompleteValue}
                        onChange={(event, newValue) => {
                            const { ccUserIds, ccEmails } = parseCcSelection(newValue);
                            const nextData = { ...ticketData, cc_users: ccUserIds, cc_emails: ccEmails };
                            setTicketData(nextData);
                            persistTicketChanges(nextData);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Buscar usuário ou digite um e-mail..."
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: theme.palette.background.default
                                    }
                                }}
                            />
                        )}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip
                                    label={option.isEmail ? option.email : (option.name || option.email)}
                                    {...getTagProps({ index })}
                                    key={option.isEmail ? `email-${option.email}` : `user-${option.id}`}
                                    size="small"
                                />
                            ))
                        }
                        renderGroup={(params) => (
                            <li key={params.key}>
                                <ListSubheader 
                                    sx={{
                                        backgroundColor: theme.palette.mode === 'dark' 
                                            ? theme.palette.grey[800] 
                                            : theme.palette.grey[100],
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                        color: theme.palette.text.primary,
                                        py: 0.5,
                                        lineHeight: 1.4
                                    }}
                                >
                                    {params.group}
                                </ListSubheader>
                                {params.children}
                            </li>
                        )}
                        renderOption={(props, option) => (
                            <Box component="li" {...props} key={option.isEmail ? `opt-email-${option.email}` : `opt-user-${option.id}`}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', pl: option.isEmail ? 0 : 2 }}>
                                    <Typography variant="body2">
                                        {option.isEmail ? option.email : (option.name || 'Sem nome')}
                                    </Typography>
                                    {!option.isEmail && option.email && (
                                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                            {option.email}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        )}
                        isOptionEqualToValue={(option, value) => {
                            if (option?.isEmail || value?.isEmail) {
                                return (option?.email || '').toLowerCase() === (value?.email || '').toLowerCase();
                            }
                            return option?.id === value?.id;
                        }}
                    />
                    {((ticketData.cc_users?.length || 0) + (ticketData.cc_emails?.length || 0)) > 0 && (
                        <Typography variant="caption" sx={{
                            color: theme.palette.text.secondary,
                            fontSize: '11px',
                            mt: 0.5,
                            display: 'block'
                        }}>
                            {(ticketData.cc_users?.length || 0) + (ticketData.cc_emails?.length || 0)} destinatário(s) receberá(ão) e-mail sobre novas ações e alterações de status
                        </Typography>
                    )}
                </Box>

                {/* O Status agora fica sempre no cabeçalho (topo), inclusive na abertura
                    do ticket — não mais aqui no formulário (item 39 + abertura). */}

                <Box sx={{ marginBottom: 1 }}>
                    <Typography variant="body2" sx={{
                        fontWeight: 'bold',
                        marginBottom: 0.5,
                        color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                        fontSize: '13px'
                    }}>
                        Previsão de solução (SLA)
                    </Typography>
                    <TextField
                        type="datetime-local"
                        name="solution_due_at"
                        value={solutionDueToInputValue(ticketData.solution_due_at)}
                        onChange={(e) => {
                            const v = e.target.value;
                            handleInputChange(null, v ? new Date(v).toISOString() : null, 'solution_due_at');
                        }}
                        disabled={!canEditTicket}
                        fullWidth
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ step: 300 }}
                        sx={{
                            backgroundColor: theme.palette.background.default,
                        }}
                    />
                </Box>

                </Box>
            </Box>

            {/* Handle arrastável entre os painéis */}
            <Box
                sx={{
                    display: { xs: 'none', md: 'block' },
                    width: 4,
                    cursor: 'col-resize',
                    backgroundColor: 'transparent',
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover
                    }
                }}
                onMouseDown={(e) => {
                    e.preventDefault();
                    // Captura o container uma vez aqui para evitar null em eventos futuros
                    const container = e.currentTarget.parentElement;
                    if (!container) return;

                    const startX = e.clientX;
                    const startWidth = leftPanelWidth;

                    const handleMouseMove = (moveEvent) => {
                        const deltaX = moveEvent.clientX - startX;
                        const totalWidth = container.getBoundingClientRect().width || 1;
                        const deltaPercent = (deltaX / totalWidth) * 100;
                        let newWidth = startWidth + deltaPercent;
                        // Limites de largura para não esmagar nenhum lado
                        newWidth = Math.max(leftPanelMinWidth, Math.min(leftPanelMaxWidth, newWidth));
                        setLeftPanelWidth(newWidth);
                    };

                    const handleMouseUp = () => {
                        window.removeEventListener('mousemove', handleMouseMove);
                        window.removeEventListener('mouseup', handleMouseUp);
                    };

                    window.addEventListener('mousemove', handleMouseMove);
                    window.addEventListener('mouseup', handleMouseUp);
                }}
            />

            <Box sx={{
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                backgroundColor: theme.palette.background.default
            }}>

                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                    p: 1.25,
                    /*
                      * `pt: 3` eram 24px de folga reservados para a barra
                      * flutuante de status/agenda/cronometro passar por cima
                      * sem tapar o conteudo. Ela deixou de flutuar, entao a
                      * folga virou um buraco no topo da coluna.
                      */
                    pt: 1.25,
                }}>

                    {/*
                      * PROTOCOLO E ASSUNTO, em destaque, acima das ações
                      * (ponto 20 da Gisele, 20/10/2026).
                      *
                      * Aqui, e não no topo da coluna da esquerda: esta é a
                      * coluna larga, então o assunto cabe inteiro em vez de
                      * morrer numa reticência. E fica acima do que o operador
                      * veio fazer -- ler e escrever ação --, que é o que
                      * "em destaque" quer dizer na prática.
                      *
                      * O corpo vai de 1rem para 1.15rem. Pouco de propósito:
                      * o que dá destaque aqui é o LUGAR, e uma fonte grande
                      * numa faixa que já tem borda e espaço em volta só
                      * empurraria as ações para baixo da dobra.
                      *
                      * É o MESMO controle de antes, com a edição do assunto no
                      * lápis. Deixar uma cópia só de leitura do outro lado
                      * faria a tela mostrar o assunto duas vezes -- e, enquanto
                      * alguém edita, mostrar dois valores diferentes.
                      */}
                    <Box data-testid="cabecalho-do-chamado" sx={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        /*
                          * QUEBRA A LINHA em vez de esconder metade.
                          *
                          * Numa linha so, o grupo da direita (status, agenda,
                          * cronometro) nao encolhe: ele empurrava o assunto a
                          * zero e o cabecalho ficava sem dizer QUAL chamado e.
                          * Na janela de 800px, medido, o assunto sumia inteiro.
                          *
                          * Com a quebra, falta de largura custa altura -- o
                          * estado desce para a segunda linha -- e nunca custa
                          * informacao. E a mesma escolha da tira de abas das
                          * Configuracoes.
                          */
                        flexWrap: 'wrap',
                        rowGap: 0.75,
                        marginBottom: 1.5,
                        py: 0.875,
                        pr: 1.25,
                        pl: 1.75,
                        overflow: 'hidden',
                        /*
                          * Pixel explicito, e nao `borderRadius: 1.2`: num `sx`
                          * o numero MULTIPLICA `theme.shape.borderRadius`, que
                          * aqui e 10 e nao os 4 do MUI. `1.2` daria 12px por
                          * coincidencia; `2` daria 20 e arredondaria a faixa
                          * inteira.
                          */
                        borderRadius: '12px',
                        border: '1px solid',
                        borderColor: 'divider',
                        /*
                          * A faixa passou de uma linha fina embaixo para um
                          * bloco com fundo proprio. A borda de antes era
                          * `divider` -- 9% de alfa no tema claro, medido: o
                          * cabecalho nao se lia como cabecalho, era texto solto
                          * boiando acima das acoes.
                          */
                        backgroundImage: (t) => `linear-gradient(135deg, ${alpha(
                            t.palette.primary.main,
                            t.palette.mode === 'dark' ? 0.16 : 0.07
                        )} 0%, ${alpha(t.palette.primary.main, 0)} 55%)`,
                        flexShrink: 0,
                        // O mesmo pincel de acento da barra lateral, na borda.
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            bottom: 0,
                            width: '3px',
                            backgroundColor: 'primary.main',
                        },
                        '&:hover .ticketSubjectEditBtn': { opacity: 1 },
                    }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.75,
                                minWidth: 0,
                                /*
                                  * 260px e a largura a partir da qual este
                                  * grupo deixa de caber junto com o estado e a
                                  * faixa quebra. Abaixo disso o assunto ainda
                                  * corta com reticencia, mas numa linha so dele.
                                  */
                                flex: '1 1 260px',
                                '&:hover .ticketSubjectEditBtn': {
                                    opacity: 1,
                                },
                            }}
                        >
                            {!isNewTicket && !isEditingSubject ? (
                                <>
                                    <ProtocoloDoChamado numero={ticketData?.number} />
                                    <Typography variant="h6" data-testid="assunto-do-chamado" sx={{
                                        fontWeight: 'bold',
                                        fontSize: '1.15rem',
                                        color: 'text.primary',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}>
                                        {ticketData?.title || 'Sem assunto'}
                                    </Typography>
                                </>
                            ) : isNewTicket ? (
                                <Typography variant="h6" sx={{
                                    fontWeight: 'bold',
                                    fontSize: '1.15rem',
                                    color: 'text.primary',
                                }}>
                                    Novo Ticket
                                </Typography>
                            ) : (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flex: 1, minWidth: 0 }}>
                                    <ProtocoloDoChamado numero={ticketData?.number} />
                                    <TextField
                                        value={subjectDraft}
                                        onChange={(e) => setSubjectDraft(e.target.value)}
                                        size="small"
                                        fullWidth
                                        autoFocus
                                        disabled={savingSubject}
                                        sx={{
                                            '& .MuiOutlinedInput-root': { backgroundColor: theme.palette.background.default },
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                saveSubject();
                                            } else if (e.key === 'Escape') {
                                                e.preventDefault();
                                                cancelEditingSubject();
                                            }
                                        }}
                                    />
                                </Box>
                            )}

                            {!isNewTicket && canEditTicket && !isEditingSubject && (
                                <Tooltip title="Editar assunto" arrow>
                                    <span>
                                        <IconButton
                                            size="small"
                                            onClick={startEditingSubject}
                                            sx={{
                                                /*
                                                  * 0.55, e nao 0: em `opacity: 0`
                                                  * o unico jeito de descobrir
                                                  * que o assunto e editavel era
                                                  * passar o mouse por cima do
                                                  * cabecalho por acaso. Visivel
                                                  * e discreto resolve a
                                                  * descoberta sem competir com
                                                  * o assunto; o hover continua
                                                  * levando a 1.
                                                  */
                                                opacity: 0.55,
                                                transition: 'opacity 160ms ease',
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                // `2` num `sx` seriam 20px -- redondo num botao de 26.
                                                borderRadius: '8px',
                                                bgcolor: 'background.paper',
                                                '&:hover': { bgcolor: 'action.hover' },
                                                width: 26,
                                                height: 26,
                                            }}
                                            className="ticketSubjectEditBtn"
                                            aria-label="Editar assunto"
                                        >
                                            <EditOutlinedIcon sx={{ fontSize: 16 }} />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            )}

                            {!isNewTicket && isEditingSubject && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <Tooltip title="Salvar" arrow>
                                        <span>
                                            <IconButton
                                                size="small"
                                                onClick={saveSubject}
                                                disabled={savingSubject}
                                                sx={{
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    // Igual ao lapis: `2` seriam 20px, nao 8.
                                                    borderRadius: '8px',
                                                    bgcolor: 'background.paper',
                                                    '&:hover': { bgcolor: 'action.hover' },
                                                }}
                                                aria-label="Salvar assunto"
                                            >
                                                <CheckOutlined fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip title="Cancelar" arrow>
                                        <span>
                                            <IconButton
                                                size="small"
                                                onClick={cancelEditingSubject}
                                                disabled={savingSubject}
                                                sx={{
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    borderRadius: '8px',
                                                    bgcolor: 'background.paper',
                                                    '&:hover': { bgcolor: 'action.hover' },
                                                }}
                                                aria-label="Cancelar edição do assunto"
                                            >
                                                <CloseOutlined fontSize="small" />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Box>
                            )}
                        </Box>

                        {/*
                          * O ESTADO do chamado, na mesma faixa que diz qual
                          * chamado e: status, agenda, cronometro e fechar.
                          *
                          * Vinham de uma caixa flutuante no canto da tela, que
                          * cobria o assunto abaixo de ~1.100px (veja o
                          * comentario no lugar de onde sairam). Aqui eles
                          * DISPUTAM a linha com o assunto em vez de deitar por
                          * cima: `flexShrink: 0` neste grupo e `minWidth: 0` no
                          * do titulo fazem o assunto encolher primeiro, com
                          * reticencia, que e o comportamento certo -- o assunto
                          * se le pela metade, o status nao.
                          */}
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.75,
                            flexShrink: 0,
                            marginLeft: 'auto',
                        }}>
                            {/* Status: sempre no cabecalho, inclusive na abertura
                                (item 39), para a posicao bater com a do chamado
                                que ja existe. */}
                            <Box sx={{ minWidth: 180, maxWidth: 300 }}>
                                {renderStatusField()}
                            </Box>
                            {/* Agenda compacta: proximo compromisso + popover. */}
                            {!isNewTicket && ticketData?.id && (
                                <TicketAgendaPanel
                                    ticketId={ticketData.id}
                                    ticketNumber={ticketData.number}
                                    theme={theme}
                                    users={users}
                                    currentUser={props.currentUser}
                                    canEditTicket={canEditTicket}
                                />
                            )}
                            {!isNewTicket && (
                                <TicketAttendanceTimer
                                    ticketId={ticketData.id || id}
                                    currentUserId={props.currentUser?.id}
                                    assignedToId={assignedToId}
                                    canManage={canEditTicket}
                                    refreshKey={attendanceRefreshKey}
                                />
                            )}
                            <Tooltip title="Fechar">
                                <IconButton
                                    size="small"
                                    onClick={() => handleRemoveTicket(ticketData.id)}
                                    sx={{
                                        backgroundColor: theme.palette.background.paper,
                                        border: `1px solid ${theme.palette.divider}`,
                                        borderRadius: '8px',
                                        '&:hover': {
                                            backgroundColor: theme.palette.action.hover
                                        }
                                    }}
                                    aria-label="Fechar chamado"
                                >
                                    <CloseSharp fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>

                    {!isNewTicket && (persistedStatus === 3 || persistedStatus === 4) ? (
                        <Box sx={{ marginBottom: 2, flexShrink: 0 }}>
                            <Box
                                sx={{
                                    p: 2,
                                    borderRadius: 2,
                                    border: `1px solid ${theme.palette.divider}`,
                                    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
                                    textAlign: 'center'
                                }}
                            >
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                    Este ticket está {persistedStatus === 3 ? 'Resolvido' : 'Cancelado'}.
                                </Typography>
                                <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
                                    Deseja reabrir o ticket?
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleReabrirTicket}
                                >
                                    Reabrir ticket
                                </Button>
                            </Box>
                        </Box>
                    ) : (
                        <Box sx={{ marginBottom: 1.25, flexShrink: 0 }}>
                            {canViewInternalComments && (
                                <Box sx={{ marginBottom: 0.25 }}>
                                    <Tabs
                                        value={commentIsInternal ? 1 : 0}
                                        onChange={(e, newValue) => setCommentIsInternal(newValue === 1)}
                                        sx={{
                                            minHeight: 32,
                                            '& .MuiTab-root': {
                                                fontWeight: 'bold',
                                                textTransform: 'none',
                                                fontSize: '11px',
                                                color: theme.palette.text?.tabUnselected ?? theme.palette.text.secondary,
                                                minHeight: '32px',
                                                padding: '4px 10px',
                                            },
                                            '& .MuiTab-root:nth-of-type(1).Mui-selected': {
                                                color: 'green',
                                                borderRadius: '4px',
                                            },
                                            '& .MuiTab-root:nth-of-type(2).Mui-selected': {
                                                color: 'orange',
                                                borderRadius: '4px',
                                            },
                                        }}
                                    >
                                        <Tab label="Ação pública" />
                                        <Tab label="Ação interna" />
                                    </Tabs>
                                </Box>
                            )}

                            <Box
                                sx={{
                                    position: 'relative',
                                    '& .ql-toolbar': {
                                        border: `1px solid ${actionMissing ? theme.palette.error.main : theme.palette.divider}`,
                                        borderBottom: 'none',
                                        borderRadius: '12px 12px 0 0',
                                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
                                        padding: '7px 10px',
                                        gap: 4
                                    },
                                    '& .ql-container': {
                                        border: `1px solid ${actionMissing ? theme.palette.error.main : theme.palette.divider}`,
                                        borderTop: 'none',
                                        borderRadius: '0 0 12px 12px',
                                        fontSize: '13px',
                                        fontFamily: 'inherit'
                                    },
                                    '& .ql-editor': {
                                        minHeight: 74,
                                        // Sem teto de altura, muitas imagens inline faziam o editor
                                        // crescer indefinidamente e empurravam o botão Salvar para
                                        // fora sem habilitar scroll. Agora o próprio editor rola.
                                        maxHeight: 320,
                                        overflowY: 'auto',
                                        padding: '8px 10px',
                                        '& img': { maxWidth: '100%', height: 'auto', borderRadius: 1 }
                                    },
                                    '& .ql-editor strong, & .ql-editor b': { fontWeight: 700 },
                                    '& .ql-editor em, & .ql-editor i': { fontStyle: 'italic' },
                                    '& .ql-editor.ql-blank::before': {
                                        fontStyle: 'normal',
                                        color: theme.palette.text.disabled
                                    }
                                }}
                                onPasteCapture={(e) => {
                                    handleCommentPasteCapture(e, {
                                        quillRef: newCommentQuillRef,
                                        setHtml: setNewComment,
                                        onNonImageFiles: (files) => {
                                            setCommentAttachments((prev) => [...prev, ...files]);
                                        },
                                    });
                                }}
                                onKeyDownCapture={(e) => {
                                    const isShortcut =
                                        e.ctrlKey &&
                                        e.shiftKey &&
                                        String(e.key || '').toLowerCase() === 'g';
                                    if (isShortcut) {
                                        e.preventDefault();
                                        handleAdjustNewCommentWithGpt();
                                    }
                                }}
                            >
                                <Tooltip
                                    title={
                                        gptAdjustingNewComment
                                            ? 'Orby está digitando...'
                                            : 'Ajustar texto (Orby) — Ctrl+Shift+G'
                                    }
                                    placement="top"
                                    arrow
                                >
                                    <IconButton
                                        size="small"
                                        onClick={handleAdjustNewCommentWithGpt}
                                        disabled={loading || gptAdjustingNewComment}
                                        sx={{
                                            position: 'absolute',
                                            top: 6,
                                            right: 6,
                                            zIndex: 5,
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            borderRadius: 2,
                                            p: 0.75,
                                            bgcolor: 'background.paper',
                                            '&:hover': { bgcolor: 'action.hover' },
                                        }}
                                        aria-label={gptAdjustingNewComment ? 'Orby está digitando' : 'Ajustar texto com Orby'}
                                    >
                                        <OrbyInlineIcon loading={gptAdjustingNewComment} />
                                    </IconButton>
                                </Tooltip>
                                <ReactQuill
                                    ref={newCommentQuillRef}
                                    value={newComment}
                                    /*
                                      * `origem === 'user'` de proposito: o Quill
                                      * tambem dispara `onChange` quando o valor e
                                      * posto por codigo (rascunho restaurado, texto
                                      * ajustado pelo Orby, macro aplicada). Sem o
                                      * corte, abrir um chamado com rascunho ja
                                      * anunciaria "esta editando" para os colegas.
                                      */
                                    onChange={(valor, delta, origem) => {
                                        setNewComment(valor);
                                        if (origem === 'user') marcarQueEstouEditando();
                                    }}
                                    modules={modules}
                                    formats={quillFormats}
                                    placeholder="Digite algo ou cole uma imagem (Ctrl+V)"
                                />
                                <QuillImageResizer
                                    quillRef={newCommentQuillRef}
                                    onCommit={setNewComment}
                                    disabled={!canEditTicket || gptAdjustingNewComment}
                                />
                                <MacroKeywordSuggest
                                    quillRef={newCommentQuillRef}
                                    value={newComment}
                                    macros={macros}
                                    disabled={!canEditTicket || gptAdjustingNewComment}
                                    onApply={(macro) => {
                                        const { messageBody } = extractMacroMessageEffects(macro.actions, ticketData);
                                        setNewComment(messageBody || '');
                                    }}
                                />
                                <OrbyTypingOverlay show={gptAdjustingNewComment} />
                            </Box>

                            {/*
                              * Assinar a ação (3º bloco da Gisele).
                              *
                              * Só aparece para quem TEM assinatura cadastrada: uma
                              * caixa de seleção que não faz nada é pior que nenhuma,
                              * e quem nunca escreveu a sua não deve descobrir o
                              * recurso por uma caixa inerte -- descobre no perfil.
                              *
                              * A prévia fica ao lado, e não dentro do editor, porque
                              * o Quill descarta o atributo que marca o bloco (ver
                              * `handleAddComment`). Assim o operador vê exatamente o
                              * que vai sair sem que o texto dele seja tocado.
                              */}
                            {(props.currentUser?.assinatura || props.currentUser?.assinatura_imagem) && (
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, marginTop: 0.75, flexWrap: 'wrap' }}>
                                    <FormControlLabel
                                        sx={{ m: 0 }}
                                        control={(
                                            <Checkbox
                                                size="small"
                                                checked={incluirAssinatura}
                                                onChange={(e) => setIncluirAssinatura(e.target.checked)}
                                                inputProps={{ 'aria-label': 'Incluir minha assinatura' }}
                                            />
                                        )}
                                        label={(
                                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                                Incluir minha assinatura
                                            </Typography>
                                        )}
                                    />
                                    {incluirAssinatura && (
                                        <Box
                                            sx={{
                                                borderLeft: '2px solid',
                                                borderColor: theme.palette.divider,
                                                pl: 1,
                                                py: 0.25,
                                            }}
                                        >
                                            {props.currentUser.assinatura && (
                                                <Typography
                                                    variant="caption"
                                                    sx={{ color: theme.palette.text.secondary, whiteSpace: 'pre-line', display: 'block' }}
                                                >
                                                    {props.currentUser.assinatura}
                                                </Typography>
                                            )}
                                            {/* A prévia mostra a imagem no tamanho em que
                                                ela sairá, para não haver surpresa depois de
                                                enviar. */}
                                            {props.currentUser.assinatura_imagem && (
                                                <img
                                                    src={props.currentUser.assinatura_imagem}
                                                    alt="Imagem da assinatura"
                                                    style={{ maxWidth: 200, maxHeight: 80, display: 'block', marginTop: 4 }}
                                                />
                                            )}
                                        </Box>
                                    )}
                                </Box>
                            )}

                            <input
                                type="file"
                                ref={fileInputRef}
                                multiple
                                accept={aceitosNoSeletor(politicaDeAnexos) || undefined}
                                style={{ display: 'none' }}
                                onChange={(e) => {
                                    const files = e.target.files ? Array.from(e.target.files) : [];
                                    setCommentAttachments(prev => [...prev, ...conferirAnexos(files)]);
                                    e.target.value = '';
                                }}
                            />
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, marginTop: 1, flexWrap: 'wrap' }}>
                                {macros.length > 0 && canEditTicket && (
                                    <Tooltip title="Aplicar uma macro a este ticket" placement="top" arrow>
                                        <Select
                                            size="small"
                                            displayEmpty
                                            value={messageMacroSelect}
                                            onChange={(e) => {
                                                const macroId = e.target.value;
                                                if (!macroId) return;
                                                setMessageMacroSelect('');
                                                applyMacroToCurrentTicket(macroId, 'manual_select');
                                            }}
                                            onClose={() => setMacroSelectFilter('')}
                                            sx={{ minWidth: 160, backgroundColor: theme.palette.background.default }}
                                            renderValue={(v) =>
                                                v ? (macros.find((m) => m.id === v)?.name || '') : 'Macro'
                                            }
                                            MenuProps={{ autoFocus: false, PaperProps: { sx: { maxHeight: 380 } } }}
                                        >
                                            {/* Busca: filtra as macros pelo nome (sao muitas). stopPropagation
                                                evita o Select fechar/selecionar ao interagir com o campo. */}
                                            <ListSubheader sx={{ p: 0.5, bgcolor: 'background.paper' }} onKeyDown={(e) => e.stopPropagation()} onClickCapture={(e) => e.stopPropagation()}>
                                                <TextField
                                                    size="small"
                                                    autoFocus
                                                    fullWidth
                                                    placeholder="Buscar macro..."
                                                    value={macroSelectFilter}
                                                    onChange={(e) => setMacroSelectFilter(e.target.value)}
                                                />
                                            </ListSubheader>
                                            <MenuItem value="">
                                                <em>Selecione uma macro...</em>
                                            </MenuItem>
                                            {macros
                                                .filter((m) => (m.name || '').toLowerCase().includes(macroSelectFilter.trim().toLowerCase()))
                                                .map((m) => (
                                                    <MenuItem key={m.id} value={m.id}>
                                                        {m.name}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </Tooltip>
                                )}

                                <Tooltip title={tituloDoBotaoDeAnexo()} placement="top" arrow>
                                    <Button
                                        size="small"
                                        startIcon={<AttachFile />}
                                        onClick={() => fileInputRef.current?.click()}
                                        sx={{ textTransform: 'none' }}
                                    >
                                        Anexar arquivos
                                    </Button>
                                </Tooltip>

                                {!isNewTicket && (
                                    <Tooltip title="Incluir anexos já adicionados neste ticket" placement="top" arrow>
                                        <Button
                                            size="small"
                                            startIcon={<InsertDriveFile />}
                                            onClick={openReuseAttachModal}
                                            sx={{ textTransform: 'none' }}
                                        >
                                            Reutilizar anexos
                                        </Button>
                                    </Tooltip>
                                )}

                                {PLAYBOOKS.some((pb) => pb.active) && (
                                    <>
                                        <Tooltip title="Abrir um playbook de atendimento" placement="top" arrow>
                                            <Button
                                                size="small"
                                                startIcon={<MenuBookOutlinedIcon />}
                                                endIcon={<ExpandMore />}
                                                onClick={(e) => setPlaybookAnchor(e.currentTarget)}
                                                sx={{ textTransform: 'none' }}
                                            >
                                                Playbook
                                            </Button>
                                        </Tooltip>
                                        <Popover
                                            open={Boolean(playbookAnchor)}
                                            anchorEl={playbookAnchor}
                                            onClose={() => setPlaybookAnchor(null)}
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        >
                                            <Box sx={{ py: 0.5, minWidth: 220 }}>
                                                {PLAYBOOKS.filter((pb) => pb.active).map((pb) => (
                                                    <MenuItem
                                                        key={pb.id}
                                                        onClick={() => {
                                                            window.open(pb.url, '_blank', 'noopener,noreferrer');
                                                            setPlaybookAnchor(null);
                                                        }}
                                                        sx={{ fontSize: '0.8125rem', gap: 1 }}
                                                    >
                                                        <LaunchOutlinedIcon sx={{ fontSize: 16 }} />
                                                        {pb.title}
                                                    </MenuItem>
                                                ))}
                                            </Box>
                                        </Popover>
                                    </>
                                )}

                                <VoiceTranscribeButton
                                    onTranscribed={insertTranscriptIntoComment}
                                    disabled={!canEditTicket}
                                />

                                {commentAttachments.length > 0 && (
                                    <Box sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 0.5,
                                        alignItems: 'flex-start',
                                        alignContent: 'flex-start',
                                        width: '100%',
                                        maxHeight: 96,
                                        overflowY: 'auto',
                                        pr: 0.5,
                                    }}>
                                        {commentAttachments.map((file, idx) => (
                                            <Chip
                                                key={idx}
                                                size="small"
                                                variant={file.__reused ? 'outlined' : 'filled'}
                                                icon={file.__reused ? <InsertDriveFile style={{ fontSize: 14 }} /> : undefined}
                                                label={file.__reused ? (file.original_name || 'anexo') : file.name}
                                                onDelete={() =>
                                                    setCommentAttachments((prev) =>
                                                        prev.filter((_, i) => i !== idx)
                                                    )
                                                }
                                                sx={{ maxWidth: 180 }}
                                            />
                                        ))}
                                    </Box>
                                )}
                            </Box>

                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: 1.25,
                                flexWrap: 'wrap',
                                gap: 1
                            }}>
                                <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                    Palavras: {Math.max(0, newComment.trim() ? newComment.trim().split(/\s+/).length : 0)}
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                    {!isNewTicket && (
                                        <Select
                                            value={[0, 1, 2].includes(Number(ticketData.status)) ? '' : ticketData.status}
                                            name="status"
                                            onChange={(e) => handleInputChange(e, e.target.value === '' ? 1 : Number(e.target.value), 'status')}
                                            size="small"
                                            displayEmpty
                                            renderValue={(v) => (v === 3 ? 'Resolvido' : v === 4 ? 'Cancelado' : 'Fechar ticket...')}
                                            sx={{
                                                minWidth: 136,
                                                backgroundColor: theme.palette.background.default
                                            }}
                                        >
                                            <MenuItem value={3}>Resolvido</MenuItem>
                                            <MenuItem value={4}>Cancelado</MenuItem>
                                        </Select>
                                    )}
                                    {!isNewTicket && (
                                        <Tooltip title="Opções" arrow>
                                            <IconButton
                                                size="small"
                                                onClick={handleOpenTicketOptions}
                                                sx={{
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    borderRadius: 2,
                                                    bgcolor: 'background.paper',
                                                    '&:hover': { bgcolor: 'action.hover' },
                                                }}
                                            >
                                                <MoreVertIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    {(() => {
                                        const statusNum = Number(ticketData.status);
                                        const resolvedOrCancelledIds = (ticketStatuses || []).filter((s) => s.name === 'Resolvido' || s.name === 'Cancelado').map((s) => s.id);
                                        const isResolvidoOuCancelado = statusNum === 3 || statusNum === 4 || (ticketData.status_id && resolvedOrCancelledIds.includes(ticketData.status_id));
                                        const hasComment = removeEmptyHtmlTags(newComment)?.trim();
                                        const canAddAction = !isResolvidoOuCancelado
                                            ? (hasComment || commentAttachments.length > 0)
                                            : !!hasComment;
                                        return (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                {isResolvidoOuCancelado && (
                                                    <Typography variant="caption" sx={{ color: theme.palette.warning.main, whiteSpace: 'nowrap' }}>
                                                        Informe o motivo no comentário
                                                    </Typography>
                                                )}
                                                {!isNewTicket && (
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        startIcon={<EmailOutlinedIcon />}
                                                        onClick={openEmailDialog}
                                                        color="primary"
                                                        disabled={!canEditTicket}
                                                    >
                                                        ENVIAR E-MAIL
                                                    </Button>
                                                )}
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={handleAddComment}
                                                    color="primary"
                                                    disabled={!canAddAction || !canEditTicket}
                                                >
                                                    ADICIONAR AÇÃO
                                                </Button>
                                            </Box>
                                        );
                                    })()}
                                </Box>
                            </Box>
                        </Box>
                    )}

                    {!isNewTicket && (
                        <Box sx={{ mt: 1.25 }}>
                            <Box
                                sx={{
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 2.5,
                                    bgcolor: 'background.paper',
                                    px: 1.5,
                                    py: 1.25,
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '0.9rem' }}>
                                            Relacionamentos
                                        </Typography>
                                        <IconButton
                                            size="small"
                                            onClick={() => setRelationshipsExpanded((v) => !v)}
                                            sx={{
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                borderRadius: 2,
                                                bgcolor: 'background.paper',
                                                '&:hover': { bgcolor: 'action.hover' },
                                            }}
                                            aria-label={relationshipsExpanded ? 'Minimizar relacionamentos' : 'Expandir relacionamentos'}
                                        >
                                            {relationshipsExpanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                                        </IconButton>
                                    </Box>
                                    <Button
                                        size="small"
                                        variant="text"
                                        onClick={handleOpenRelatedModal}
                                        sx={{ textTransform: 'none' }}
                                        disabled={!ticketData?.id}
                                    >
                                        Relacionar
                                    </Button>
                                </Box>

                                <Collapse in={relationshipsExpanded} timeout={180}>
                                    <Divider sx={{ my: 1 }} />

                                    {relationshipsLoading ? (
                                        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.85rem' }}>
                                            Carregando relacionamentos...
                                        </Typography>
                                    ) : (
                                        <>
                                            <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.85rem', mb: 1 }}>
                                                {relationshipsData?.parent?.id
                                                    ? `Este ticket é filho do protocolo ${relationshipsData.parent.number}.`
                                                    : (relationshipsData?.children?.length
                                                        ? `Este ticket é o principal e possui ${relationshipsData.children.length} filho(s) relacionado(s).`
                                                        : 'Sem tickets relacionados.')}
                                            </Typography>

                                            {(relationshipsData?.parent?.id || (relationshipsData?.children?.length || 0) > 0) && (
                                                <Box sx={{ overflowX: 'auto' }}>
                                                    <Box sx={{ minWidth: 840 }}>
                                                        <Box
                                                            sx={{
                                                                display: 'grid',
                                                                gridTemplateColumns: '110px 1.6fr 1.2fr 140px 160px 110px 140px',
                                                                gap: 1,
                                                                pb: 0.75,
                                                            }}
                                                        >
                                                            {['Protocolo', 'Assunto', 'Cliente', 'Aberto em', 'Responsável', 'Status', 'Vencimento'].map((h) => (
                                                                <Typography key={h} variant="caption" sx={{ fontWeight: 700, color: 'text.secondary' }}>
                                                                    {h}
                                                                </Typography>
                                                            ))}
                                                        </Box>

                                                        {[
                                                            ...(relationshipsData?.parent?.id ? [relationshipsData.parent] : []),
                                                            ...((relationshipsData?.children || []).slice(0, 50)),
                                                        ].map((t) => (
                                                            <Box
                                                                key={t.id}
                                                                sx={{
                                                                    display: 'grid',
                                                                    gridTemplateColumns: '110px 1.6fr 1.2fr 140px 160px 110px 140px',
                                                                    gap: 1,
                                                                    py: 0.75,
                                                                    borderTop: '1px solid',
                                                                    borderColor: 'divider',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <Button
                                                                    variant="text"
                                                                    size="small"
                                                                    onClick={() => props.history.push(`/ticket/${t.id}`)}
                                                                    sx={{ justifyContent: 'flex-start', textTransform: 'none', px: 0.5, minWidth: 0 }}
                                                                >
                                                                    {t.number}
                                                                </Button>
                                                                <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                                                                    {t.title || 'Sem assunto'}
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ fontSize: '0.85rem', color: 'text.secondary' }}>
                                                                    {t.client_name || t.client?.name || t.client || '—'}
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ fontSize: '0.85rem', color: 'text.secondary' }}>
                                                                    {t.created_at ? new Date(t.created_at).toLocaleString('pt-BR') : '—'}
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ fontSize: '0.85rem', color: 'text.secondary' }}>
                                                                    {t.assigned_to_name || t.assigned_to?.name || '—'}
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ fontSize: '0.85rem', color: 'text.secondary' }}>
                                                                    {t.status_name || t.ticket_status?.name || t.status || '—'}
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ fontSize: '0.85rem', color: 'text.secondary' }}>
                                                                    {t.solution_due_at ? new Date(t.solution_due_at).toLocaleString('pt-BR') : '—'}
                                                                </Typography>
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            )}
                                        </>
                                    )}
                                </Collapse>
                            </Box>
                        </Box>
                    )}

                    <Dialog
                        open={relatedModalOpen}
                        onClose={handleCloseRelatedModal}
                        maxWidth="sm"
                        fullWidth
                    >
                        <Box sx={{ px: 2.5, pt: 2.25, pb: 1 }}>
                            <Typography variant="h6" sx={{ fontSize: '1.05rem', fontWeight: 800 }}>
                                Relacionar ticket
                            </Typography>
                        </Box>
                        <Divider />
                        <Box sx={{ px: 2.5, pt: 1.5, pb: 2 }}>
                            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.25 }}>
                                Escolha se deseja criar um novo ticket filho ou vincular este protocolo a um ticket existente.
                            </Typography>

                            <RadioGroup
                                value={relatedMode}
                                onChange={(e) => setRelatedMode(e.target.value)}
                                sx={{ mb: 1.5 }}
                            >
                                <FormControlLabel
                                    value="create_new"
                                    control={<Radio size="small" />}
                                    label="Criar novo ticket relacionado (filho deste)"
                                />
                                <FormControlLabel
                                    value="link_existing"
                                    control={<Radio size="small" />}
                                    label="Vincular a um ticket existente"
                                />
                            </RadioGroup>

                            {relatedMode === 'create_new' ? (
                                <>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.75 }}>
                                        Ações importadas para o novo ticket
                                    </Typography>
                                    <RadioGroup
                                        value={relatedCopyMode}
                                        onChange={(e) => setRelatedCopyMode(e.target.value)}
                                    >
                                        <FormControlLabel value="all" control={<Radio size="small" />} label="Todas" />
                                        <FormControlLabel value="first_last" control={<Radio size="small" />} label="Somente a primeira e a última" />
                                        <FormControlLabel value="first" control={<Radio size="small" />} label="Somente a primeira" />
                                        <FormControlLabel value="last" control={<Radio size="small" />} label="Somente a última" />
                                        <FormControlLabel value="none" control={<Radio size="small" />} label="Nenhuma" />
                                    </RadioGroup>
                                </>
                            ) : (
                                <>
                                    <TextField
                                        label="Registro do cliente"
                                        size="small"
                                        fullWidth
                                        value={relatedRegistroFilter}
                                        onChange={(e) => setRelatedRegistroFilter(e.target.value)}
                                        placeholder="Filtrar por código da empresa..."
                                        sx={{ mb: 1.5 }}
                                    />
                                    <Autocomplete
                                        noOptionsText={
                                            relatedOptionsLoading
                                                ? 'Buscando...'
                                                : `Digite ao menos ${MIN_CARACTERES} caracteres do número ou do assunto`
                                        }
                                        loading={relatedOptionsLoading}
                                        // O servidor é quem busca; este filtro
                                        // é o de código da empresa, que o campo
                                        // acima aplica POR CIMA do resultado.
                                        filterOptions={(x) => x}
                                        onInputChange={(event, termo, motivo) => {
                                            if (motivo === 'input') {
                                                buscarChamadosParaSelecao(termo, setRelatedTicketOptions, setRelatedOptionsLoading);
                                            }
                                        }}
                                        options={relatedTicketOptions.filter((t) => {
                                            const reg = relatedRegistroFilter.trim().toLowerCase();
                                            if (!reg) return true;
                                            const codes = (Array.isArray(t.ticket_clients) ? t.ticket_clients : [])
                                                .map((tc) => String(tc.company?.code ?? '').toLowerCase());
                                            if (t.company?.code) codes.push(String(t.company.code).toLowerCase());
                                            return codes.some((c) => c && c.includes(reg));
                                        })}
                                        value={relatedTargetTicket}
                                        onChange={(event, newValue) => setRelatedTargetTicket(newValue)}
                                        getOptionLabel={(option) => `#${option.number} - ${option.title || 'Sem título'}`}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Ticket existente"
                                                size="small"
                                                placeholder="Buscar por # ou título..."
                                            />
                                        )}
                                        isOptionEqualToValue={(option, value) => Number(option.id) === Number(value?.id)}
                                        sx={{ mb: 1.5 }}
                                    />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.75 }}>
                                        Tipo de vínculo
                                    </Typography>
                                    <RadioGroup
                                        value={relatedLinkDirection}
                                        onChange={(e) => setRelatedLinkDirection(e.target.value)}
                                    >
                                        <FormControlLabel
                                            value="current_as_child"
                                            control={<Radio size="small" />}
                                            label={`Este ticket (#${ticketData?.number}) passa a ser filho do selecionado`}
                                        />
                                        <FormControlLabel
                                            value="target_as_child"
                                            control={<Radio size="small" />}
                                            label={`O ticket selecionado passa a ser filho deste (#${ticketData?.number})`}
                                            disabled={!relatedTargetTicket}
                                        />
                                    </RadioGroup>
                                </>
                            )}
                        </Box>
                        <Divider />
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, px: 2.5, py: 1.5 }}>
                            <Button onClick={handleCloseRelatedModal} disabled={creatingRelatedTicket}>
                                Cancelar
                            </Button>
                            <Button
                                onClick={handleConfirmRelated}
                                variant="contained"
                                color="primary"
                                disabled={creatingRelatedTicket}
                            >
                                {creatingRelatedTicket
                                    ? 'Salvando...'
                                    : relatedMode === 'link_existing'
                                        ? 'Vincular'
                                        : 'Criar ticket'}
                            </Button>
                        </Box>
                    </Dialog>

                    <Popover
                        open={Boolean(ticketOptionsAnchorEl)}
                        anchorEl={ticketOptionsAnchorEl}
                        onClose={handleCloseTicketOptions}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                        <Box sx={{ minWidth: 240, py: 0.5 }}>
                            <MenuItem
                                onClick={handleOpenRelatedModal}
                                disabled={!ticketData?.id || isNewTicket}
                            >
                                Relacionar ticket
                            </MenuItem>
                            {canMergeTickets && (
                                <MenuItem
                                    onClick={handleOpenMergeFromMenu}
                                    disabled={!ticketData?.id || isNewTicket}
                                >
                                    Mesclar tickets
                                </MenuItem>
                            )}
                            {canDeleteTicket && (
                                <MenuItem
                                    onClick={() => { handleCloseTicketOptions(); setDeleteDialogOpen(true); }}
                                    disabled={!ticketData?.id || isNewTicket}
                                    sx={{ color: theme.palette.error.main }}
                                >
                                    Excluir ticket
                                </MenuItem>
                            )}
                        </Box>
                    </Popover>

                    <Dialog open={deleteDialogOpen} onClose={() => !deletingTicket && setDeleteDialogOpen(false)} maxWidth="xs" fullWidth>
                        <DialogTitle sx={{ color: theme.palette.error.main }}>Excluir ticket</DialogTitle>
                        <DialogContent>
                            <Typography variant="body2">
                                Tem certeza que deseja excluir o ticket <strong>#{ticketData?.number}</strong>
                                {ticketData?.title ? <> — {ticketData.title}</> : null}? Esta ação é
                                permanente e remove também comentários, anexos e histórico do ticket.
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setDeleteDialogOpen(false)} color="inherit" disabled={deletingTicket}>Cancelar</Button>
                            <Button onClick={handleDeleteTicket} color="error" variant="contained" disabled={deletingTicket}>
                                {deletingTicket ? 'Excluindo...' : 'Excluir'}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {(!isNewTicket && (getFilteredComments().length > 0 || (showAuditHistory && (auditHistory.length > 0 || attendanceTimelineItems.length > 0)))) || (isNewTicket && pendingComments.length > 0) ? (
                        <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'visible', display: 'flex', flexDirection: 'column', paddingLeft: 0.5 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 1.25, flexShrink: 0 }}>
                                <Typography variant="subtitle1" sx={{
                                    fontWeight: 'bold',
                                    fontSize: '0.93rem',
                                    color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary
                                }}>
                                    Timeline de Ações
                                </Typography>

                                {!isNewTicket && (
                                <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, flexWrap: 'nowrap' }}>
                                    <Switch
                                        size="small"
                                        checked={showAuditHistory}
                                        onChange={(e) => setShowAuditHistory(e.target.checked)}
                                        color="primary"
                                    />
                                    <Typography variant="body2" sx={{
                                        color: theme.palette.text.secondary,
                                        fontSize: '11px',
                                        lineHeight: 1.25,
                                    }}>
                                        Mostrar histórico e tempo de atendimento
                                    </Typography>
                                </Box>
                                )}
                            </Box>

                            <Box sx={{ position: 'relative', paddingLeft: 2.5, overflow: 'visible' }}>
                                <Box sx={{
                                    position: 'absolute',
                                    left: 20,
                                    top: 0,
                                    bottom: 0,
                                    width: 2,
                                    backgroundColor: theme.palette.divider,
                                    zIndex: 1
                                }} />

                                {getCombinedTimeline().map((item, index) => (
                                    item.type === 'comment' ? (
                                        (() => {
                                            const accentColor = item.is_internal
                                                ? theme.palette.warning.main
                                                : theme.palette.primary.main;
                                            const isTranscriptionComment = item.comment.trim().startsWith('{');
                                            const isLatestComment =
                                                item.commentId != null &&
                                                latestVisibleCommentId != null &&
                                                Number(item.commentId) === Number(latestVisibleCommentId);
                                            const isOwnComment =
                                                item.user?.id != null &&
                                                props.currentUser?.id != null &&
                                                Number(item.user.id) === Number(props.currentUser.id);
                                            const canEditThis =
                                                !isNewTicket &&
                                                !isTranscriptionComment &&
                                                item.commentId != null &&
                                                (canEditAllTicketActions || (isLatestComment && isOwnComment));
                                            const isEditing =
                                                item.commentId != null &&
                                                editingCommentId != null &&
                                                Number(item.commentId) === Number(editingCommentId);
                                            return (
                                        <Box key={item.id} sx={{
                                            position: 'relative',
                                            marginBottom: 1.5,
                                            paddingLeft: 4.75,
                                            zIndex: 2
                                        }}>
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    left: '-5px',
                                                    top: '12px',
                                                    width: 12,
                                                    height: 12,
                                                    borderRadius: '50%',
                                                    backgroundColor: accentColor,
                                                    border: `3px solid ${theme.palette.background.default}`,
                                                    zIndex: 3,
                                                    boxShadow: `0 0 0 1px ${accentColor}55, 0 2px 10px ${accentColor}40`,
                                                }}
                                            />

                                            <Box sx={{
                                                backgroundColor: theme.palette.background.paper,
                                                borderRadius: 2,
                                                padding: 1.25,
                                                boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                                                border: `1px solid ${theme.palette.divider}`,
                                                borderLeft: `4px solid ${accentColor}`,
                                                position: 'relative',
                                                overflow: 'hidden',
                                            }}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'flex-start',
                                                    marginBottom: 0.75
                                                }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Avatar
                                                            src={item.user?.picture}
                                                            sx={{
                                                                width: 28,
                                                                height: 28,
                                                                fontSize: '11px',
                                                                fontWeight: 'bold',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                                                color: 'white'
                                                            }}
                                                        >
                                                            {item.user ? item.user.name.split(' ').map(n => n[0]).join('').toUpperCase() : 'U'}
                                                        </Avatar>

                                                        <Box>
                                                            <Typography variant="subtitle2" sx={{
                                                                fontWeight: 'bold',
                                                                fontSize: '0.8125rem',
                                                                lineHeight: 1.3,
                                                                color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
                                                                marginBottom: 0
                                                            }}>
                                                                {item.user ? item.user.name : 'Operador Removido'}
                                                            </Typography>
                                                            <Typography sx={{
                                                                color: theme.palette.text.secondary,
                                                                fontSize: '11px'
                                                            }}>
                                                                {formatDate(item.created_at)}
                                                                {item.updated_at && item.updated_at !== item.created_at ? ` · Editado em ${formatDate(item.updated_at)}` : ''}
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    <Box sx={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        justifyContent: 'flex-end',
                                                        gap: 0.25,
                                                        flexWrap: 'wrap',
                                                    }}>
                                                        <Box sx={{
                                                            backgroundColor: accentColor,
                                                            color: 'white',
                                                            padding: '4px 9px',
                                                            borderRadius: 2,
                                                            fontSize: '11px',
                                                            fontWeight: 'bold',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                        }}>
                                                            {item.is_internal ? 'Ação Interna' : 'Ação Pública'}
                                                        </Box>
                                                        {canEditThis && !isEditing && (
                                                            <Tooltip title="Editar ação" placement="top">
                                                                <IconButton
                                                                    size="small"
                                                                    aria-label="Editar ação"
                                                                    onClick={() => openCommentForEdit(item)}
                                                                    sx={{
                                                                        color: 'text.secondary',
                                                                        opacity: 0.7,
                                                                        p: 0.5,
                                                                        '&:hover': {
                                                                            color: 'primary.main',
                                                                            opacity: 1,
                                                                            backgroundColor: 'action.hover',
                                                                        },
                                                                    }}
                                                                >
                                                                    <EditOutlinedIcon sx={{ fontSize: 18 }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                    </Box>
                                                </Box>

                                                {!isEditing && (
                                                    <Divider sx={{ margin: '10px 0', backgroundColor: theme.palette.background.divider }} />
                                                )}

                                                <Box sx={{
                                                    backgroundColor: theme.palette.background.paper,
                                                    padding: 1.5,
                                                    borderRadius: 2,
                                                    position: 'relative'
                                                }}>
                                                    {isTranscriptionComment ? (
                                                        <ChatTranscription comment={item.comment} roomId={ticketData?.room?.room_id} />
                                                    ) : isEditing ? (
                                                        <>
                                                            <Box
                                                                sx={{
                                                                    position: 'relative',
                                                                    '& .ql-toolbar': {
                                                                        border: `1px solid ${theme.palette.divider}`,
                                                                        borderBottom: 'none',
                                                                        borderRadius: '10px 10px 0 0',
                                                                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
                                                                        padding: '8px 10px',
                                                                    },
                                                                    '& .ql-container': {
                                                                        border: `1px solid ${theme.palette.divider}`,
                                                                        borderTop: 'none',
                                                                        borderRadius: '0 0 10px 10px',
                                                                        fontSize: '15px',
                                                                        fontFamily: 'inherit',
                                                                    },
                                                                    '& .ql-editor': {
                                                                        minHeight: 120,
                                                                        padding: '10px 14px',
                                                                        '& img': { maxWidth: '100%', height: 'auto', borderRadius: 1 },
                                                                    },
                                                                    '& .ql-editor strong, & .ql-editor b': { fontWeight: 700 },
                                                                    '& .ql-editor em, & .ql-editor i': { fontStyle: 'italic' },
                                                                }}
                                                                onPasteCapture={(e) => {
                                                                    handleCommentPasteCapture(e, {
                                                                        quillRef: editCommentQuillRef,
                                                                        setHtml: setEditCommentDraft,
                                                                        onNonImageFiles: (files) => {
                                                                            setEditCommentAttachments((prev) => [...prev, ...files]);
                                                                        },
                                                                    });
                                                                }}
                                                            >
                                                                <Tooltip
                                                                    title={
                                                                        gptAdjustingComment
                                                                            ? 'Orby está digitando...'
                                                                            : 'Ajustar texto (Orby) — Ctrl+Shift+G'
                                                                    }
                                                                    placement="top"
                                                                    arrow
                                                                >
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={handleAdjustEditingCommentWithGpt}
                                                                        disabled={savingCommentEdit || gptAdjustingComment}
                                                                        sx={{
                                                                            position: 'absolute',
                                                                            top: 6,
                                                                            right: 6,
                                                                            zIndex: 5,
                                                                            border: '1px solid',
                                                                            borderColor: 'divider',
                                                                            borderRadius: 2,
                                                                            p: 0.75,
                                                                            bgcolor: 'background.paper',
                                                                            '&:hover': { bgcolor: 'action.hover' },
                                                                        }}
                                                                        aria-label={gptAdjustingComment ? 'Orby está digitando' : 'Ajustar texto com Orby'}
                                                                    >
                                                                        <OrbyInlineIcon loading={gptAdjustingComment} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <ReactQuill
                                                                    key={`edit-comment-${editingCommentId}`}
                                                                    ref={editCommentQuillRef}
                                                                    value={editCommentDraft}
                                                                    onChange={(valor, delta, origem) => {
                                                                        setEditCommentDraft(valor);
                                                                        if (origem === 'user') marcarQueEstouEditando();
                                                                    }}
                                                                    modules={modules}
                                                                    formats={quillFormats}
                                                                    placeholder="Editar texto da ação"
                                                                />
                                                                <QuillImageResizer
                                                                    quillRef={editCommentQuillRef}
                                                                    onCommit={setEditCommentDraft}
                                                                    disabled={gptAdjustingComment}
                                                                />
                                                                <MacroKeywordSuggest
                                                                    quillRef={editCommentQuillRef}
                                                                    value={editCommentDraft}
                                                                    macros={macros}
                                                                    disabled={gptAdjustingComment}
                                                                    onApply={(macro) => {
                                                                        const { messageBody } = extractMacroMessageEffects(macro.actions, ticketData);
                                                                        setEditCommentDraft(messageBody || '');
                                                                    }}
                                                                />
                                                                <OrbyTypingOverlay show={gptAdjustingComment} />
                                                            </Box>
                                                            <input
                                                                type="file"
                                                                ref={editFileInputRef}
                                                                multiple
                                                                accept={aceitosNoSeletor(politicaDeAnexos) || undefined}
                                                                style={{ display: 'none' }}
                                                                onChange={(e) => {
                                                                    const files = e.target.files ? Array.from(e.target.files) : [];
                                                                    setEditCommentAttachments((prev) => [...prev, ...conferirAnexos(files)]);
                                                                    e.target.value = '';
                                                                }}
                                                            />
                                                            {Array.isArray(item.attachments) &&
                                                                item.attachments.filter((att) => att?.path && !editRemovedAttachmentPaths.includes(att.path)).length > 0 && (
                                                                <Box sx={{ mt: 1 }}>
                                                                    <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5 }}>
                                                                        Anexos salvos
                                                                    </Typography>
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
                                                                        {item.attachments
                                                                            .filter((att) => att?.path && !editRemovedAttachmentPaths.includes(att.path))
                                                                            .map((att, idx) => (
                                                                                <Chip
                                                                                    key={`edit-existing-att-${idx}-${att.path}`}
                                                                                    size="small"
                                                                                    variant="outlined"
                                                                                    label={att.original_name || att.path}
                                                                                    onDelete={() =>
                                                                                        setEditRemovedAttachmentPaths((prev) =>
                                                                                            prev.includes(att.path) ? prev : [...prev, att.path]
                                                                                        )
                                                                                    }
                                                                                    disabled={savingCommentEdit}
                                                                                    sx={{ maxWidth: 200 }}
                                                                                />
                                                                            ))}
                                                                    </Box>
                                                                </Box>
                                                            )}
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 1, flexWrap: 'wrap' }}>
                                                                <Tooltip title={tituloDoBotaoDeAnexo()} placement="top" arrow>
                                                                    <Button
                                                                        size="small"
                                                                        startIcon={<AttachFile />}
                                                                        onClick={() => editFileInputRef.current?.click()}
                                                                        disabled={savingCommentEdit}
                                                                        sx={{ textTransform: 'none' }}
                                                                    >
                                                                        Anexar arquivos
                                                                    </Button>
                                                                </Tooltip>
                                                                {editCommentAttachments.length > 0 && (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
                                                                        {editCommentAttachments.map((file, idx) => (
                                                                            <Chip
                                                                                key={`edit-att-${idx}-${file.name}`}
                                                                                size="small"
                                                                                label={file.name}
                                                                                onDelete={() =>
                                                                                    setEditCommentAttachments((prev) =>
                                                                                        prev.filter((_, i) => i !== idx)
                                                                                    )
                                                                                }
                                                                                sx={{ maxWidth: 180 }}
                                                                            />
                                                                        ))}
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                            <Box
                                                                onKeyDownCapture={(e) => {
                                                                    const isShortcut =
                                                                        e.ctrlKey &&
                                                                        e.shiftKey &&
                                                                        String(e.key || '').toLowerCase() === 'g';
                                                                    if (isShortcut) {
                                                                        e.preventDefault();
                                                                        handleAdjustEditingCommentWithGpt();
                                                                    }
                                                                }}
                                                                sx={{ display: 'flex', gap: 1, mt: 1.5, flexWrap: 'wrap' }}
                                                            >
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={handleSaveCommentEdit}
                                                                    disabled={savingCommentEdit}
                                                                    sx={{ textTransform: 'none', fontWeight: 600 }}
                                                                >
                                                                    Salvar
                                                                </Button>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setEditingCommentId(null);
                                                                        setEditCommentDraft('');
                                                                        setEditCommentAttachments([]);
                                                                        setEditRemovedAttachmentPaths([]);
                                                                    }}
                                                                    disabled={savingCommentEdit}
                                                                    sx={{ textTransform: 'none', fontWeight: 600 }}
                                                                >
                                                                    Cancelar
                                                                </Button>
                                                            </Box>
                                                        </>
                                                    ) : (item.comment || '').includes('Transcrição de chat (importada do Movidesk)') ? (
                                                        <ChatTranscript text={item.comment} />
                                                    ) : (
                                                        <SanitizeHTML htmlContent={item.comment} onImageClick={handleCommentImageClick} />
                                                    )}
                                                </Box>
                                                {item.attachments && item.attachments.length > 0 && (
                                                    <Box sx={{ marginTop: 1.25, display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                                                        {item.attachments.map((att, idx) => {
                                                            const isFromApi = typeof att.path === 'string';
                                                            const name = isFromApi ? (att.original_name || att.path) : (att.name || `Arquivo ${idx + 1}`);
                                                            const handleDownload = isFromApi ? () => {
                                                                http.get(`/ticket/comments/file?path=${encodeURIComponent(att.path)}`, { responseType: 'blob' })
                                                                    .then(res => {
                                                                        const blob = res.data;
                                                                        const url = URL.createObjectURL(blob);
                                                                        const link = document.createElement('a');
                                                                        link.href = url;
                                                                        link.download = att.original_name || name;
                                                                        link.click();
                                                                        URL.revokeObjectURL(url);
                                                                    })
                                                                    .catch(err => toast.error('Erro ao baixar arquivo'));
                                                            } : undefined;
                                                            const isImage = isFromApi && /\.(jpg|jpeg|png|gif|webp)$/i.test(att.original_name || '');
                                                            const isPdf = isFromApi && /\.pdf$/i.test(att.original_name || '');
                                                            const isTxt = isFromApi && /\.txt$/i.test(att.original_name || '');
                                                            const canPreview = isFromApi && (isImage || isPdf || isTxt);
                                                            const handleOpenPreview = canPreview ? () => {
                                                                http.get(`/ticket/comments/file?path=${encodeURIComponent(att.path)}`, { responseType: 'blob' })
                                                                    .then(res => {
                                                                        const blob = res.data;
                                                                        const mimeType = blob.type || (isPdf ? 'application/pdf' : isTxt ? 'text/plain' : 'image/webp');
                                                                        const file = new File([blob], att.original_name || name, { type: mimeType });
                                                                        setPreviewFile(file);
                                                                        setPreviewOpen(true);
                                                                    })
                                                                    .catch(() => toast.error('Erro ao abrir arquivo'));
                                                            } : undefined;
                                                            return (
                                                                <Box key={idx}>
                                                                    {isFromApi && (isImage || isPdf || isTxt) ? (
                                                                        <Button
                                                                            size="small"
                                                                            startIcon={isImage ? <Image /> : <InsertDriveFile />}
                                                                            onClick={handleOpenPreview}
                                                                            sx={{ textTransform: 'none' }}
                                                                        >
                                                                            {name}
                                                                        </Button>
                                                                    ) : isFromApi ? (
                                                                        <Button
                                                                            size="small"
                                                                            startIcon={att.original_name && /\.(mp3|ogg|wav|webm)$/i.test(att.original_name) ? <Audiotrack /> : <InsertDriveFile />}
                                                                            onClick={handleDownload}
                                                                            sx={{ textTransform: 'none' }}
                                                                        >
                                                                            {name}
                                                                        </Button>
                                                                    ) : (
                                                                        <Chip size="small" icon={<InsertDriveFile />} label={name} variant="outlined" sx={{ maxWidth: 180 }} />
                                                                    )}
                                                                </Box>
                                                            );
                                                        })}
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                            );
                                        })()
                                    ) : item.type === 'attendance' ? (
                                        <Box key={item.id} sx={{
                                            position: 'relative',
                                            marginBottom: 1.25,
                                            paddingLeft: 6.5,
                                            zIndex: 2,
                                        }}>
                                            <Box sx={{
                                                position: 'absolute',
                                                left: -3,
                                                top: 6,
                                                width: 6,
                                                height: 6,
                                                borderRadius: '50%',
                                                backgroundColor: item.is_active
                                                    ? theme.palette.success.main
                                                    : theme.palette.primary.main,
                                                zIndex: 3,
                                            }} />
                                            <Box sx={{
                                                backgroundColor: theme.palette.background.paper,
                                                borderRadius: 2,
                                                padding: 1.25,
                                                border: `1px solid ${theme.palette.divider}`,
                                                borderLeft: `4px solid ${item.is_active ? theme.palette.success.main : theme.palette.primary.main}`,
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexWrap: 'wrap' }}>
                                                    <Typography sx={{ color: 'text.secondary', fontSize: '11px', minWidth: '60px' }}>
                                                        {formatDate(item.created_at)}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ fontSize: '13px', flex: 1, fontWeight: 600 }}>
                                                        {item.is_active
                                                            ? `${item.user_name} — atendimento em andamento`
                                                            : `${item.user_name} — ${formatAttendanceDuration(item.duration_seconds)} de atendimento`}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box key={item.id} sx={{
                                            position: 'relative',
                                            marginBottom: 1.25,
                                            paddingLeft: 6.5,
                                            zIndex: 2
                                        }}>
                                            {/* Indicador verde na timeline */}
                                            <Box sx={{
                                                position: 'absolute',
                                                left: -3,
                                                top: 6,
                                                width: 6,
                                                height: 6,
                                                borderRadius: '50%',
                                                backgroundColor: theme.palette.success.main,
                                                zIndex: 3
                                            }} />

                                            {/* Item com fundo igual aos comentários */}
                                            <Box sx={{
                                                backgroundColor: theme.palette.background.paper,
                                                borderRadius: 2,
                                                padding: 1.25,
                                                border: `1px solid ${theme.palette.divider}`,
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                            }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                                                    {/* Ícone dentro da caixa */}
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: 24,
                                                        height: 24,
                                                        borderRadius: '50%',
                                                        backgroundColor: theme.palette.success.light,
                                                        color: theme.palette.success.contrastText
                                                    }}>
                                                        {item.users && item.users.length > 0 && item.users[0].user ? (
                                                            <Avatar
                                                                src={item.users[0].user.picture}
                                                                sx={{
                                                                    width: 20,
                                                                    height: 20,
                                                                    fontSize: '8px'
                                                                }}
                                                            >
                                                                {item.users[0].user.name.split(' ').map(n => n[0]).join('').toUpperCase()}
                                                            </Avatar>
                                                        ) : (
                                                            // Quem alterou foi o SISTEMA, e não uma pessoa: aqui
                                                            // não há iniciais para pôr no avatar. Sem tamanho --
                                                            // `AppThemeGlobalStyles` força 1.1rem em todo ícone
                                                            // com `!important`.
                                                            <SettingsOutlinedIcon />
                                                        )}
                                                    </Box>

                                                    {/* Nome de quem fez a alteração ao lado do ícone */}
                                                    <Typography sx={{
                                                        color: theme.palette.text.secondary,
                                                        fontSize: '11px',
                                                        fontStyle: 'italic'
                                                    }}>
                                                        {item.users && item.users.length > 0 && item.users[0].user
                                                            ? item.users[0].user.name
                                                            : 'Sistema'
                                                        }
                                                    </Typography>

                                                    <Typography sx={{
                                                        color: theme.palette.text.secondary,
                                                        fontSize: '11px',
                                                        minWidth: '60px'
                                                    }}>
                                                        {formatDate(item.created_at)}
                                                    </Typography>

                                                    <Typography variant="body2" sx={{
                                                        color: theme.palette.text.primary,
                                                        fontSize: '13px',
                                                        flex: 1
                                                    }}>
                                                        {item.action_description}
                                                    </Typography>
                                                </Box>

                                                {/* Detalhes das mudanças (se houver) */}
                                                {item.old_values && item.new_values && typeof item.new_values === 'object' && (
                                                    <Box sx={{ marginTop: 1, marginLeft: 6 }}>
                                                        {Object.keys(item.new_values || {}).map(key => {
                                                            // Traduzir nomes dos campos
                                                            const fieldTranslations = {
                                                                'category': 'Categoria',
                                                                'service_id': 'Serviço',
                                                                // Sem esta linha o histórico mostraria a chave
                                                                // crua "service_group_id" ao lado dos campos
                                                                // traduzidos.
                                                                'service_group_id': 'Departamento responsável',
                                                                'status': 'Status',
                                                                'client': 'Cliente',
                                                                'assigned_to': 'Responsável',
                                                                'priority': 'Prioridade',
                                                                'title': 'Título',
                                                                'contact': 'Contato',
                                                                'channel': 'Canal',
                                                                'is_internal': 'Tipo de Ticket',
                                                                'solution_due_at': 'Previsão de solução (SLA)'
                                                            };

                                                            const translatedKey = fieldTranslations[key] || key;

                                                            // Função para formatar valores específicos
                                                            const formatValue = (value, fieldKey) => {
                                                                if (value === null || value === undefined) {
                                                                    return 'Não definido';
                                                                }

                                                                switch (fieldKey) {
                                                                    case 'status': {
                                                                        const statusMap = { 0: 'Fechado', 1: 'Aberto', 2: 'Pendente', 3: 'Resolvido', 4: 'Cancelado' };
                                                                        const num = Number(value);
                                                                        return statusMap[num] ?? value;
                                                                    }

                                                                    case 'priority':
                                                                        const priorityMap = { 0: 'Baixa', 1: 'Média', 2: 'Alta', 3: 'Urgente' };
                                                                        return priorityMap[value] || value;

                                                                    case 'assigned_to':
                                                                        // Tentar encontrar o nome do operador nos dados de auditoria
                                                                        if (typeof value === 'number' || /^\d+$/.test(value)) {
                                                                            // Procurar o operador nos dados de auditoria (qualquer tipo)
                                                                            const user = item.users?.find(u => u.user?.id === value);
                                                                            if (user?.user?.name) {
                                                                                return user.user.name;
                                                                            }

                                                                            // Se não encontrar, tentar buscar na lista de operadores do sistema
                                                                            const systemUser = users?.find(u => u.id === value);
                                                                            if (systemUser?.name) {
                                                                                return systemUser.name;
                                                                            }

                                                                            return `Operador #${value}`;
                                                                        }
                                                                        return value;

                                                                    case 'is_internal':
                                                                        return value ? 'Interno' : 'Público';

                                                                    case 'solution_due_at':
                                                                        if (!value) return 'Não definido';
                                                                        try {
                                                                            return new Date(value).toLocaleString('pt-BR');
                                                                        } catch {
                                                                            return String(value);
                                                                        }

                                                                    default:
                                                                        return value;
                                                                }
                                                            };

                                                            const oldValue = formatValue(item.old_values[key], key);
                                                            const newValue = formatValue(item.new_values[key], key);

                                                            return (
                                                                <Typography key={key} sx={{
                                                                    color: theme.palette.text.secondary,
                                                                    fontSize: '11px',
                                                                    display: 'block',
                                                                    marginTop: 0.5
                                                                }}>
                                                                    <strong>{translatedKey}:</strong> {oldValue} → {newValue}
                                                                </Typography>
                                                            );
                                                        })}
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    )
                                ))}
                            </Box>
                        </Box>
                    ) : !isNewTicket ? (
                        <Box sx={{
                            flex: 1,
                            textAlign: 'center',
                            padding: 4,
                            color: theme.palette.text.secondary
                        }}>
                            <Typography variant="body1">
                                Nenhuma ação encontrada para este ticket
                            </Typography>
                        </Box>
                    ) : reminderChecklistHtml ? (
                        // Item 15: checklist pré-definido no lugar do skeleton das ações
                        // (só ticket novo). É um guia visual — não é salvo; a ação real
                        // vai na caixa de ação (que fica vazia).
                        <Box sx={{ flex: 1, p: 1 }}>
                            <Box sx={{
                                p: 2,
                                borderRadius: 1,
                                border: `1px dashed ${theme.palette.divider}`,
                                backgroundColor: alpha(theme.palette.warning.main, 0.07),
                                color: theme.palette.text.secondary,
                                fontSize: '0.85rem',
                                '& p': { margin: 0, marginBottom: 1 },
                                '& ul': { margin: 0, paddingLeft: '1.25rem' },
                                '& li': { marginBottom: '0.35rem' },
                            }}>
                                <Box dangerouslySetInnerHTML={{ __html: sanitizeHtml(reminderChecklistHtml) }} />
                            </Box>
                        </Box>
                    ) : (
                        <Box sx={{ flex: 1 }}>
                            <CommentSkeletons />
                        </Box>
                    )}
                </Box>
            </Box>

            <Dialog
                open={previewOpen}
                onClose={() => { setPreviewOpen(false); setPreviewFile(null); }}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    sx: {
                        bgcolor: 'transparent',
                        boxShadow: 'none',
                        overflow: 'visible',
                        maxWidth: '95vw',
                    },
                }}
            >
                {previewFile && (
                    <FilePreview
                        selectedFile={previewFile}
                        setSelectedFile={() => { setPreviewOpen(false); setPreviewFile(null); }}
                        isChat={false}
                    />
                )}
            </Dialog>

            {/* Fechar chamado de OUTRO agente: de quem ele fica?
                Os dois caminhos são legítimos (pedido da Gisele), por isso é
                pergunta e não regra. Fechar o modal sem escolher CANCELA o
                fechamento -- escolher por omissão seria decidir pela pessoa
                justamente na tela que existe para ela decidir. */}
            <Dialog
                open={Boolean(assumirPendente)}
                onClose={() => setAssumirPendente(null)}
                maxWidth="xs"
                fullWidth
                data-testid="modal-assumir-ticket"
            >
                <DialogContent sx={{ pt: 3 }}>
                    <Typography variant="body1">
                        Esse ticket está atribuído a outro agente. Deseja assumi-lo para você?
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1.5 }}>
                        Em “Não”, o ticket é fechado mantendo o responsável atual.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={() => aplicarPendenteDeAssumir(false)} sx={{ textTransform: 'none' }}>
                        Não
                    </Button>
                    <Button
                        onClick={() => aplicarPendenteDeAssumir(true)}
                        variant="contained"
                        color="success"
                        sx={{ textTransform: 'none' }}
                    >
                        Sim
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={Boolean(createdTicketInfo)}
                onClose={handleSuccessGoToTicket}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                        border: `1px solid ${theme.palette.divider}`,
                        overflow: 'hidden',
                    },
                }}
            >
                <Box sx={{ padding: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginBottom: 2.5 }}>
                        <Box
                            sx={{
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                backgroundColor: 'rgba(76, 175, 80, 0.15)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                            }}
                        >
                            <CheckCircleOutlineIcon sx={{ color: 'success.main' }} />
                        </Box>
                        <Typography variant="h6" sx={{ fontWeight: 600, color: theme.palette.text.primary, lineHeight: 1.2 }}>
                            Seu ticket foi registrado com sucesso!
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 1.5, rowGap: 0.75, marginBottom: 3 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: theme.palette.text.primary }}>Ticket:</Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                            <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>#{createdTicketInfo?.number}</Typography>
                            {/*
                              * Copiar o link AQUI, junto do número (item 6 do Daniel):
                              * é neste instante que o operador tem o chamado na mão e
                              * precisa mandá-lo a alguém. Depois de fechar o aviso,
                              * restaria copiar da barra de endereços.
                              */}
                            <Button
                                onClick={copiarLinkDoChamadoCriado}
                                size="small"
                                startIcon={<ContentCopyIcon />}
                                sx={{ textTransform: 'none', fontWeight: 500, minHeight: 0, py: 0.25, px: 1 }}
                            >
                                Copiar link
                            </Button>
                        </Box>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: theme.palette.text.primary }}>Assunto:</Typography>
                        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>{createdTicketInfo?.title || '—'}</Typography>
                        {createdTicketInfo?.solution_due_at && (
                            <>
                                <Typography variant="body2" sx={{ fontWeight: 700, color: theme.palette.text.primary }}>Previsão de solução:</Typography>
                                <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                                    {new Date(createdTicketInfo.solution_due_at).toLocaleString('pt-BR', { dateStyle: 'long', timeStyle: 'short' })}
                                </Typography>
                            </>
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                        <Button
                            onClick={handleSuccessNewTicket}
                            variant="outlined"
                            size="small"
                            sx={{ textTransform: 'none', fontWeight: 500, borderRadius: 2, px: 2 }}
                        >
                            Novo ticket
                        </Button>
                        <Button
                            onClick={handleSuccessGoToTicket}
                            variant="outlined"
                            size="small"
                            sx={{ textTransform: 'none', fontWeight: 500, borderRadius: 2, px: 2 }}
                        >
                            Continuar editando
                        </Button>
                        <Button
                            onClick={handleSuccessGoToTicket}
                            variant="contained"
                            color="success"
                            size="small"
                            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: 2, px: 3 }}
                        >
                            OK
                        </Button>
                    </Box>
                </Box>
            </Dialog>

            <Dialog
                open={showTypeChangeModal}
                onClose={cancelTypeChange}
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                        border: `1px solid ${theme.palette.divider}`,
                        overflow: 'hidden'
                    }
                }}
            >
                <Box sx={{ padding: 3 }}>
                    {/* Ícone e título */}
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        marginBottom: 2
                    }}>
                        <Box sx={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            backgroundColor: theme.palette.warning.light,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: theme.palette.warning.contrastText
                        }}>
                            <WarningAmberOutlinedIcon />
                        </Box>
                        <Typography variant="h6" sx={{
                            fontWeight: 600,
                            color: theme.palette.text.primary
                        }}>
                            Confirmar alteração
                        </Typography>
                    </Box>

                    {/* Mensagem */}
                    <Typography variant="body2" sx={{
                        color: theme.palette.text.secondary,
                        lineHeight: 1.3,
                        marginBottom: 3
                    }}>
                        {pendingTypeChange
                            ? "Tem certeza que deseja transformar esse ticket em interno? Ele não será mais exibido para o cliente."
                            : "Tem certeza que deseja transformar esse ticket em público? Ele será exibido para o cliente."
                        }
                    </Typography>

                    {/* Botões */}
                    <Box sx={{
                        display: 'flex',
                        gap: 1.5,
                        justifyContent: 'flex-end'
                    }}>
                        <Button
                            onClick={cancelTypeChange}
                            variant="text"
                            size="small"
                            sx={{
                                color: theme.palette.text.secondary,
                                textTransform: 'none',
                                fontWeight: 500,
                                '&:hover': {
                                    backgroundColor: theme.palette.action.hover
                                }
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={confirmTypeChange}
                            variant="contained"
                            size="small"
                            sx={{
                                backgroundColor: theme.palette.primary.main,
                                color: theme.palette.primary.contrastText,
                                textTransform: 'none',
                                fontWeight: 500,
                                borderRadius: 2,
                                px: 2,
                                '&:hover': {
                                    backgroundColor: theme.palette.primary.dark
                                }
                            }}
                        >
                            Confirmar
                        </Button>
                    </Box>
                </Box>
            </Dialog>

            <Dialog
                open={mergeModalOpen}
                onClose={handleCloseMergeModal}
                maxWidth="sm"
                fullWidth
            >
                <Box sx={{ p: 2.5 }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                        Mesclar tickets
                    </Typography>
                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
                        Escolha o ticket a ser mesclado com este e defina qual ficará como principal.
                    </Typography>

                    <Autocomplete
                        noOptionsText={
                            mergeLoadingOptions
                                ? 'Buscando...'
                                : `Digite ao menos ${MIN_CARACTERES} caracteres do número ou do assunto`
                        }
                        loading={mergeLoadingOptions}
                        options={mergeCandidates}
                        // `filterOptions` identidade: quem filtra é o servidor.
                        // Sem isto o MUI filtraria de novo, no navegador, sobre
                        // o que a busca já devolveu -- e descartaria o chamado
                        // que casou por um campo que o rótulo não mostra.
                        filterOptions={(x) => x}
                        value={mergeTargetTicket}
                        onChange={(event, newValue) => setMergeTargetTicket(newValue)}
                        onInputChange={(event, termo, motivo) => {
                            if (motivo === 'input') {
                                buscarChamadosParaSelecao(termo, setMergeCandidates, setMergeLoadingOptions);
                            }
                        }}
                        getOptionLabel={(option) => `#${option.number} - ${option.title || 'Sem título'}`}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Ticket para mesclar"
                                size="small"
                                placeholder="Buscar por # ou título..."
                            />
                        )}
                        isOptionEqualToValue={(option, value) => Number(option.id) === Number(value?.id)}
                    />

                    <Typography variant="body2" sx={{ mt: 2, mb: 0.5, fontWeight: 600 }}>
                        Ticket principal após a mesclagem
                    </Typography>
                    <RadioGroup value={mergePrimaryChoice} onChange={(e) => setMergePrimaryChoice(e.target.value)}>
                        <FormControlLabel
                            value="current"
                            control={<Radio size="small" />}
                            label={`Manter atual como principal (#${ticketData?.number})`}
                        />
                        <FormControlLabel
                            value="target"
                            control={<Radio size="small" />}
                            label={`Manter selecionado como principal${mergeTargetTicket?.number != null ? ` (#${mergeTargetTicket.number})` : ''}`}
                            disabled={!mergeTargetTicket}
                        />
                    </RadioGroup>

                    <FormControlLabel
                        sx={{ mt: 0.5 }}
                        control={(
                            <Checkbox
                                size="small"
                                checked={rememberMergeChoice}
                                onChange={(e) => setRememberMergeChoice(e.target.checked)}
                            />
                        )}
                        label="Usar esta opção como padrão nas próximas mesclagens"
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
                        <Button onClick={handleCloseMergeModal}>Cancelar</Button>
                        <Button
                            onClick={handleConfirmMerge}
                            variant="contained"
                            disabled={!mergeTargetTicket || mergeSaving}
                        >
                            {mergeSaving ? 'Mesclando...' : 'Confirmar mesclagem'}
                        </Button>
                    </Box>
                </Box>
            </Dialog>

            <Dialog
                open={emailDialogOpen}
                onClose={() => !sendingEmail && setEmailDialogOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <EmailOutlinedIcon color="primary" fontSize="small" />
                    Enviar e-mail
                </DialogTitle>
                <DialogContent dividers>
                    <TextField
                        label="Para"
                        type="email"
                        fullWidth
                        size="small"
                        value={emailForm.to}
                        onChange={(e) => setEmailForm((p) => ({ ...p, to: e.target.value }))}
                        placeholder="cliente@empresa.com"
                        sx={{ mb: 2 }}
                        autoFocus
                    />
                    <TextField
                        label="CC (opcional)"
                        fullWidth
                        size="small"
                        value={emailForm.cc}
                        onChange={(e) => setEmailForm((p) => ({ ...p, cc: e.target.value }))}
                        placeholder="Separe vários e-mails por vírgula"
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Assunto"
                        fullWidth
                        size="small"
                        value={emailForm.subject}
                        onChange={(e) => setEmailForm((p) => ({ ...p, subject: e.target.value }))}
                        sx={{ mb: 2 }}
                    />
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                        Mensagem
                    </Typography>
                    <Box sx={{ '& .ql-container': { minHeight: 140 } }}>
                        <ReactQuill
                            theme="snow"
                            value={emailForm.body}
                            onChange={(html) => setEmailForm((p) => ({ ...p, body: html }))}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEmailDialogOpen(false)} disabled={sendingEmail}>
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSendEmail}
                        disabled={sendingEmail}
                        startIcon={sendingEmail ? <CircularProgress size={16} color="inherit" /> : <EmailOutlinedIcon />}
                    >
                        {sendingEmail ? 'Enviando...' : 'Enviar'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={reuseAttachModalOpen} onClose={() => setReuseAttachModalOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <InsertDriveFile fontSize="small" />
                    Reutilizar anexos do ticket
                </DialogTitle>
                <DialogContent dividers>
                    {existingTicketAttachments.length === 0 ? (
                        <Typography variant="body2" color="text.secondary">
                            Nenhum anexo salvo neste ticket.
                        </Typography>
                    ) : (
                        <>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                                Selecione um ou mais anexos já adicionados em outras ações para incluir nesta ação.
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                {existingTicketAttachments.map((a) => (
                                    <FormControlLabel
                                        key={a.path}
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={reuseSelectedPaths.has(a.path)}
                                                onChange={() => toggleReusePath(a.path)}
                                            />
                                        }
                                        label={
                                            <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                {a.original_name}
                                            </Typography>
                                        }
                                    />
                                ))}
                            </Box>
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setReuseAttachModalOpen(false)}>Cancelar</Button>
                    <Button
                        variant="contained"
                        onClick={confirmReuseAttachments}
                        disabled={existingTicketAttachments.length === 0}
                    >
                        Incluir selecionados
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={phonesDialog.open} onClose={() => !savingPhones && setPhonesDialog({ open: false, companyId: null })} maxWidth="xs" fullWidth>
                <DialogTitle>Telefones adicionais</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 1.5 }}>
                        Cadastre os telefones extras desta empresa.
                    </Typography>
                    {(phonesDraft.length ? phonesDraft : [emptyPhone()]).map((ph, idx) => (
                        <Box
                            key={idx}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 0.5,
                                mb: 1.5,
                                pb: 1.5,
                                borderBottom: `1px solid ${theme.palette.divider}`,
                                '&:last-of-type': { borderBottom: 'none', pb: 0 },
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <TextField
                                    size="small"
                                    placeholder="Nome"
                                    value={ph.name || ''}
                                    onChange={(e) => updatePhoneDraft(idx, { name: e.target.value })}
                                    sx={{ width: '42%' }}
                                />
                                <TextField
                                    size="small"
                                    placeholder="(11) 99999-0000"
                                    value={ph.phone || ''}
                                    onChange={(e) => updatePhoneDraft(idx, { phone: e.target.value })}
                                    sx={{ flex: 1 }}
                                />
                                <Tooltip title="Remover" arrow>
                                    <IconButton size="small" onClick={() => {
                                        const next = (phonesDraft.length ? phonesDraft : [emptyPhone()]).filter((_, i) => i !== idx);
                                        setPhonesDraft(next.length ? next : [emptyPhone()]);
                                    }}>
                                        <CloseOutlined sx={{ fontSize: 18 }} />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <TextField
                                size="small"
                                placeholder="Observação (ex.: WhatsApp, gerente, balconista, farmacêutico)"
                                value={ph.note || ''}
                                onChange={(e) => updatePhoneDraft(idx, { note: e.target.value })}
                                inputProps={{ maxLength: 120 }}
                                sx={{ mr: 4.5 }}
                            />
                        </Box>
                    ))}
                    <Button size="small" startIcon={<Add />} onClick={() => setPhonesDraft([...(phonesDraft.length ? phonesDraft : [emptyPhone()]), emptyPhone()])} sx={{ textTransform: 'none', mt: 0.5 }}>
                        Adicionar telefone
                    </Button>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setPhonesDialog({ open: false, companyId: null })} color="inherit" disabled={savingPhones}>Cancelar</Button>
                    <Button onClick={savePhones} variant="contained" disabled={savingPhones}>{savingPhones ? 'Salvando...' : 'Salvar'}</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={contactDialog.open} onClose={() => !savingContact && setContactDialog({ open: false })} maxWidth="xs" fullWidth>
                <DialogTitle>Novo contato</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 1.5 }}>
                        Cadastre um contato atrelado ao registro.
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 0.5 }}>
                        {(() => {
                            const companies = getTicketCompanies();
                            // Seletor de registro so aparece se houver mais de um registro
                            // atrelado ao ticket; com um so, mostra apenas o rotulo.
                            if (companies.length <= 1) {
                                const only = companies[0];
                                return only ? (
                                    <Typography variant="body2" sx={{ fontSize: '0.82rem', color: theme.palette.text.primary }}>
                                        Registro: <strong>{only.label}</strong>
                                    </Typography>
                                ) : null;
                            }
                            return (
                                <Box>
                                    <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block', mb: 0.5 }}>
                                        Registro
                                    </Typography>
                                    <Select
                                        size="small"
                                        fullWidth
                                        value={contactDraft.companyId || ''}
                                        onChange={(e) => setContactDraft((d) => ({ ...d, companyId: e.target.value }))}
                                    >
                                        {companies.map((c) => (
                                            <MenuItem key={c.id} value={c.id}>{c.label}</MenuItem>
                                        ))}
                                    </Select>
                                </Box>
                            );
                        })()}
                        <TextField
                            size="small"
                            label="Nome"
                            required
                            value={contactDraft.name}
                            onChange={(e) => setContactDraft((d) => ({ ...d, name: e.target.value }))}
                            inputProps={{ maxLength: 255 }}
                        />
                        {/*
                          Sem campo de e-mail, a pedido da Gisele (item 2): o e-mail
                          e do CLIENTE, nao do contato. Ele continua existindo la e
                          continua sendo de onde sai o destinatario da resposta por
                          e-mail (`guessTicketEmail`).
                        */}
                        <TextField
                            size="small"
                            label="Telefone/WhatsApp"
                            placeholder="(11) 99999-0000"
                            value={contactDraft.whatsapp}
                            onChange={(e) => setContactDraft((d) => ({ ...d, whatsapp: e.target.value }))}
                            inputProps={{ maxLength: 40 }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setContactDialog({ open: false })} color="inherit" disabled={savingContact}>Cancelar</Button>
                    <Button onClick={saveContact} variant="contained" disabled={savingContact}>{savingContact ? 'Salvando...' : 'Salvar'}</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

const mapStateToProps = state => {
    const { user, field, tickets } = state;
    const { currentUser, users, permissions } = user;
    const { fields } = field;
    const { viewedTickets } = tickets;

    return { currentUser, users, fields, viewedTickets, permissions };
};

const mapDispatchToProps = dispatch => ({
    editTicket: ticket => dispatch(editTicket(ticket)),
    createTicket: ticket => dispatch(createTicket(ticket)),
    fetchTickets: () => dispatch(fetchTickets()),
    setViewedTickets: tickets => dispatch(setViewedTickets(tickets)),
    getUsers: () => dispatch(getUsers()),
    notifyNewTicketAssigned: (ticketId, ticketTitle, assignedToUserId, createdByName) => dispatch(notifyNewTicketAssigned(ticketId, ticketTitle, assignedToUserId, createdByName)),
    notifyTicketUpdated: (ticketId, ticketTitle, updatedBy, changes, notifyUserIds) => dispatch(notifyTicketUpdated(ticketId, ticketTitle, updatedBy, changes, notifyUserIds))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TicketDetails));